/* Up selectコンシェルジュ ─ 振り分けと答えの組み立て（ブラウザ側）

   ⚠️ ここは route.py と**同じ答えを出さないといけない**。
      規則（正規表現）は upc-kb.js に焼き込んだものを使う＝手で写さない。
      文面が食い違っていないことは parity.py が毎回突き合わせる。
*/
(function () {
  'use strict';
  var KB = window.UPC_KB;
  if (!KB) return;

  var GREEN = '🟢', AMBER = '🟡', RED = '🔴';

  /* ── 書き方のゆれを、当てる前に一つの言い方へ寄せる ──────────────
     ⚠️ 寄せ方の正本は route.READ_AS。ここは upc-kb.js に焼き込まれたものを使う
        （手で写さない）。同じ結果になることは variant_check と parity が見る。
     ⚠️ 日本語のあいだの空白だけ詰める。英字のまわりは残す（「au PAY」を壊さない） */
  var JP_SPACE = /([^\x00-\x7F])[ 　]+(?=[^\x00-\x7F])/g;

  /* ★**否定されたほうの言葉に当てない**（260902・route._NEGATED と同じ）。
     「法事ではなく食事会に着る服」の「法事」が礼服の受け口に当たって、
     **「礼服のお取り扱いはございません」**と答えていた。
     ⚠️ 落とすのは**否定された語だけ**。文の残りはそのまま当てる */
  var NEGATED = /[^、。\s]{1,12}?(?:ではなく|じゃなく|ではありません|以外)/g;

  function normInput(s) {
    /* ★商品名の頭の【…】は売り文句であって、お尋ねではない（260809・Take）。
       外すと当たりがきれいになる＝「【アイロン、もう要らない】…」でお手入れに落ちない */
    s = (s || '').normalize('NFKC').replace(/【[^】]{0,24}】/g, '')
                 .replace(NEGATED, '')
                 .replace(JP_SPACE, '$1');
    var ra = KB.readAs || [];
    for (var i = 0; i < ra.length; i++) s = s.split(ra[i][0]).join(ra[i][1]);
    return s;
  }

  function detect(text) {
    text = normInput(text);
    for (var i = 0; i < KB.intents.length; i++) {
      var name = KB.intents[i][0], pat = KB.intents[i][1];
      if (new RegExp(pat).test(text)) return name;
    }
    return 'unknown';
  }

  function patternOf(name) {
    for (var i = 0; i < KB.intents.length; i++) {
      if (KB.intents[i][0] === name) return KB.intents[i][1];
    }
    return null;
  }

  /* ── サイズを推す ────────────────────────────────────────
     ⚠️ 吹き出しには up のロゴが付く＝**お店の言葉として読まれる**。
        推すときは必ず「数字の根拠」と「合わなければ交換できます」を添える。
        根拠が無いときは推さない（聞き返す）。 */
  /* ⚠️ **Sが抜けていた**（260810）。カーディガンは S/M/L/LL/3L の5展開 */
  var SIZES = ['3L', 'LL', 'L', 'M', 'S'];

  function usualSize(text) {
    /* ⚠️「サイズはMです」が読めていなかった（260809・slot_sim が検出） */
    var m = text.match(/(?:いつも|普段|ふだん|通常)[^。]{0,8}?(3L|LL|L|M|S)/);
    if (m) return m[1];
    m = text.match(/(3L|LL|L|M|S)\s*サイズ/);
    if (m) return m[1];
    m = text.match(/サイズ(?:は|が|＝|=)\s*(3L|LL|L|M|S)(?![A-Za-z])/);
    return m ? m[1] : null;
  }
  function heightOf(text) {
    var m = text.match(/(1[4-8]\d)\s*(?:cm|センチ|ｾﾝﾁ)/);
    return m ? parseInt(m[1], 10) : null;
  }
  function cutOf(fit) {
    if (fit.indexOf('ゆったり') >= 0 || fit.indexOf('大きめ') >= 0) return 'ゆったり';
    if (fit.indexOf('小さめ') >= 0 || fit.indexOf('細め') >= 0
        || fit.indexOf('タイト') >= 0) return '小さめ';
    return '標準';
  }
  function esc(s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }

  /* サイズ表の適応範囲「(64~70)」「106(79~87)」。**ここに言われた実寸を当てる** */
  var RANGE = /[(（](\d{2,3})\s*[~～ー－-]\s*(\d{2,3})[)）]/;
  var MEASURE_KEYS = ['ウエスト', 'ヒップ', 'バスト'];

  function toldMeasures(text) {
    var out = {}, any = false;
    MEASURE_KEYS.forEach(function (k) {
      var m = text.match(new RegExp(k + '[^0-9]{0,6}(\\d{2,3})'));
      if (m) { out[k] = parseInt(m[1], 10); any = true; }
    });
    return any ? out : null;
  }

  /* ⚠️ 260807の事故＝**ウエスト72cmの方に適応64〜70のMを「大丈夫」と言い切っていた**
        （身長からスタッフの着用を借りていた）。言われた数字があるなら、それが最優先 */
  function byMeasure(prod, text) {
    var want = toldMeasures(text);
    if (!want) return null;
    var fits = [], near = [];
    prod.v.forEach(function (v) {
      var used = [];
      (v.z || []).forEach(function (kv) {
        var key = String(kv[0]).split('(')[0];
        if (!(key in want)) return;
        var rg = RANGE.exec(String(kv[1]));
        if (rg) used.push([key, parseInt(rg[1], 10), parseInt(rg[2], 10)]);
      });
      if (!used.length) return;
      var ok = used.every(function (u) { return u[1] <= want[u[0]] && want[u[0]] <= u[2]; });
      if (ok) { fits.push([v, used]); return; }
      var over = 0;
      used.forEach(function (u) {
        var d = want[u[0]] > u[2] ? want[u[0]] - u[2] : u[1] - want[u[0]];
        if (d > over) over = d;
      });
      near.push([over, v, used]);
    });
    var pack = function (v, used, outside) {
      var s = v.t.match(/(3L|LL|L|M|S)/);
      var why = used.map(function (u) { return u[0] + u[1] + '〜' + u[2] + 'cm'; }).join('／');
      var told = Object.keys(want).filter(function (k) {
        return used.some(function (u) { return u[0] === k; });
      }).map(function (k) { return k + want[k] + 'cm'; }).join('／');
      return {size: s ? s[1] : null, by: 'お伺いした実寸', why: why,
              told: told, outside: outside};
    };
    if (fits.length) return pack(fits[0][0], fits[0][1], false);
    if (near.length) {
      near.sort(function (a, b) { return a[0] - b[0]; });
      return pack(near[0][1], near[0][2], true);
    }
    return null;
  }

  /* 品切れのサイズについて、**予約できるかどうかを在庫の状態から言う**。
     ⚠️ 260807に実画面で測った＝**納期メタが付いていても予約できるとは限らない**。
        在庫0のSKU13件はすべて「売り切れ」で、予約できるものは0件だった */
  /* 納期マスターの文字から、お客様への言い方を作る。**「月」を含むかの1点**で分ける
     ＝テーマ（delivery_leadtime）と同じ物差し。**ここを二重に持たない** */
  function deliverSay(when) {
    if (!when) return '';
    return when.indexOf('月') >= 0 ? ('お届けは' + when + 'の予定です。')
                                   : (when + 'に発送の予定です。');
  }
  /* その商品が**まるごと在庫0でも、ご予約でお求めいただける**ときの一言（短い形）。
     ⚠️ サイズを名指しする restockNote と使い分ける */
  function preorderNote(prod) {
    var when = '';
    (prod.v || []).forEach(function (v) {
      if (!when && canBuy(v) && v.dl) when = v.dl;
    });
    /* ⚠️ ★**「在庫を切らしています」と言わない**（260909 Take「9/9新商品は在庫
       切らしてますが、は要らない。どうせ明日には入荷される」）。お客様に要るのは
       「買えるか」と「いつ来るか」だけで、こちらの在庫の事情ではない */
    return 'ご予約を承っています。' + deliverSay(when);
  }
  /* ★**作り置きの接客トーク**（talk/{handle}.json → kb → ここ）。無ければ空 */
  function talkOf(prod) { return (prod && prod.talk) || {}; }
  /* その一枚の一言。トーク → 見出しの言い換え → 商品名、の順に落とす。
     ⚠️ トークがあるときは toTalk を呼ばない（「んです」が2回になる） */
  function talkHook(prod) {
    var t = talkOf(prod).hook;
    if (t) return String(t);
    var head = (prod.head || prod.t.replace(/【.*?】/g, '')).trim();
    return toTalk(head) || (prod.t + 'をご覧いただいていますね。');
  }

  function restockNote(soldout, dl) {
    var can = soldout.filter(function (v) { return v.b; });
    if (can.length) {
      var when = '';
      can.forEach(function (v) { if (!when && v.dl) when = v.dl; });
      if (!when) when = dl || '';
      var head = can.slice(0, 3).map(function (v) { return v.t; }).join('／');
      return head + 'は、ご予約いただけます。' + deliverSay(when);
    }
    return 'いまはご予約もお受けできないのですが、入荷の予定が決まると'
         + '商品ページに「◯月◯日入荷予定」と出て、そのときは先にご注文いただけます。';
  }

  /* ── 店として持っていないもの（260807にTakeへ確認して確定）──────────
     ⚠️ FAQにもガイドにも書かれていない。**憶測でなく、聞いて決まったこと**なので
        「分かりかねます」ではなく言い切る。書き換えるときは必ず人に確かめてから */
  var NO_INFO = [
    {words: ['ラッピング', '包装紙', 'ギフト包装', 'ギフトカード'],
     intent: 'ラッピングについて', lead: 'ラッピングは承っておりません。',
     body: ['贈り物としてお届けする場合も、通常のお包みでのお届けになります。']},
    {words: ['のし', '熨斗'],
     intent: 'のしについて', lead: 'のしはお付けしておりません。',
     body: ['贈り物としてお届けする場合も、通常のお包みでのお届けになります。']},
    {words: ['裾上げ', '丈詰め', 'お直し', '寸法直し'],
     intent: '裾上げ・お直しについて', lead: '裾上げやお直しは承っておりません。',
     body: ['丈が選べる商品もございますので、よろしければお出しします。'],
     acts: [['丈のあるものを見る', 'ask', 'パンツを探しています']]},
    {words: ['取り置き', '取置', 'お取り置'],
     intent: 'お取り置きについて', lead: 'お取り置きは承っておりません。',
     body: ['在庫はこの画面でご覧いただけるぶんがすべてです。'],
     acts: [['合う一枚を選んで', 'ask', '似合うものを見せてください']]},
    {words: ['カタログ', '冊子', '通販誌'],
     intent: 'カタログについて', lead: '紙のカタログはございません。',
     body: ['Up selectはオンラインだけのお店で、お品はこの画面でご覧いただけます。'],
     acts: [['合う一枚を選んで', 'ask', '似合うものを見せてください']]},
    {words: ['セール', '値下げ', 'バーゲン', '割引はいつ'],
     intent: 'セールについて', lead: 'セールの予定は、お答えしていないんです。',
     body: ['いまお使いいただけるものでしたら、LINEのご登録で送料無料のクーポンを'
            + 'お受け取りいただけます。商品ページのボタンからお進みください。']},
    {words: ['電話'],
     intent: 'お電話でのご注文について', lead: 'お電話でのご注文は承っておりません。',
     body: ['ご注文はこの画面から、ご相談は下のフォームかメールで承ります。'],
     acts: [['メールで知らせる', 'mail', 'up_support@halmek.co.jp']],
     form: 'ご相談があります。'},
    {words: ['入荷'],   /* ＝入荷の「お知らせ」。入荷そのものは restock が答える */
     intent: '入荷のお知らせについて', lead: '入荷のお知らせはお送りしていないんです。',
     body: ['入荷の予定があるものは、商品ページに「◯月◯日入荷予定」と出ます。'
            + 'そのときは品切れの表示でも、先にご注文いただけます。',
            '表示のないものは、いまのところ入荷の予定がございません。']},
    {words: ['明細書', '納品書'],
     intent: '明細書について', lead: 'お包みの中身については、スタッフがお答えします。',
     body: ['贈り物としてお送りするときのことでしたら、下のフォームから'
            + 'お知らせください。'],
     form: '贈り物として送りたいのですが、金額のわかるものを抜いていただけますか。'},
    /* 260810＝`wild_sim`33件の精査で確定（Take確認済み）。
       ⚠️ 男性ものは、贈り物より先に当てる。「旦那さんへの誕生日プレゼント」は
          贈り物の体で聞かれても、答えるべきは「紳士ものが無い」ほう */
    /* ⚠️「息子」だけだと「息子の彼女に」まで紳士もの扱いになる（260809） */
    {words: ['旦那', '夫', '主人', '息子に', '息子へ', '息子の分',
             '男性', 'メンズ', '紳士'],
     intent: '紳士もの・男性ものについて', lead: '紳士もののお取り扱いはございません。',
     body: ['女性もののお洋服だけをそろえたお店なんです。'],
     acts: [['合う一枚を選んで', 'ask', '似合うものを見せてください']]},
    {words: ['母', '娘', '孫', '義母', '友人', 'プレゼント', '贈り物', 'ギフト'],
     intent: '贈り物について', lead: '贈り物にも、お選びいただけます。',
     body: ['お相手のふだんのサイズが分かれば、そこからお出しします。',
            'ラッピングとのしは承っておりませんので、通常のお包みでのお届けになります。'],
     acts: [['合う一枚を選んで', 'ask', '似合うものを見せてください'],
            ['サイズを選ぶ', 'ask', 'サイズはどれがいいですか']]}
  ];

  /* 身長からは**丈だけ**を案内する。太さ（サイズ）は決めない */
  function inseamHint(prod, text) {
    var h = heightOf(text);
    if (!h) return null;
    var cands = (prod.staffs || []).filter(function (x) { return x[2]; });
    if (!cands.length) return null;
    var near = cands.reduce(function (a, b) {
      return Math.abs(b[0] - h) < Math.abs(a[0] - h) ? b : a;
    });
    var lens = {};
    prod.v.forEach(function (v) {
      var m = v.t.match(/股下\d{2}/);
      if (m) lens[m[0]] = 1;
    });
    return {near: near, lens: Object.keys(lens).sort()};
  }

  function recommend(prod, text, wantColor, wantSize) {
    var meas = byMeasure(prod, text);
    if (meas && meas.outside) {
      return {size: meas.size, variant: null, fit: '', alt: [],
              same: false, near: null, meas: meas};
    }
    /* ★②【選ぶ】の言葉（「M～Lにします」）は usualSize では読めない。
       ⚠️ ここを見ないと rec が null になり、**選んだのに「ふだんのサイズを
          教えてください」に落ちる**（260810・Take） */
    var usual = meas ? meas.size : (usualSize(text) || wantSize || ''), near = null;
    if (!usual) return null;
    var fit = cutOf(prod.fit || '');
    var want = usual;
    if (fit === '小さめ') {
      var i = SIZES.indexOf(usual);
      want = i > 0 ? SIZES[i - 1] : usual;
    }
    var inseam = text.match(/股下\s*(\d{2})/);
    /* ⚠️ **幅のあるサイズ（M～L）にも当てる**（260810）。文字どおりの一致で書いて
       いたため、ワッシャーで「いつもMサイズです」と答えても1つも当たらず、
       **もう一度サイズを伺い直していた**（Take「同じ応答が二回続く」）。
       ★`hasSize` を作ったのに、**この呼び出し口を直していなかった** */
    var cands = prod.v.filter(function (v) {
      return hasSize(v, want) && (!inseam || v.t.indexOf('股下' + inseam[1]) >= 0);
    });
    var live = cands.filter(function (v) { return (v.s || 0) > 0; });
    /* ★そのサイズの**ご用意そのものが無い**とき。null を返すと上の分岐が
       「ふだんお召しのサイズを教えてください」に落ちて、同じ聞き返しになる */
    if (!cands.length && !live.length) {
      return {size: want, variant: null, fit: fit, alt: [], none: true,
              same: want === usual, near: near, meas: meas};
    }
    if (!live.length) {
      var alt = prod.v.filter(function (v) { return (v.s || 0) > 0; }).slice(0, 3);
      /* ⚠️ out ＝**言われたサイズの、品切れの現物**。alt（ほかに在庫のあるもの）が
         空でも、予約できるかどうかはこちらから言える（260909） */
      return {size: want, variant: null, fit: fit, alt: alt, out: cands,
              same: want === usual, near: near, meas: meas};
    }
    /* ★もう色を伺っているなら、**その色のもの**でお答えする（260810） */
    if (wantColor) {
      var same = live.filter(function (v) {
        return v.t.split(/\s*\/\s*/).pop().trim() === wantColor;
      });
      if (same.length) live = same;
    }
    return {size: want, variant: live[0], fit: fit, alt: [],
            same: want === usual, near: near, meas: meas};
  }

  /* 本文に出てくる商品を当てる。SKUがいちばん強い、次に商品名の一部 */
  function findProduct(text) {
    /* ⚠️ 名前・SKUで当てるときは**絞る前の店ぜんぶ**を見る（route.all_products と同じ）。
       コレクションの面で、その面に無い商品を名指しされても答えられるように */
    var pool = allProducts();
    var m = text.match(/(HU\d{5})/);
    if (m) {
      for (var i = 0; i < pool.length; i++) {
        var p = pool[i];
        for (var j = 0; j < p.v.length; j++) {
          if ((p.v[j].sku || '').indexOf(m[1]) === 0) return p;
        }
      }
    }
    /* ⚠️ **何点にも当たる言葉では、商品を名指しされたとみなさない**（260902）。
       「コットンのプルオーバーはありますか」の「コットン」は5点の名前に入るのに、
       先に見つけた1点（汗対策コットンTシャツ）の話にして答え切っていた。
       決めきれないときは黙って選ばず、探すほうへ渡す（そちらは名前で並べ替える）。
       ⚠️ 前後に漢字が1〜2字くっつくところまでを1語にする＝「デニム」と「デニム調」、
          「レースコットンシャツ」と「肩レース／袖レースコットンシャツ」を分けるため */
    /* ★商品名が**丸ごと**書かれていたら、それが一番強い（260902・route.find_product と同じ）。
       ⚠️ こちらが出した丸は「<商品名>はどんな商品ですか」を送るのに、下の語ごとの当たりは
          **カタカナの塊**しか見ないので、仮名で切れる名前（シアー重ね着**風**ノースリーブ）が
          決まらない。決まらないと名前の中の言葉に用件を奪われる */
    var whole = null;
    for (var w = 0; w < pool.length; w++) {
      var wc = titleCore(pool[w]).trim();
      if (wc.length >= 6 && text.indexOf(wc) >= 0
          && (!whole || wc.length > titleCore(whole).trim().length)) whole = pool[w];
    }
    if (whole) return whole;
    var best = null, bestN = 0;
    for (var k = 0; k < pool.length; k++) {
      var pr = pool[k];
      var toks = titleCore(pr).match(/[一-龥]{0,2}[ァ-ヴー]{3,}[一-龥]{0,2}/g) || [];
      var n = 0;
      for (var t = 0; t < toks.length; t++) {
        if (text.indexOf(toks[t]) < 0) continue;
        var seen = 0;
        for (var q = 0; q < pool.length; q++) {
          if (titleCore(pool[q]).indexOf(toks[t]) >= 0) seen++;
        }
        if (seen === 1) n += toks[t].length;
      }
      if (n > bestN) { best = pr; bestN = n; }
    }
    return best;
  }

  /* 本文に出てくる商品を**全部**拾う（比べたいときに要る） */
  function namedProducts(text) {
    return allProducts().filter(function (p) {
      var toks = p.t.replace(/【.*?】/g, '').match(/[ァ-ヴー]{4,}/g) || [];
      return toks.some(function (t) { return text.indexOf(t) >= 0; });
    });
  }

  /* ── 探すための手がかり（route.py の TAG_WORDS と同じ）───────── */
  var TAG_WORDS = [
    ['二の腕カバー', ['二の腕', '腕を隠', '袖あり']],
    /* ⚠️「カバー」を手がかりにすると「二の腕カバー」と必ず二重に当たる */
    ['体型カバー', ['体型', 'お腹', 'ヒップ', 'ぽっこり', 'ラインを拾', '腰まわり',
                '腰回り', '太って', 'ぽっちゃり', '体形']],
    ['汗・暑さ対策', ['汗', '暑', '涼し', '夏', '冷感']],
    /* 出かける先から探す人が多い。**タグに橋渡しできるものだけ** */
    ['きちんと見え', ['きちんと', '通勤', 'オフィス', 'きれいめ', '上品', '仕事',
                 '同窓会', '食事会', 'お出かけ', '観劇', '会食', '会社']],
    ['一枚で決まる', ['一枚', '1枚', '楽に決ま']],
    /* ⚠️ 「羽織」は**季節に紐づけない**（260902）。`夏の羽織り` に入れていたので、
       9月に「羽織りものはありますか」で**「冷房よけですね」**と答えていた */
    ['夏の羽織り', ['冷房', 'クーラー']],
    ['羽織り・ジャケット', ['羽織', 'ジャケット', 'カーディガン', 'ブルゾン']],
    ['リネン・コットン', ['リネン', 'コットン', '麻', '綿']]
  ];

  /* ⚠️「涼しくなってきた」は**気温の話**で、涼しい服のご要望ではない（260902）。
     9/2の秋物発売日に「涼しくなってきたので羽織れるものが欲しい」へ「汗・暑さ対策」を
     当てて、**「ございません」と言い切ってから夏物**を出していた */
  function wantedTags(text) {
    var t = (text || '').replace(/涼しくな[っりるら]/g, '');
    return TAG_WORDS.filter(function (x) {
      return x[1].some(function (w) { return t.indexOf(w) >= 0; });
    }).map(function (x) { return x[0]; });
  }
  function tagWordsOf(tag) {
    for (var i = 0; i < TAG_WORDS.length; i++) {
      if (TAG_WORDS[i][0] === tag) return TAG_WORDS[i][1];
    }
    return [];
  }

  /* ── 何を探しているか（品種）。⚠️「涼しいパンツ」にブラウスを出さない ── */
  var GARMENT = [
    ['パンツ', ['パンツ', 'ぱんつ', 'ボトム', 'ズボン', 'デニム']],
    ['スカート', ['スカート']],
    ['ジャケット', ['ジャケット', '羽織', 'カーディガン', 'ブルゾン']],
    ['ワンピース', ['ワンピース', 'ワンピ']],
    ['ブラウス', ['ブラウス', 'シャツ']],
    ['トップス', ['トップス', 'プルオーバー', 'カットソー', 'Tシャツ']],
    /* ★ここから下は、いまのところお店に無い品目（route.GARMENT と1語ずつ同じ）。
       品種として受けるだけ＝商品名に1点も無ければ「いまございません」と言い切る */
    ['コート', ['コート', 'アウター', 'ダウン']],
    ['ニット', ['ニット', 'セーター']],
    ['インナー', ['インナー', '肌着', '下着', 'キャミソール', 'タンクトップ']],
    ['ルームウェア', ['ルームウェア', 'パジャマ', '部屋着']],
    ['レギンス', ['レギンス', 'タイツ', 'ストッキング', '靴下', 'ソックス']],
    ['くつ', ['くつ', '靴', 'シューズ', 'パンプス', 'スニーカー', 'サンダル']],
    ['バッグ', ['バッグ', 'かばん', '鞄', '財布']],
    ['帽子', ['帽子', 'ハット', 'キャップ']],
    ['アクセサリー', ['アクセサリー', 'ネックレス', 'イヤリング', 'ピアス',
                      '指輪', 'ブレスレット', '腕時計', 'スカーフ', 'ストール',
                      'ベルト', '手袋', '傘']],
    ['和装', ['着物', '浴衣', '振袖', '袴']],
    ['水着', ['水着', 'スイム']],
    ['礼服', ['喪服', '礼服', 'ブラックフォーマル']],
    /* 260810＝`wild_sim`で拾った（Take確認済み・1点も無い） */
    ['エプロン', ['エプロン', '割烹着']]
  ];
  var GARMENT_IN_TITLE = {
    'パンツ': ['パンツ', 'デニム'],
    'スカート': ['スカート'],
    'ジャケット': ['ジャケット', 'カーディガン', 'ブルゾン', '羽織'],
    'ワンピース': ['ワンピース'],
    'ブラウス': ['ブラウス', 'シャツ'],
    'トップス': ['トップス', 'プルオーバー', 'カットソー', 'ノースリーブ'],
    /* ⚠️ route._GARMENT_IN_TITLE と1語ずつ同じ。商品名に当たりが無ければ「ございません」 */
    'コート': ['コート', 'ダウン'],
    'ニット': ['ニット', 'セーター'],
    'インナー': ['インナー', '肌着', 'キャミソール', 'タンクトップ'],
    'ルームウェア': ['ルームウェア', 'パジャマ'],
    'レギンス': ['レギンス', 'タイツ', '靴下'],
    'くつ': ['シューズ', 'パンプス', 'スニーカー', 'サンダル'],
    'バッグ': ['バッグ', '財布'],
    '帽子': ['帽子', 'ハット'],
    'アクセサリー': ['ネックレス', 'イヤリング', 'ピアス', 'ストール',
                     'スカーフ', 'ベルト', '手袋'],
    '和装': ['着物', '浴衣'],
    '水着': ['水着'],
    '礼服': ['喪服', '礼服'],
    'エプロン': ['エプロン', '割烹着']
  };
  /* ★装い以外のお話（route.CHAT と1行ずつ同じ）。受け止めて、装いへ1つ戻す */
  var CHAT = [
    {words: ['あなたは誰', 'あなたって誰', 'あなたの名前', 'お名前は', '名前は',
             'AIなの', 'AIですか', 'ロボット', '人間が', '人間なの', '人間ですか',
             '感情', '何歳', 'あなたって', 'あなたは'],
     intent: 'お店の係のこと',
     lead: 'Up selectの、自動でお答えする係です。',
     body: ['商品ページとよくあるご質問に書いてあることから、その場でお答えしています。',
            '私で分からないことは、スタッフにお渡しできますよ。'],
     acts: [['合う一枚を選んで', 'ask', '似合うものを見せてください'],
            ['スタッフに聞く', 'form', '']]},
    {words: ['疲れ', 'つかれ', '眠く', 'ねむい', 'しんど', 'だるい'],
     intent: 'ひと息つかれている',
     lead: 'どうぞ、ごゆっくりなさってくださいね。',
     body: ['気が向いたときに、お手伝いします。'],
     acts: [['合う一枚を選んで', 'ask', '似合うものを見せてください']]},
    {words: ['褒めて', 'ほめて', '励まし'],
     intent: '励ましのお申し出',
     lead: '今日もおつかれさまです。',
     body: ['似合う一枚が見つかると、出かけるのが少し楽しみになりますよ。'],
     acts: [['合う一枚を選んで', 'ask', '似合うものを見せてください'],
            ['似合う色から', 'ask', 'カラー診断をお願いします']]},
    {words: ['値引き', 'まけて', '安くして', 'もっと安く', '安いですよ', '安いです'],
     intent: 'お値引きのお申し出',
     lead: 'お値引きは承っておりません。',
     body: ['LINEにご登録いただくと、送料が無料になるクーポンをお受け取りいただけます。'],
     acts: [['合う一枚を選んで', 'ask', '似合うものを見せてください']]},
    {words: [],
     intent: '装い以外のお話',
     lead: 'そのお話は、私にはお答えできないんです。',
     body: ['お洋服のことでしたら、なんでもどうぞ。'],
     acts: [['合う一枚を選んで', 'ask', '似合うものを見せてください'],
            ['人気のものを見る', 'ask', '人気のものはどれですか']]}
  ];

  /* ★お店にある色の名前を、バリアントから機械で集める（route.shop_colors と同じ）。
     長いものから見る＝「オフホワイト」を「シロ」より先に当てるため */
  function shopColors() {
    var out = {};
    (KB.products || []).forEach(function (p) {
      colorList(p).forEach(function (c) { if (c[0]) out[c[0]] = 1; });
    });
    return Object.keys(out).sort(function (a, b) { return b.length - a.length; });
  }
  var COLOR_ASK = '.{0,4}(あり|在庫|ほし|欲し|できま|にしま|がいい|ください|でお願い|は？|は?$)';
  /* ⚠️ 振り分けの語を手で書いていたせいで、**こちらが出した色の丸**（オフホワイト・
     オリーブ…）を押しても色の答えにならず、場面のお伺いに落ちていた（260809） */
  /* ★お客様が口にされた色を、**在庫の色名から**当てる（言い方は問わない）。
     ⚠️ 手で書いた28色の regex だけを見ていたので、**新しく入った色を受けられない**。
        260902の発売5点で入った ラズベリー／ボルドー／ブラウン がそれで、色の丸を
        押しても**同じ答えが返る輪**になっていた。色は商品が増えるたびに増える。
     ⚠️ 手書きのほうは捨てない＝「黒」「白」「紺」「ピンク系」など、在庫の表記に
        無いふだんの呼び方はこちらでしか拾えない */
  function saidColor(text) {
    var t = text || '', cs = shopColors(), i;
    for (i = 0; i < cs.length; i++) {
      if (t.indexOf(cs[i]) >= 0) return cs[i];
    }
    var cw = (KB.cdx || {}).colorWord;
    var m = cw ? t.match(new RegExp(cw)) : null;
    return m ? ((KB.colorAlias || {})[m[1]] || m[1]) : '';
  }

  function namedColor(text) {
    var t = text || '';
    var cs = shopColors();
    for (var i = 0; i < cs.length; i++) {
      var c = cs[i];
      if (t.indexOf(c) >= 0
          && new RegExp(c.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + COLOR_ASK).test(t)) {
        return c;
      }
    }
    return '';
  }

  /* ★品種を当てるときの商品名＝**【…】を外したもの**（route.title_core と同じ）。
     ⚠️ 外さないと「【ネックレス要らず…】…トップス」が「ネックレスは？」に当たって、
        売っていないものを出す（260809） */
  function titleCore(p) { return (p.t || '').replace(/【.*?】/g, ''); }

  /* ★聞かれた言葉が**名前や紹介文に入っているもの**を先にお出しする（260902）。
     ⚠️ **絞り込みではなく並べ替え**。「ございません」と言い切る道は一切通らない。
     ⚠️ これが無かったので、9/2発売の5点は名前で聞かれても出てこなかった＝
        「フリルのブラウスはありますか」に夏のブラウス3点。品種で15点に当たっては
        いるのに、先頭3点が入れ替わらないので画面には出ない。
     ⚠️ 3字未満のカタカナ・1字の漢字は採らない（「色」「服」が何にでも当たる）。
        「デニム調」のようにカタカナ＋漢字で1語になるものは続けて1語で採る */
  var NAME_TOKEN = /[ァ-ヴー]{3,}[一-龥]{0,2}|[ァ-ヴー]{2,}[一-龥]{1,2}|[一-龥]{2,}/g;

  function nameWords(text) { return (text || '').match(NAME_TOKEN) || []; }

  /* 当てにいく先＝商品名（【】ごと）と、紹介文の見出し・要点・魅力。
     ⚠️ Python側（route.name_hay）と同じ材料・同じ切り方。違うと parity が落ちる */
  function nameHay(p) {
    return [p.t || '', p.head || '', (p.pts || []).join(' '), p.appeal || ''].join(' ');
  }

  function byNameFirst(ps, text) {
    var ws = nameWords(text);
    if (!ws.length) return ps;
    var sc = ps.map(function (p) {
      var hay = nameHay(p), n = 0;
      ws.forEach(function (w) { if (hay.indexOf(w) >= 0) n += w.length; });
      return n;
    });
    if (!sc.some(function (n) { return n > 0; })) return ps;
    return ps.map(function (p, i) { return [p, sc[i], i]; })
      .sort(function (a, b) { return (b[1] - a[1]) || (a[2] - b[2]); })
      .map(function (x) { return x[0]; });
  }

  /* ★新しく入ったもの＝**「新着アイテム」の面に並んでいるもの**（260902）。
     ⚠️ タグ `new_arrival` は使わない。6/17発売の5点に付いたまま更新されていない */
  var NEW_COLL = 'new-arrivals';
  var SOLD_ON = /^(\d{2})(\d{2})(\d{2})発売$/;

  /* ★Up select オリジナル＝**「オリジナル」の面に並んでいるもの**（260902）。
     ⚠️ 商品側に PB を表す vendor もタグも無い。見分けはこの面の所属だけ。
     ⚠️ ライン名は使ってよい。禁じられているのは**素材**を「オリジナル素材」と呼ぶこと */
  var ORIG_COLL = 'originals';

  /* **いまお出しできる商品か**。＝在庫がある、または**予約でお求めいただける**。
     ⚠️ 260909に踏んだ。ここを (p.s||0)>0 だけで見ていたので、**発売当日で在庫が
        まだ0の3点**（レース切替3WAYブラウス／シアー切替ジレ／プリントワンピース
        ＝いずれもPB）が**コンシェルジュから丸ごと消え**、店頭は普通に売っているのに
        「ワンピースはありますか」へ**「いまございません」と言い切っていた**。
     ★分かれ目は在庫の点数ではなく Shopify の availableForSale（＝v.b）。
     ⚠️ **毎週5点が在庫0で発売される**ので、これは毎週再発する */
  /* そのバリアントを**お求めいただけるか**＝在庫がある、または**予約できる**。
     ★物差しは Shopify の availableForSale（＝v.b）。在庫の点数から推し量らない。
     ⚠️ カートに入れる一歩だけは別＝そこは在庫のあるものだけ */
  function canBuy(v) { return (v.s || 0) > 0 || !!v.b; }

  function sellable(p) {
    if ((p.s || 0) > 0) return true;
    return (p.v || []).some(canBuy);
  }

  function collItems(handle) {
    var cs = KB.collections || [], coll = null, i;
    for (i = 0; i < cs.length; i++) { if (cs[i].h === handle) coll = cs[i]; }
    if (!coll) return [];
    return (coll.p || []).map(byHandle).filter(function (p) {
      return p && sellable(p);
    });
  }

  function newArrivals() { return collItems(NEW_COLL); }

  /* Up select オリジナル。**今季のものを先に**（発売日タグの新しい順） */
  function originalsList() {
    function day(p) {
      var got = (p.tags || []).filter(function (t) { return SOLD_ON.test(t); });
      return got.length ? got.sort()[got.length - 1] : '';
    }
    return collItems(ORIG_COLL).slice().sort(function (x, y) {
      var dx = day(x), dy = day(y);
      return dx === dy ? 0 : (dx < dy ? 1 : -1);
    });
  }

  /* 発売日を「9月2日」の形で。**全部そろって同じ日のときだけ**言う（推測しない） */
  function arrivalDay(ps) {
    var days = {};
    ps.forEach(function (p) {
      (p.tags || []).forEach(function (t) { if (SOLD_ON.test(t)) days[t] = 1; });
    });
    var ks = Object.keys(days);
    if (ks.length !== 1) return '';
    var m = ks[0].match(SOLD_ON);
    return parseInt(m[2], 10) + '月' + parseInt(m[3], 10) + '日';
  }

  /* 品種を1つ当てる。**同じ文に2つ出てきたら、うしろに出たほう**を採る（260902）。
     ⚠️ 日本語は探しているもの（主名詞）がうしろに来る。「デニム調のブラウス」の
        「デニム」は形容であって品種ではない。並び順の先勝ちにしていたので
        「パンツ」が勝ち、**デニム調ギャザーブラウスにパンツを7点出していた** */
  function wantedGarment(text) {
    var best = '', at = -1;
    for (var i = 0; i < GARMENT.length; i++) {
      for (var j = 0; j < GARMENT[i][1].length; j++) {
        var k = (text || '').lastIndexOf(GARMENT[i][1][j]);
        if (k > at) { best = GARMENT[i][0]; at = k; }
      }
    }
    return best;
  }

  /* 「1万円くらい」＝**予算で絞れないと買い物にならない** */
  function budgetOf(text) {
    if (!/予算|以内|くらい|ぐらい|まで|以下/.test(text)) return null;
    var m = text.match(/(\d+(?:[,.]\d+)?)\s*万円/);
    if (m) return Math.round(parseFloat(m[1].replace(/,/g, '')) * 10000);
    m = text.match(/(\d[\d,]{2,6})\s*円/);
    return m ? parseInt(m[1].replace(/,/g, ''), 10) : null;
  }

  /* ── FAQの設問を、聞かれた言葉に近いもので選ぶ ──────────────
     ⚠️ 260807の事故＝**並び順の先頭で選んでいた**。「領収書はもらえますか」に
        「注文後に支払い方法を変更できますか？」の答えを出典つきで断定していた */
  var SYN = [['代引き', '代金引換'], ['代引', '代金引換'], ['後払い', 'あと払い'],
             ['あとばらい', 'あと払い'], ['カード払い', 'クレジットカード'],
             ['振込み', '銀行振込'], ['振り込み', '銀行振込'], ['分割', 'お支払い回数']];
  function normSyn(s) {
    SYN.forEach(function (p) { s = s.split(p[0]).join(p[1]); });
    return s;
  }
  var KANJI = /[一-龥ァ-ヴA-Za-z]/;
  function grams(s) {
    s = (s || '').replace(/[\s、。？?！!「」（）()・]/g, '');
    var out = {};
    for (var i = 0; i < s.length - 1; i++) out[s.substr(i, 2)] = 1;
    return out;
  }
  function kgrams(s) {
    var g = grams(s), out = {};
    Object.keys(g).forEach(function (k) {
      if (KANJI.test(k[0]) && KANJI.test(k[1])) out[k] = 1;
    });
    return out;
  }
  function common(a, b) {
    var n = 0;
    Object.keys(a).forEach(function (k) { if (b[k]) n++; });
    return n;
  }
  function bestFaq(text, pat) {
    var re = pat ? new RegExp(pat) : null;
    var cands = KB.faq.filter(function (f) { return !re || re.test(f.q); });
    if (!cands.length) return null;
    var t = normSyn(text), tg = grams(t), tk = kgrams(t);
    var score = function (f) {
      return 2 * common(tk, kgrams(f.q)) + common(tg, grams(f.q))
           + common(tk, kgrams(f.a));
    };
    var best = cands[0], bs = score(cands[0]);
    cands.forEach(function (f) { var v = score(f); if (v > bs) { best = f; bs = v; } });
    return bs ? best : cands[0];
  }
  function faqAnswer(text, pat, label) {
    var f = bestFaq(text, pat);
    if (!f) return null;
    var parts = f.a.split('。').filter(function (s) { return s.trim(); });
    var a = A(GREEN, label);
    a.lead = parts[0] + '。';
    a.body = parts.length > 1 ? [parts.slice(1).join('。') + '。'] : [];
    a.sources = ['よくあるご質問「' + f.q + '」'];
    return a;
  }

  /* ── 着たときの心配ごと。**書いてあることだけ答える** ────────── */
  var FEEL_MAP = [
    ['透け感', ['透け', 'すけま']],
    ['生地の厚さ', ['厚み', '厚い', '薄い', '厚さ']],
    ['伸縮性', ['伸び', '伸縮']],
    ['光沢', ['光沢', 'つや', 'テカ']]
  ];
  /* 商品ページに書かれていないもの。**推し量って言わない** */
  var FEEL_UNKNOWN = [
    ['シワになりにくいか', ['シワ', 'しわ']],
    ['重さ', ['重い', '重く', '重さ', '軽い']],
    ['肌ざわり', ['チクチク', 'ちくち', '肌が弱', 'かゆ', '敏感肌']],
    ['静電気', ['静電気']],
    ['毛玉', ['毛玉']],
    ['色落ち', ['色落ち', '色移り']],
    ['におい', ['におい', '匂い']]
  ];
  function radarMap(prod) {
    var out = {}, keys = [];
    ((prod.radar || '').match(/"([^"]+)"/g) || []).forEach(function (x) {
      var s = x.replace(/"/g, '');
      var i = s.indexOf('｜');
      if (i > 0) { out[s.slice(0, i).trim()] = s.slice(i + 1).trim();
                   keys.push(s.slice(0, i).trim()); }
    });
    out.__keys = keys;
    return out;
  }
  function radarPairs(rm, skip) {
    return rm.__keys.filter(function (k) { return k !== skip; })
      .map(function (k) { return k + '｜' + rm[k]; });
  }

  /* ★見立てを**文にして**返す（260902・Take「かたい」）。
     ⚠️ 「透け感｜あり／光沢｜なし／生地の厚さ｜薄手／伸縮性｜あり／シルエット｜ゆったり」は
        機械の書き方。**2つまで**にして「〜は〜」でつなぐ */
  function radarSay(rm, skip, n) {
    return rm.__keys.filter(function (k) { return k !== skip; })
      .slice(0, n || 2)
      .map(function (k) { return k + 'は' + rm[k]; })
      .join('、');
  }

  function listField(v) {
    if (!v) return [];
    return (v || []).map(function (x) { return String(x).trim(); })
      .filter(function (x) { return x; });
  }
  function colorList(prod) {
    var cs = [], at = {};
    prod.v.forEach(function (v) {
      var c = v.t.split(/\s*\/\s*/).pop().trim();
      if (!c) return;
      if (!(c in at)) { at[c] = cs.length; cs.push([c, 0]); }
      cs[at[c]][1] += Math.max(0, v.s || 0) || (canBuy(v) ? 1 : 0);
    });
    return cs;
  }
  /* 色ごとに、実物の写真を1枚ずつ（画面用。**色は言葉より写真が早い**）
     ⚠️ route.color_cards と同じ形。2か所で書くとどちらかが静かに古くなる */
  function colorCards(prod) {
    var cc = {}, order = [];
    prod.v.forEach(function (v) {
      var c = v.t.split(/\s*\/\s*/).pop().trim();
      if (!c) return;
      /* ⚠️ 写真1枚ごとに**その商品への入口**を付ける（260809・Take） */
      /* ★**どんな色かを一言添える**（260909・Take「合うカラーが二択でしょぼい」）。
         色名だけでは「オフホワイトはまっ白ですか」に答えられない */
      if (!cc[c]) {
        cc[c] = {name: c, stock: 0, img: '', h: prod.h,
                 say: String((talkOf(prod).colors || {})[c] || ''),
                 hex: colorHex(c), ask: ''};
        order.push(c);
      }
      cc[c].stock += Math.max(0, v.s || 0) || (canBuy(v) ? 1 : 0);
      if (!cc[c].img && v.img) cc[c].img = v.img;
    });
    return order.map(function (c) { return cc[c]; });
  }
  function sizeLine(prod) {
    var cs = colorList(prod);
    var seen = {}, sizes = [];
    prod.v.forEach(function (v) {
      var m = v.t.match(/(3L|LL|L|M|S)/);
      if (m && !seen[m[1]]) { seen[m[1]] = 1; sizes.push(m[1]); }
    });
    sizes.sort(function (a, b) { return SIZES.indexOf(a) - SIZES.indexOf(b); });
    return yen(prod.p) + '円で、' + cs.length + '色'
         + (sizes.length ? '・' + sizes.join('／') : '') + 'のご用意です。';
  }

  /* さっきお出しした商品を、そのまま押せるようにする */
  function shownActs(ctx) {
    var out = (ctx.shown || []).slice(0, 3).map(function (t) {
      return [t.replace(/【.*?】/g, '').trim().slice(0, 16), 'ask', t];
    });
    if (!out.length) {
      /* ★まだ何もお出ししていないのに聞き返すと、**そこで行き止まりになる**（260809） */
      /* ⚠️ 260902まで**同じ丸を2つ**置いていた（書き写しの取りこぼし）。
         「秋らしい色のものはありますか」で2個並んで出ていた。
         ⚠️ 一覧の面では、**その一覧の外へ連れて行く丸を置かない**（all_sim の関所） */
      out = [['合う一枚を選んで', 'ask', '似合うものを見せてください']];
      out = out.concat(ctx.coll
        ? [['人気のものを見る', 'ask', '人気のものはどれですか']]
        : [['新しいものを見る', 'ask', '新商品はありますか']]);
    }
    return out;
  }

  /* ★お出しした商品を、**チャットの中で選べるようにする**（route.pick_acts と同じ）。
     押すとその一枚の話に切り替わる＝サイズ→色→カートへ繋がる。
     ⚠️ これが無いと、写真は出ているのに商品が決まらず、延々会話が続く（260809） */
  function pickActs(ps, limit) {
    return (ps || []).slice(0, limit || 3).map(function (p) {
      return [p.t.replace(/【.*?】/g, '').trim().slice(0, 16),
              'ask', p.t + 'はどんな商品ですか'];
    });
  }

  /* ★1点に決まった直後の道。**まだ伺っていないものだけ**を押せるようにする
     （route.buy_next_acts と同じ）。順番は決めない＝サイズが先でも色が先でもよい */
  function buyNextActs(prod, ctx) {
    var me = ctx.me || {};
    var ca = cartAct(prod, ctx);
    if (ca.length) return ca.concat([productAct(prod, ctx)]);
    var out = [];
    if (!me.size) out.push(['サイズを選ぶ', 'ask', 'サイズはどれがいいですか']);
    if (!me.color && colorList(prod).length > 1) {
      out.push(['色を見る', 'ask', '何色ありますか']);
    }
    /* ★丈（股下）が2種類あるものは、丈も伺わないと一点に決まらない（260810） */
    var lvn = lengthList(prod).filter(function (x) { return x[1] > 0; }).length;
    if (!me.length && lvn > 1) out.push(['丈を選ぶ', 'ask', '股下はどれがありますか']);
    return out.concat([productAct(prod, ctx)]);
  }

  /* 商品が決まっていないと答えられない型 */
  var NEED_PRODUCT = ['feel', 'size', 'color', 'material', 'care', 'styling',
                      'price', 'about', 'review', 'together', 'why', 'restock',
                      'scene'];
  var FIND_VERB = /探し|探す|ほしい|欲しい|おすすめ|ありますか|ありませんか|どれ|何か|いいもの/;

  /* `spec` は「■素材\n…\n\n■原産国\n…」の形。狙った見出しだけ取る */
  function specLine(spec, head) {
    var m = (spec || '').match(new RegExp('■' + head + '\\s*\\n([^\\n■]+)'));
    return m ? m[1].trim() : null;
  }

  /* ── 実データで絞る3つ（袖丈・生地の厚さ・素材）─ route の同名と同じ ──────────
     ★季節のお尋ねは、**タグでは受けられない**（お店のタグは12種で、季節の語が無い）。
       そこで**商品ページに実際に書いてある値**へ橋渡しする。増えるのは商品であって
       語彙ではないので、9月から12月まで毎週足されても勝手に追随する。
     ⚠️ 値の語彙は現物34点から数えて決めた。**無い値は作らない** */
  var SLEEVE_WORDS = [
    ['長袖', ['長袖', 'ながそで', '袖のある', '袖あり']],
    ['七分袖', ['七分袖', '7分袖', '五分袖', '5分袖', '二の腕が隠れる']],
    ['半袖', ['半袖', 'はんそで']],
    ['ノースリーブ', ['ノースリーブ', '袖なし', 'タンクトップ']]
  ];
  /* 境目（cm）。⚠️ ここを動かすときは現物の袖丈を数え直す */
  var SLEEVE_RANGE = {'長袖': [50, 999], '七分袖': [40, 49], '半袖': [20, 39],
                      'ノースリーブ': [0, 19]};

  /* ★袖丈は `slv` に焼き込んである（build_widget）。⚠️ `v.z` はサイズ表の先頭4行
     だけなので、そちらから数えると袖丈が5行目にある商品を落とす */
  function sleeveOf(prod) {
    return (prod.slv === null || prod.slv === undefined) ? null : prod.slv;
  }

  function wantedSleeve(text) {
    for (var i = 0; i < SLEEVE_WORDS.length; i++) {
      var name = SLEEVE_WORDS[i][0], ws = SLEEVE_WORDS[i][1];
      for (var j = 0; j < ws.length; j++) {
        if (text.indexOf(ws[j]) >= 0) return name;
      }
    }
    return '';
  }

  function hasSleeve(prod, want) {
    var r = SLEEVE_RANGE[want], n = sleeveOf(prod);
    if (n === null) n = 0;
    return n >= r[0] && n <= r[1];
  }

  /* 生地の厚さ＝`radar` の「生地の厚さ｜薄め／普通／厚め」（現物にある値だけ） */
  var THICK_WORDS = [
    ['厚め', ['厚手', '厚め', 'しっかりした生地', 'しっかりめ', '肉厚']],
    ['薄め', ['薄手', '薄め', '軽い生地']]
  ];

  function thicknessOf(prod) {
    var m = (prod.radar || '').match(/生地の厚さ｜([^｜"]+)/);
    return m ? m[1].trim() : '';
  }

  function wantedThickness(text) {
    for (var i = 0; i < THICK_WORDS.length; i++) {
      var name = THICK_WORDS[i][0], ws = THICK_WORDS[i][1];
      for (var j = 0; j < ws.length; j++) {
        if (text.indexOf(ws[j]) >= 0) return name;
      }
    }
    return '';
  }

  /* 素材＝`spec` の「■素材」行。**書いてある繊維名だけ**を当てる */
  var MATERIAL_WORDS = [
    ['ウール', ['ウール', '毛100', '羊毛']],
    ['カシミヤ', ['カシミヤ', 'カシミア']],
    ['アクリル', ['アクリル']],
    ['綿', ['綿', 'コットン']],
    ['麻', ['麻', 'リネン']],
    ['レーヨン', ['レーヨン']],
    ['ナイロン', ['ナイロン']],
    ['ポリエステル', ['ポリエステル']],
    ['シルク', ['シルク', '絹']]
  ];

  function wantedMaterial(text) {
    for (var i = 0; i < MATERIAL_WORDS.length; i++) {
      var name = MATERIAL_WORDS[i][0], ws = MATERIAL_WORDS[i][1];
      for (var j = 0; j < ws.length; j++) {
        if (text.indexOf(ws[j]) >= 0) return name;
      }
    }
    return '';
  }

  function hasMaterial(prod, want) {
    return (specLine(prod.spec || '', '素材') || '').indexOf(want) >= 0;
  }

  /* ★**「毎週、新しいものが入っています」と添えてよいか**（260902・Take決定）。
     ⚠️ 添え文を**決め打ちにしない**。9月から12月まで毎週足される予定だが、実績としては
        6月に3週続けたあと**8週間ゼロだった**。止まった週に言うと嘘になるので、
        **いま並んでいる新着に発売タグが2つ以上ある＝2週ぶん以上が実在する**ときだけ添える */
  function weeklyArrivals() {
    var days = {};
    newArrivals().forEach(function (p) {
      (p.tags || []).forEach(function (t) { if (SOLD_ON.test(t)) days[t] = 1; });
    });
    return Object.keys(days).length >= 2;
  }

  /* ★気になるところの丸を、**いま在庫にあるタグからだけ**作る（260902）。
     ⚠️ 「汗ジミ」を決め打ちで出していた。9月から12月まで毎週入れ替わるので、
        夏物が捌けた日に**押しても1点も出ない丸**が残る。タグから作れば自動で消える */
  /* ★丸にしてよいタグと、押していただく言葉（タグ／丸の文字／送る言葉）。route._ASK_ACT と同じ。
     ⚠️ **送る言葉が TAG_WORDS でそのタグに当たること**が条件。当たらない言葉を置くと、
        押しても別のタグに落ちる（「羽織りものがほしい」は `夏の羽織り` に当たるので入れない）。
     ⚠️ 並び順は**同点のときの決め方**でもある。ここを動かすと丸の順番が変わる */
  var WORRY_ACT = [
    ['体型カバー', '体型カバー', '体型が気になります'],
    ['きちんと見え', 'きちんと見せたい', 'きちんと見せたいです'],
    ['一枚で決まる', '一枚で決めたい', '一枚で決めたいです'],
    ['二の腕カバー', '二の腕', '二の腕が気になります'],
    ['汗・暑さ対策', '汗ジミ', '汗ジミが気になります']
  ];

  /* ★どんなふうに着たいかの丸を、**今季（新着）にあるタグから**作る（260902・Take）。
     ⚠️ もとは3つの決め打ちで、サイトのヘッダー「お悩みから選ぶ」に合わせていた。
        9/2に数えると3つのうち2つは新着が0点で、押すと必ず春夏に着地していた。
     ⚠️ 並べるのは**新着に多い順**（同数なら在庫の多い順、それも同数なら上の並び順） */
  function worryActs() {
    function count(list, t) {
      var n = 0;
      list.forEach(function (p) {
        if ((p.tags || []).indexOf(t) >= 0) n += 1;
      });
      return n;
    }
    var na = newArrivals();
    var live = (KB.products || []).filter(sellable);
    var cand = [];
    WORRY_ACT.forEach(function (w, i) {
      var all = count(live, w[0]);
      if (all) cand.push({i: i, w: w, n: count(na, w[0]), a: all});
    });
    cand.sort(function (x, y) {
      return (y.n - x.n) || (y.a - x.a) || (x.i - y.i);
    });
    var out = cand.slice(0, 3).map(function (c) {
      return [c.w[1], 'ask', c.w[2]];
    });
    return out.concat([['とくにない', 'ask', 'とくにありません']]);
  }

  function yen(n) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }

  /* 合わせ方の段を選ぶ手がかり。⚠️「合う」だけだと「靴に合う長さ」に当たる */
  var DRESS_WORDS = ['トップス', 'ボトム', 'ブラウス', 'Tシャツ', 'シャツ', 'デニム',
                     'スカート', 'パンツ', 'ジャケット', '羽織', 'インナー',
                     'コーデ', '着回', '合わせれば', '合わせても', '合わせて'];

  function bestDressBlock(heads) {
    if (!heads.length) return ['', ''];
    var sc = function (h, b) {
      var n = 0;
      DRESS_WORDS.forEach(function (w) {
        if (h.indexOf(w) >= 0) n += 3;
        if (b.indexOf(w) >= 0) n += 1;
      });
      return n;
    };
    var best = heads[0], bs = sc(heads[0][0], heads[0][1]);
    heads.forEach(function (x) {
      var v = sc(x[0], x[1]);
      if (v > bs) { best = x; bs = v; }
    });
    return bs ? best : heads[0];
  }

  /* 着ていく場面の手がかり。**商品ページに書いてある言葉だけ**を拾う
     （route.py の WEAR_SCENE_WORDS と1語ずつ同じ。片方だけ足すと parity が落ちる）
     ⚠️ お客様に伺う場面のほう（KB.scenes）とは**別物**。名前を分けてある */
  var WEAR_SCENE_WORDS = ['オフィス', '職場', '会社', '通勤', 'お仕事', '仕事',
                     '休日', 'お出かけ', 'おでかけ', '外出', '旅行', 'お出まし',
                     '食事会', '会食', 'お呼ばれ', '集まり', '同窓会', '観劇',
                     '参観', '行事', 'ふだん', '普段', '家事', '散歩', '近所'];

  /* ★この一枚を、どんな場面で着られるか。**タグから引く**（260902・Take「大体かけんかね」）。
     ⚠️ `KB.scenes` は場面→タグの対応表（route.SCENE_WORDS）。**逆に引けば場面が言える**。
        スタッフが付けたタグそのものなので、推し量りではない。
     ⚠️ 並べるのは2つまで。3つ並べると「AIの書き方」になる（260809） */
  /* ★2つの文が**同じ言い回し**を持っているか（4字以上・読点や句点の直前）。
     ⚠️ 商品ページの紹介文を2つ並べると同じ書き方が重なることがある。
        こちらが書いた文ではないので直せない＝**2つめを出さない**ことで避ける */
  function echoes(x, y) {
    var ts = x.match(/[ぁ-んァ-ヶ一-龥]{4,6}(?=[。、])/g) || [];
    return ts.some(function (t) { return y.indexOf(t) >= 0; });
  }

  var SCENE_OK = ['お出かけ', 'お仕事', 'ふだん着', '旅行', 'あらたまった日', '冷房よけ'];

  /* 2つの文が、**n字以上の同じ並び**を持っているか。
     ⚠️ echoes() は句読点の前の言い回ししか見ないので、**文の途中で重なる**ぶんを
        取りこぼす（260909。「シャツを重ねて」が1つの吹き出しに2回出た） */
  function sharesPhrase(a, b, n) {
    n = n || 6;
    a = String(a || ''); b = String(b || '');
    if (a.length < n || b.length < n) return false;
    for (var i = 0; i + n <= a.length; i++) {
      if (b.indexOf(a.slice(i, i + n)) >= 0) return true;
    }
    return false;
  }

  function sceneFromTags(prod) {
    var out = [];
    (KB.scenes || []).forEach(function (row) {
      if (SCENE_OK.indexOf(row[0]) >= 0
          && (prod.tags || []).indexOf(row[1]) >= 0
          && out.indexOf(row[0]) < 0) out.push(row[0]);
    });
    return out.slice(0, 2);
  }

  function sceneBlocks(heads) {
    var sc = function (h, b) {
      var n = 0;
      WEAR_SCENE_WORDS.forEach(function (w) {
        if (h.indexOf(w) >= 0) n += 3;
        if (b.indexOf(w) >= 0) n += 1;
      });
      return n;
    };
    /* ⚠️ 濃い順。同点は**書いてある順**を守る（並べ替えで両側がずれないように） */
    return heads.map(function (x, i) { return {x: x, n: sc(x[0], x[1]), i: i}; })
      .filter(function (o) { return o.n > 0; })
      .sort(function (p, q) { return (q.n - p.n) || (p.i - q.i); })
      .map(function (o) { return o.x; });
  }

  function sceneNames(heads) {
    var out = [];
    heads.forEach(function (hb) {
      WEAR_SCENE_WORDS.forEach(function (w) {
        if ((hb[0] + hb[1]).indexOf(w) >= 0 && out.indexOf(w) < 0) out.push(w);
      });
    });
    return out;
  }

  /* ★お店のご紹介。**面にその言葉が残っているときだけ言う**（route.SHOP_SAY と同じ） */
  /* ★軸は Daily elegance（route.SHOP_SAY と1行ずつ同じ） */
  var SHOP_SAY = [
    ['ラクなのに凛として見え', '仕事の日も、お出かけの日も。'],
    ['手持ちの服にも合わせやすい',
     'ラクなのに凛として見えて、手持ちの服にも合わせやすい。そんな一枚のことです。'],
    ['迷うほどの数は、置きません',
     'HALMEK up編集部が一着ずつ袖を通して選んでいます。迷うほどの数は置いていません。'],
    ['お悩みの答え', '服の名前が、そのままお悩みの答えになっています。'],
    ['2日以内に出荷', 'ご注文の約8割を、2日以内に出荷しています。'],
    ['名前を名乗って',
     'サイズのご相談も返品・交換も、スタッフが名前を名乗ってお返事しています。']
  ];
  function shopText() {
    var s = (KB.shop && KB.shop.sections) || [];
    return s.map(function (x) { return (x.title || '') + '\n' + (x.body || ''); })
            .join('\n');
  }
  function shopLines() {
    var t = shopText();
    return SHOP_SAY.filter(function (x) { return t.indexOf(x[0]) >= 0; })
                   .map(function (x) { return x[1]; });
  }
  function shopLead() {
    var t = shopText();
    if (t.indexOf('これがいい') >= 0) {
      return 'Daily elegance ──「これでいい」ではなく「これがいい」を、毎日に。';
    }
    return t.indexOf('その答えだけを並べたお店') >= 0
      ? '装いのお悩みの答えだけを並べた、HALMEK up編集部のお店です。'
      : 'HALMEK up編集部が選んだ服を並べた、Up selectというお店です。';
  }

  /* 用言で終わる見出しは「〜んです。」で語りかけに変わる（鳥井トーン 1d） */
  var VERB_END = 'うくぐすつぬぶむるい';
  /* ⚠️ ★**見出しの1行目だけに当てる**（260909）。260907に見出しが1行→3行になり
     <br> を持つようになったので末尾が体言止めになり、販売中39点のうち23点で
     魅力の一言が丸ごと消えていた（variety_sim が数える） */
  function toTalk(head) {
    var h = String(head || '').split(/\s*<br\s*\/?>\s*|\n/)[0].trim();
    /* ⚠️ 見出しが3行になったとき、1行目は「。」で終わるようになった（260907）。
       句点を落としてから用言を見ないと、ここでも空を返す */
    h = h.replace(/。+$/, '');
    if (!h || VERB_END.indexOf(h.charAt(h.length - 1)) < 0) return '';
    return h + 'んです。';
  }

  /* 着姿に効く事実を1文で。**評価は入れず、数字と言葉だけ** */
  function dressNote(prod) {
    var sil = '', items = (prod.radar || '').match(/"([^"]+)"/g) || [];
    items.forEach(function (x) {
      var t = x.replace(/"/g, '');
      if (t.indexOf('シルエット') === 0) sil = t.split('｜')[1] || '';
    });
    var lens = [];
    prod.v.forEach(function (v) {
      var m = v.t.match(/股下(\d{2})/);
      if (m && lens.indexOf(m[1]) < 0) lens.push(m[1]);
    });
    lens.sort();
    var bits = [];
    if (sil) bits.push('シルエットは' + sil);
    if (lens.length > 1) {
      bits.push('股下は' + lens.map(function (x) { return x + 'cm'; }).join('と')
                + 'から選べます');
    }
    return bits.length ? (bits.join('。') + '。')
                       : '着たときの感じは、下の写真をご覧くださいね。';
  }

  function A(tier, intent) {
    return {tier: tier, intent: intent, lead: '', body: [], note: [],
            acts: [], sources: [], prefill: '', rows: null, product: null,
            snaps: [], colors: [], cards: [], figs: [], about: null, next: []};
  }

  function faqHits(pat) {
    var re = new RegExp(pat), out = [];
    for (var i = 0; i < KB.faq.length; i++) {
      if (re.test(KB.faq[i].q)) out.push(KB.faq[i]);
    }
    return out;
  }

  /* ── 会話を続ける（route.py の new_ctx と同じ形）─────────────── */
  function newCtx(pageHandle, coll) {
    /* me＝その人のカルテ（場面・気になるところ・サイズ・身長・似合う色の目安）
       proposed＝もうお出ししたもの。同じ顔を出し直さないために持つ */
    /* at＝いまどの面にいるか（cart のときは**決済へ進む後押しを優先する**） */
    /* coll＝いま見ているコレクションのhandle。**この中からお出しする**（260810） */
    return {product: '', pending: '', page: pageHandle || '', at: '',
            coll: coll || '', last: '', asked: [], offset: 0, miss: 0,
            me: {}, proposed: []};
  }

  /* ── 店員の接客を再現する（260809）────────────────────────────
     ⚠️ 語彙も色の対応表も **upc-kb.js に焼き込んだものを使う**（手で写さない）。
        正本は route.SCENE_WORDS / MOOD_WORDS / PCOLOR。 */
  function sceneOf(text) {
    var sc = KB.scenes || [], i, j;
    for (i = 0; i < sc.length; i++) {
      for (j = 0; j < sc[i][2].length; j++) {
        if (text.indexOf(sc[i][2][j]) >= 0) return [sc[i][0], sc[i][1]];
      }
    }
    var mo = KB.moods || [];
    for (i = 0; i < mo.length; i++) {
      if (text.indexOf(mo[i][0]) >= 0) return [mo[i][1], mo[i][2]];
    }
    return ['', ''];
  }

  /* ⚠️ `asked=true`＝**こちらが伺った直後**だけ、要望寄りのタグ（きちんと見え／一枚で決まる）も
     答えとして受け取る。free text で拾うと「お出かけに着たいです」が「きちんと見え」に
     当たって、**2段目の問いが飛ぶ**（260902に踏んだ） */
  function worryOf(text, asked) {
    var tags = wantedTags(text);
    var wt = (asked ? KB.askTags : KB.worryTags) || [], i;
    for (i = 0; i < tags.length; i++) {
      if (wt.indexOf(tags[i]) >= 0) return tags[i];
    }
    return new RegExp(KB.noWorry).test(text) ? 'なし' : '';
  }

  /* 会話で分かったことを、その人のカルテに足す。**足すだけ。消さない。** */
  /* ★★「体型カバー」の**どこが**気になるかを、もう1段だけ伺う（260909・Take
     「体型カバー、着たいシーンとかも一辺倒でつまらん」）。
     ⚠️ 語彙は route._PARTS / talk.source.PARTS と対＝**片方だけ増やさない** */
  var PARTS = ['お腹まわり', '腰まわり・ヒップ', '二の腕', '背中・後ろ姿',
               '首まわり・デコルテ', '脚のライン'];
  var PART_WORD = {
    'お腹まわり': ['お腹', 'おなか', '腹まわり', 'ウエストまわり', 'ぽっこり'],
    '腰まわり・ヒップ': ['腰', 'ヒップ', 'おしり', 'お尻', '下半身'],
    '二の腕': ['二の腕', 'にのうで', '腕まわり', '腕が'],
    '背中・後ろ姿': ['背中', '後ろ姿', 'うしろ姿', '後姿'],
    '首まわり・デコルテ': ['首', 'デコルテ', '胸元', '顔まわり'],
    '脚のライン': ['脚', '足のライン', 'ふくらはぎ', '太もも']
  };
  function partOf(text) {
    for (var i = 0; i < PARTS.length; i++) {
      var ws = PART_WORD[PARTS[i]];
      for (var j = 0; j < ws.length; j++) {
        if (text.indexOf(ws[j]) >= 0) return PARTS[i];
      }
    }
    return '';
  }
  /* 伺う丸＝**いまその言葉で言える商品がある部位**だけを、多い順に3つ */
  function partActs() {
    var n = {};
    allProducts().forEach(function (p) {
      if (!sellable(p)) return;
      var cv = talkOf(p).covers || {};
      Object.keys(cv).forEach(function (k) {
        if (PARTS.indexOf(k) >= 0) n[k] = (n[k] || 0) + 1;
      });
    });
    var got = Object.keys(n).sort(function (x, y) {
      return (n[y] - n[x]) || (PARTS.indexOf(x) - PARTS.indexOf(y));
    }).slice(0, 3);
    return got.map(function (k) { return [k, 'ask', k + 'が気になります']; })
      .concat([['とくにない', 'ask', 'とくにありません']]);
  }

  function remember(ctx, text) {
    var me = ctx.me = ctx.me || {};
    var sc = sceneOf(text);
    if (sc[1]) { me.scene = sc[0]; me.scene_tag = sc[1]; }
    /* ⚠️ `pending === 'worry'`＝**こちらが伺った直後**。そのときだけ要望寄りのタグも受け取る */
    var w = worryOf(text, ctx.pending === 'worry');
    if (w) me.worry = w;
    /* ★どこが気になるかも覚える（propose の理由と並べ替えが変わる） */
    var pt = partOf(text);
    if (pt) { me.part = pt; if (!me.worry) me.worry = '体型カバー'; }
    var s = usualSize(text);
    if (s) me.size = s;
    /* ★色も覚える（カートに入れるには、サイズと色の両方が決まっている必要がある）。
       ⚠️ ここをPython側にだけ書いていて、**画面ではカートのボタンが出なかった**（260809） */
    var cm = saidColor(text);
    if (cm) me.color = cm;
    var h = heightOf(text);
    if (h) me.height = h;
    var g = wantedGarment(text);
    if (g) me.garment = g;
    /* ★丈（股下）も覚える（260810・`all_sim`）。
       ⚠️ パンツは股下57／62のように丈が分かれていて、サイズと色が決まっても
          一点に決まらない。それなのに先頭の丈を黙って選んでいた */
    var lm = text.match(/股下\s*(\d{2})/);
    if (lm) me.length = '股下' + lm[1];
    /* ★②【選ぶ】＝「M～Lにします」。**伺ったのではなく、選ばれた** */
    var pk = text.match(PICK_SIZE);
    if (pk) {
      me.picked_size = pk[1].trim();
      var inner = pk[1].match(/(3L|LL|L|M|S)/);
      if (inner) me.size = inner[1];
    }
  }

  /* ⚠️ 提案のときに「残り◯点」は出さない（260809・Take）。急かすのは接客ではない */
  function productCards(ps) {
    return ps.map(function (p) {
      return {t: p.t, p: p.p, img: p.img || '', h: p.h};
    });
  }

  /* 用件を当てる前に商品名を外す（route.strip_title と同じ）。**当てるためだけ**に使う */
  function stripTitle(text, prod) {
    var out = text;
    (prod.t.match(/【.*?】/g) || []).forEach(function (br) {
      out = out.split(br).join('');
    });
    var core = prod.t.replace(/【.*?】/g, '');
    /* ★名前が**丸ごと**書かれていたら、丸ごと外す（260902・route.strip_title と同じ）。
       ⚠️ 下の行はカタカナの塊しか外さないので、「シアー重ね着**風**ノースリーブ」から
          「重ね着風」が文に残る。残った「重ね着」が季節の受け口に当たって、
          商品の丸を押しても**その一枚の話にならず新着5点が出ていた** */
    out = out.split(core.trim()).join('');
    (core.match(/[ァ-ヴー]{3,}/g) || []).sort(function (x, y) {
      return y.length - x.length;
    }).forEach(function (t) { out = out.split(t).join(''); });
    return out;
  }

  /* バリアント名から**色を落とした**サイズの呼び名（route.size_key と同じ） */
  function sizeKey(vt) {
    var parts = vt.split(/\s*\/\s*/);
    return (parts.length > 1 ? parts.slice(0, -1).join(' / ') : vt).trim();
  }

  /* ★★お客様に出す「サイズの丸」には**2つの尺度**がある（260810・Take）。
     ①【伺う】ふだんお召しのサイズは？ → 丸は**店の共通**（S/M/L/LL/3L）
                                        → 受けは「Lで大丈夫ですよ」＝判断
     ②【選ぶ】お選びいただけるのは…   → 丸は**その商品の表記**（M～L 等）
                                        → 受けは「M～Lですね。承ります」＝受領
     ⚠️ 混ぜると、選んだだけの方に**適合の判断**を返してしまう。正本は route.offer_sizes */
  /* ⚠️ 260909まで「在庫のあるものだけ」だったので、**発売当日で在庫0の商品は
     1つも返さず**、丸が店の共通（S/M/L/LL/3L）へ落ちていた＝ワンピース
     （M～L／LL～3L）に**そもそも無いサイズの丸**が出ていた（Take指摘）。
     予約でお求めいただけるサイズは在るので、sellable と同じ物差しで見る */
  function offerSizes(prod) {
    var out = [];
    (prod.v || []).forEach(function (v) {
      var k = sizeKey(v.t);
      if (canBuy(v) && out.indexOf(k) < 0) out.push(k);
    });
    return out;
  }

  /* ★**そのサイズで買える色**（260810・Take）。正本は route.colors_in_size。
     ⚠️ 「Lで大丈夫ですよ」のあと、いきなり色の丸だけが出ていた。お店なら
        「お選びいただいたLですと、シロ・クロがございます」と挟む */
  function colorsInSize(prod, size, length) {
    var out = [];
    (prod.v || []).forEach(function (v) {
      if (!hasSize(v, size)) return;
      if (length && !hasLength(v, length)) return;
      if (!canBuy(v)) return;
      var c = v.t.split(/\s*\/\s*/).pop().trim();
      if (c && out.indexOf(c) < 0) out.push(c);
    });
    return out;
  }

  function offerActs(prod) {
    return offerSizes(prod).map(function (s) { return [s, 'ask', s + 'にします']; });
  }

  /* ⚠️ 単独の S・L は別の語に当たるので、**「にします」が付くときだけ**読む */
  var PICK_SIZE =
    /((?:股下\d{2}／)?(?:3L|LL|L|M|S)(?:\s*[～〜~-]\s*(?:3L|LL|L|M|S))?)\s*にします/;
  /* サイズ表を**サイズごとに1行**へ（在庫は足し上げる）。route.merge_rows と同じ */
  /* 伺ったサイズを、**その商品の表記**でお返しする（260909）。
     ⚠️ 丸は「M～L」なのに受けが「お選びいただいたMですと」になっていた
        ＝その商品に無い呼び名を画面に出していた。丸の字と答えの字はそろえる */
  var LEN_HEAD = /^股下\s*\d{2}\s*[／/]\s*/;

  /* 「**ふだんお召しのサイズ**」を伺う丸＝その商品にあるサイズだけ（丈は付けない）。
     ⚠️ ②【選ぶ】の丸（offerSizes）は「股下57／M」のように丈込みで正しいが、ここで
        同じものを使うと**丈まで決まった丸**が並び、丈を伺う手が消える（260909） */
  function usualSizes(prod) {
    var out = [];
    (prod.v || []).forEach(function (v) {
      if (!canBuy(v)) return;
      var k = sizeKey(v.t).replace(LEN_HEAD, '').trim();
      if (k && out.indexOf(k) < 0) out.push(k);
    });
    return out;
  }

  function saidSizeLabel(prod, want) {
    var out = want;
    (prod.v || []).some(function (v) {
      if (hasSize(v, want)) { out = sizeKey(v.t); return true; }
      return false;
    });
    return out;
  }

  function mergeRows(vs) {
    var at = {}, order = [];
    vs.forEach(function (v) {
      var k = sizeKey(v.t);
      if (!(k in at)) {
        /* ⚠️ **先頭3項目で切らない**（260909）。パンツは6行あり、後ろ3つが
           丸ごと出ていなかった。★2表目（z2）も足す＝PDPには出ているのに
           コンシェルジュには渡っていなかった */
        var rows = (v.z || []).concat(v.z2 || []);
        at[k] = [k, 0, rows.map(function (x) { return x[0] + x[1]; }).join('／')];
        order.push(k);
      }
      at[k][1] += Math.max(0, v.s || 0);
    });
    return order.map(function (k) { return at[k]; });
  }
  /* お店にあるサイズ展開（在庫のあるものだけ）。route.store_sizes と同じ */
  /* ⚠️ ここは名前のとおり**お店ぜんぶ**で数える。コレクションの面では KB.products が
     その面に絞られているので、allProducts を見ないとその一覧のサイズ展開に化ける */
  function storeSizes() {
    var got = {};
    allProducts().forEach(function (p) {
      p.v.forEach(function (v) {
        /* ⚠️ **在庫の点数で数えない**（260909）。毎週5点が在庫0で発売される */
        if (!canBuy(v)) return;
        var m = v.t.match(/(3L|LL|L|M|S)/);
        if (m) got[m[1]] = 1;
      });
    });
    /* ⚠️ ここに S が無かった（260810）＝並びを手で書いた漏れ */
    return ['S', 'M', 'L', 'LL', '3L'].filter(function (s) { return got[s]; });
  }
  /* ★「トップスならこれ、ボトムスならこれ」と捌く。route.size_picks と同じ */
  var PICK_GROUPS = [['トップス', ['トップス', 'ブラウス']],
                     ['ボトムス', ['パンツ', 'スカート']],
                     ['羽織りもの', ['ジャケット']]];

  /* ★「M～L」のような**幅のあるサイズ**も、MにもLにも当たるものとして扱う
     （260810・buy_sim が検出。ワッシャーは「M～L／LL～3L」の2つしか無く、
     在庫も色もあるのにカートのボタンが永遠に出なかった） */
  function hasSize(v, want) {
    if (new RegExp('(^|[／/\\s])' + esc(want) + '([／/\\s]|$)').test(v.t)) return true;
    var re = /(3L|LL|L|M|S)\s*[～〜~-]\s*(3L|LL|L|M|S)/g, m;
    while ((m = re.exec(v.t))) {
      var i = SIZES.indexOf(m[1]), j = SIZES.indexOf(m[2]);
      if (i < 0 || j < 0) continue;
      var lo = Math.min(i, j), hi = Math.max(i, j);
      if (SIZES.slice(lo, hi + 1).indexOf(want) >= 0) return true;
    }
    return false;
  }

  function sizePicks(want) {
    var out = [];
    var sorted = KB.products.slice().sort(function (x, y) {
      return ratingVal(y) - ratingVal(x);
    });
    PICK_GROUPS.forEach(function (g) {
      var ws = [];
      g[1].forEach(function (k) {
        ws = ws.concat(GARMENT_IN_TITLE[k] || []);
      });
      for (var i = 0; i < sorted.length; i++) {
        var p = sorted[i];
        var ok = false;
        for (var w = 0; w < ws.length; w++) {
          if (titleCore(p).indexOf(ws[w]) >= 0) ok = true;
        }
        if (!ok) continue;
        for (var j = 0; j < p.v.length; j++) {
          if (hasSize(p.v[j], want) && (p.v[j].s || 0) > 0) {
            out.push([g[0], p, p.v[j]]);
            return;
          }
        }
      }
    });
    return out;
  }

  /* ★一覧への入口。**条件が1つだけぴたりと合えば、そのコレクションへ**（route.see_all） */
  /* ⚠️ 合わないときは**何も出さない**（260809・Take「すべてのアイテムだと意味がない」）。
     お出しした商品の写真が、そのまま入口になっている */
  function seeAll() {
    var got = [].slice.call(arguments).filter(function (x) { return x; });
    var map = KB.collectionOf || {};
    if (got.length === 1 && map[got[0]]) {
      return [[map[got[0]][0] + 'をぜんぶ見る', 'url', '/collections/' + map[got[0]][1]]];
    }
    return [];
  }

  /* ★商品への入口。**いま見ている商品なら、同じ面へ飛ばさない**（260809・Take）。
     気になるところが晴れたら、サイズと色を選ぶところへご案内する＝買う一歩の後押し */
  function productAct(prod, ctx) {
    if ((ctx.page || '') === prod.h) return ['サイズと色を選ぶ', 'pick', ''];
    return ['この商品を見る', 'url', '/products/' + prod.h];
  }

  /* ★会話で**サイズと色の両方が決まった**ときだけ返す（route.decided_variant と同じ）。
     ⚠️ 押し間違いで意図しない商品がカートに入るのがいちばん怖い（260809・Take）。
        「たぶんこれ」では出さない。 */
  /* ★丈（股下）の違い。**サイズと色が決まっても、丈が残る商品がある**（260810）。
     正本は route.lengths。⚠️ `all_sim` が捕まえた＝伺わずに先頭の丈を入れていた */
  function lengthList(prod) {
    var out = {}, order = [];
    (prod.v || []).forEach(function (v) {
      var m = (v.t || '').match(/股下\s*(\d{2})/);
      if (!m) return;
      var k = '股下' + m[1];
      if (!(k in out)) { out[k] = 0; order.push(k); }
      out[k] += Math.max(0, v.s || 0) || (canBuy(v) ? 1 : 0);
    });
    return order.map(function (k) { return [k, out[k]]; });
  }

  /* ⚠️ 「57」を文字として探すと別の数字にも当たる。**股下＋数字**でそろえて見る */
  function hasLength(v, want) {
    var m = (v.t || '').match(/股下\s*(\d{2})/);
    return !!m && ('股下' + m[1]) === want;
  }

  function decidedVariant(prod, ctx) {
    var me = ctx.me || {};
    if (!me.size) return null;
    var cs = colorList(prod).filter(function (x) { return x[1] > 0; })
                            .map(function (x) { return x[0]; });
    var col = cs.indexOf(me.color) >= 0 ? me.color : (cs.length === 1 ? cs[0] : '');
    if (!col) return null;
    var ls = lengthList(prod).filter(function (x) { return x[1] > 0; })
                             .map(function (x) { return x[0]; });
    var ln = ls.indexOf(me.length) >= 0 ? me.length : (ls.length === 1 ? ls[0] : '');
    if (ls.length && !ln) return null;
    /* ★決め方は**残った候補を数える**（260810）。ぴったり1点でなければ決まっていない */
    var cand = (prod.v || []).filter(function (v) {
      return hasSize(v, me.size)
          && v.t.split(/\s*\/\s*/).pop().trim() === col
          && (!ln || hasLength(v, ln))
          && (v.s || 0) > 0 && v.b && v.id;
    });
    return cand.length === 1 ? cand[0] : null;
  }

  /* ★2枚1組で選ぶ商品（Tシャツ）。**会話から1点だけ入れてはいけない**（260809・Take）。
     ⚠️ 見分けはタグ limit_by_2（Bundlerアプリが付ける）＋商品名の「セット」 */
  function isSet(prod) {
    return (prod.tags || []).indexOf('limit_by_2') >= 0 || prod.t.indexOf('セット') >= 0;
  }

  function cartAct(prod, ctx) {
    if (isSet(prod)) return [];
    var v = decidedVariant(prod, ctx);
    /* ⚠️ **どれを入れるのかを名前に出す**（サイズだけだと色が分からない） */
    if (!v) return [];
    return [[v.t.replace(/\s*\/\s*/g, '・').trim() + 'をカートに入れる', 'cart', v.id]];
  }

  /* ★ガイドの中身を、チャットの中で出し切る（route.guide_detail と同じ）。
     ⚠️ **書いてあることしか出さない**（要約で足さない） */
  var GUIDE_NAV = /お買い物ガイド「[^」]*」を見る\s*›?/g;

  function guideDetail(intent, limit) {
    var key = (KB.guidePick || {})[intent];
    if (!key) return [[], []];
    var ch = null;
    (KB.guide || []).forEach(function (g) {
      if (!ch && g.t.indexOf(key[0]) >= 0) ch = g;
    });
    if (!ch) return [[], []];
    var heads = ch.subs || [];
    var lines = [], seen = {};
    if (intent === 'payment') {
      var ways = heads.filter(function (h) {
        return ['クレジットカード', 'スマホ決済', 'コンビニ決済',
                'あと払い（ペイディ）'].indexOf(h) >= 0;
      });
      if (ways.length) lines.push(ways.join('／') + 'がご利用いただけます。');
    }
    var parts = (ch.body || '').replace(GUIDE_NAV, ' ').split(/[。\n]/);
    for (var i = 0; i < parts.length && lines.length < (limit || 4); i++) {
      var s = parts[i].replace(/^[\s　]+|[\s　]+$/g, '');
      if (s.length < 12 || s.length > 58 || seen[s] || heads.indexOf(s) >= 0) continue;
      var hit = false;
      for (var w = 0; w < key[1].length; w++) {
        if (s.indexOf(key[1][w]) >= 0) hit = true;
      }
      if (!hit) continue;
      seen[s] = 1;
      lines.push(s + '。');
    }
    /* ⚠️ お支払いの図は**VisaとJCBしか無い**（260809・Take「クレカしかできない様に
       見える」）。**足りない絵は出さないほうが正しい**＝言葉で全部言ってある */
    if (intent === 'payment') return [lines, []];
    return [lines, (ch.imgs || []).slice(0, 3)];
  }

  /* ★お買い物ガイドは**該当箇所へ**（route.GUIDE_AT が正本・焼き込み） */
  function guideAct(intent, label) {
    var at = (KB.guideAt || {})[intent] || '';
    return [label, 'url', '/pages/shopping-guide' + at];
  }

  function ratingVal(p) {
    var v = parseFloat(p.rv);
    return isNaN(v) ? 0 : v;
  }

  /* なぜこれをお出しするのかを1文で。**商品ページに書いてあることだけ** */
  function reasonLine(p) {
    var say = toTalk((p.head || '').trim());
    if (say) return say;
    return (p.pts && p.pts.length) ? (p.pts[0] + '、というところです。') : '';
  }

  function ptypeOf(warm, bright) {
    return warm ? (bright ? '春' : '秋') : (bright ? '夏' : '冬');
  }

  function colorTypes(name) { return (KB.pcolor || {})[name] || []; }
  /* ★色の値。**正本は route.COLOR_HEX**（build_widget が焼き込む）。手書きしない */
  function colorHex(name) {
    var m = KB.colorHex || {}, k;
    if (m[name]) return m[name];
    for (k in m) {
      if (m.hasOwnProperty(k) && (k.indexOf(name) >= 0 || name.indexOf(k) >= 0)) {
        return m[k];
      }
    }
    return '';
  }
  /* その色の**鮮やかさ**（0〜1）。無彩色はほぼ0。
     ⚠️ 診断で**無彩色ばかり並べない**ために要る（260909・Take「めちゃ単調」） */
  function chroma(name) {
    var h = colorHex(name);
    if (!h) return 0;
    var rgb = [parseInt(h.substr(1, 2), 16) / 255,
               parseInt(h.substr(3, 2), 16) / 255,
               parseInt(h.substr(5, 2), 16) / 255];
    return Math.max.apply(null, rgb) - Math.min.apply(null, rgb);
  }
  /* ★★カラー診断で見ていただく色の丸（route.dx_colors と同じ） */
  function dxColors(warm, exclude) {
    var brightS = warm ? '春' : '夏', deepS = warm ? '秋' : '冬';
    var live = {};
    allProducts().forEach(function (p) {
      if (!sellable(p)) return;
      colorList(p).forEach(function (x) {
        if (x[1] > 0 && (KB.pcolor || {})[x[0]]) {
          live[x[0]] = (live[x[0]] || 0) + 1;
        }
      });
    });
    var used = (exclude || []).slice();
    function pick(season, k) {
      var got = Object.keys(live).filter(function (c) {
        return colorTypes(c).indexOf(season) >= 0 && used.indexOf(c) < 0;
      });
      got.sort(function (x, y) {
        return (chroma(y) - chroma(x)) || (live[y] - live[x])
            || (x < y ? -1 : x > y ? 1 : 0);
      });
      var out = got.slice(0, k);
      used = used.concat(out);
      return out;
    }
    var got = pick(brightS, 2).concat(pick(deepS, 2));
    if (got.length < 4) {
      var rest = Object.keys(live).filter(function (c) {
        return used.indexOf(c) < 0
          && (colorTypes(c).indexOf(brightS) >= 0
              || colorTypes(c).indexOf(deepS) >= 0);
      });
      rest.sort(function (x, y) {
        return (chroma(y) - chroma(x)) || (x < y ? -1 : x > y ? 1 : 0);
      });
      got = got.concat(rest.slice(0, 4 - got.length));
    }
    return got;
  }
  /* 店の実物から、その色の写真を1枚ずつ（route.color_swatch と同じ） */
  function colorSwatch(names, ask) {
    return names.map(function (c) {
      var img = '', say = '';
      var ps = allProducts();
      for (var i = 0; i < ps.length; i++) {
        var p = ps[i];
        if (!sellable(p)) continue;
        p.v.forEach(function (v) {
          if (v.t.split(/\s*\/\s*/).pop().trim() === c && canBuy(v) && v.img) {
            if (!img) img = v.img;
            if (!say) say = String((talkOf(p).colors || {})[c] || '');
          }
        });
        if (img && say) break;
      }
      return {name: c, stock: 1, img: img, h: '', say: say,
              hex: colorHex(c), ask: (ask ? (c + 'を選びます') : '')};
    });
  }

  /* いま見ている商品の色のうち、そのタイプに映えやすいもの */
  function fitsColors(prod, ptype) {
    var out = [], cs = colorList(prod), i;
    for (i = 0; i < cs.length; i++) {
      if (cs[i][1] > 0 && colorTypes(cs[i][0]).indexOf(ptype) >= 0
          && out.indexOf(cs[i][0]) < 0) out.push(cs[i][0]);
    }
    return out;
  }

  /* お店にある色から、そのタイプに映えやすいものを写真つきで（在庫のあるものだけ） */
  function palette(ptype) {
    var seen = {}, order = [];
    KB.products.forEach(function (p) {
      p.v.forEach(function (v) {
        var c = v.t.split(/\s*\/\s*/).pop().trim();
        if (!c || colorTypes(c).indexOf(ptype) < 0 || !canBuy(v)) return;
        /* ★写真1枚ごとに、その色を持つ商品への入口を付ける（260809・Take） */
        /* ⚠️ 色見本の形は**1つに揃える**（colorCards / colorSwatch と同じ） */
        if (!seen[c]) {
          seen[c] = {name: c, stock: 0, img: '', h: p.h,
                     say: '', hex: colorHex(c), ask: ''};
          order.push(c);
        }
        seen[c].stock += v.s || 0;
        if (!seen[c].img && v.img) { seen[c].img = v.img; seen[c].h = p.h; }
      });
    });
    /* ⚠️ ★**鮮やかな色を先に**（260909・Take「めちゃ単調」） */
    return order.map(function (c) { return seen[c]; })
                .sort(function (x, y) {
                  return (chroma(y.name) - chroma(x.name)) || (y.stock - x.stock);
                }).slice(0, 6);
  }

  /* カルテに合うものを**1点だけ**、理由をつけてお出しする */
  /* ★**Up select が作った一枚だと、先に言う**（260909 Take「オリジナル商品は
     Up selectがこだわって作ったことを冒頭にいって欲しい。PBなので」）。
     ⚠️ 言ってよい言い方は決まっている＝「オリジナル素材」「百貨店と同じ」は社内で否決。
        言えるのは「Up select が作った」「素材から選び直した」まで */
  function originalSay(prod) {
    var orig = collItems(ORIG_COLL).some(function (q) { return q.h === prod.h; });
    return orig ? 'Up select が、素材から選び直して作った一枚です。' : '';
  }

  function propose(ctx, lead) {
    var me = ctx.me || {};
    var tags = [me.scene_tag, me.worry].filter(function (t) {
      return t && t !== 'なし';
    });
    var pool = KB.products.filter(sellable);
    if (me.garment) {
      var ws = GARMENT_IN_TITLE[me.garment] || [];
      var narrowed = pool.filter(function (p) {
        return ws.some(function (w) { return titleCore(p).indexOf(w) >= 0; });
      });
      if (narrowed.length) pool = narrowed;
    }
    var hit = tags.length ? pool.filter(function (p) {
      return tags.every(function (t) { return p.tags.indexOf(t) >= 0; });
    }) : [];
    var kept = '';
    if (!hit.length && tags.length) {
      /* ⚠️ 両方に当たるものが無いときは**体型の悩みを先に取る** */
      var order2 = [me.worry, me.scene_tag].filter(function (x) {
        return x && x !== 'なし';
      });
      for (var i = 0; i < order2.length; i++) {
        var got = pool.filter(function (p) {
          return p.tags.indexOf(order2[i]) >= 0;
        });
        if (got.length) { hit = got; kept = order2[i]; break; }
      }
    }
    if (!hit.length) { hit = pool; kept = 'なし'; }

    var t = me.ptype;
    if (t) {
      var good = hit.filter(function (p) { return fitsColors(p, t).length; });
      if (good.length) hit = good;
    }
    /* ★今季のものを先に（260902・Take「選択形式だと悩み軸で春夏に着地して、変わった感じがしない」）。
       ⚠️ 評価→在庫の順は、**新商品が構造的に上へ来られない**並び（レビューがまだ無い）。
          実測＝場面3×気になるところ3の9通りのうち、新商品に着地したのは1通りだけだった。
       ⚠️ 絞り込みはタグで済んでいるので、前に出しても**場面と無関係なものは出ない** */
    var hNew = {}, hOrig = {};
    newArrivals().forEach(function (p) { hNew[p.h] = 1; });
    collItems(ORIG_COLL).forEach(function (p) { hOrig[p.h] = 1; });
    /* ★★**その場面・その部位について言えることがある商品を先に出す**（260909）。
       実測＝24通りで出た商品は3種類だけだった。タグが2つに畳まれるので、
       タグの並べ替えだけでは場面ごとに変わらない */
    var scP = me.scene || '', ptP = me.part || '';
    /* ★★**その場面・その部位について言える商品に絞る**（260909）。並べ替えだけでは
       足りない＝秋はタグが2つに畳まれるので、お出かけ・お仕事・PTA が同じ母集団になる。
       ⚠️ 0点になるなら絞らない（言えないからといって、お出しできないわけではない） */
    if (scP) {
      var byScene = hit.filter(function (q) {
        return (talkOf(q).scenes || {})[scP];
      });
      if (byScene.length) hit = byScene;
    }
    if (ptP) {
      var byPart = hit.filter(function (q) {
        return (talkOf(q).covers || {})[ptP];
      });
      if (byPart.length) hit = byPart;
    }
    var saysN = function (q) {
      var tq = talkOf(q);
      return ((scP && (tq.scenes || {})[scP]) ? 1 : 0)
           + ((ptP && (tq.covers || {})[ptP]) ? 1 : 0);
    };
    hit = hit.slice().sort(function (x, y) {
      var sx = saysN(x), sy = saysN(y);
      if (sx !== sy) return sy - sx;
      var nx = hNew[x.h] ? 1 : 0, ny = hNew[y.h] ? 1 : 0;
      if (nx !== ny) return ny - nx;
      var ox = hOrig[x.h] ? 1 : 0, oy = hOrig[y.h] ? 1 : 0;
      if (ox !== oy) return oy - ox;
      return (ratingVal(y) - ratingVal(x)) || ((y.s || 0) - (x.s || 0));
    });
    ctx.proposed = ctx.proposed || [];
    var rest = hit.filter(function (p) { return ctx.proposed.indexOf(p.h) < 0; });
    if (!rest.length) {
      /* ★出し切ったら**言い切る**。⚠️ ここで先頭に戻していたので、押すたびに
         同じ顔がぐるぐる出て、終わりの無い会話になっていた（260809・flow_sim が検出） */
      var aEnd = A(GREEN, '合うものをお出しする（ここまで）');
      aEnd.lead = 'ご紹介できるのは、いまのところここまでです。';
      aEnd.body = ['お出しした' + ctx.proposed.length
                   + '点のほかには、条件に合うものがございません。'];
      var back = ctx.proposed.slice(-2).map(byHandle).filter(function (q) { return q; });
      aEnd.acts = pickActs(back, 2).concat(
        [['別の場面で探す', 'ask', '別の場面で探したいです']]);
      aEnd.sources = ['商品のタグ', '在庫'];
      return aEnd;
    }
    var p = rest[0];
    ctx.proposed.push(p.h);

    var a = A(GREEN, '合うものをお出しする');
    var scene = me.scene || '';
    var say = (KB.worrySay || {})[kept];
    var tkP = talkOf(p);
    /* ★★**その商品の、その場面の話をする**（260909・Take「体型カバー、着たいシーンとかも
       一辺倒でつまらん」）。実測＝24通りで導入は語尾違いの1文、理由は24回中12回が同じ文 */
    var sceneSay = scene ? String((tkP.scenes || {})[scene] || '') : '';
    var coverSay = (me.part) ? String((tkP.covers || {})[me.part] || '') : '';
    if (lead) a.lead = lead;
    else if (sceneSay) a.lead = sceneSay;
    else if (say) a.lead = '気になるところをカバーできるものからお出ししますね。';
    else if (scene) a.lead = scene + 'でしたら、こちらはいかがでしょう。';
    else a.lead = 'こちらはいかがでしょう。';
    a.body.push(p.t + '／' + yen(p.p) + '円');
    /* ⚠️ 導入で場面の話をしたら、**理由は別のことを言う**（同じ文を2回置かない） */
    var r = coverSay || (sceneSay ? String(tkP.hook || '') : '') || reasonLine(p);
    if (r && !echoes(a.lead, r)) a.body.push(r);
    /* ⚠️ ★決め文句は**トークが無い商品の落とし方にだけ残す**（260909）。トークがあるのに
       重ねると、その一枚の言葉のあとに全商品共通の1文が続いて台無しになる */
    if (coverSay || Object.keys(tkP).length) { /* 足さない */ }
    else if ((KB.worrySay || {})[me.worry]) a.body.push(KB.worrySay[me.worry]);
    if (t) {
      var ok = fitsColors(p, t);
      if (ok.length) a.body.push(ok.join('／') + 'でしたら、お伺いした色の目安にも合います。');
    }
    a.body.push(sizeLine(p));
    a.cards = productCards([p]);
    a.snaps = (p.snaps || []).slice(0, 2);
    a.note = ['もし合わなければ、お届けから8日以内は交換も承ります'];
    /* ★条件が1つだけぴたりと合うなら、その一覧への入口も置く（260809・Take） */
    a.acts = [productAct(p, ctx),
              ['ほかも見せて', 'ask', 'ほかのものも見せてください']];
    a.acts = a.acts.concat(seeAll.apply(null,
      [me.worry, me.scene].filter(function (t) { return t && t !== 'なし'; })
        .concat([me.garment || ''])));
    /* ⚠️「つづけて」は決め打ちにしない＝**もう答えた話を勧め直す**（answer が組む） */
    a.sources = ['商品のタグ', '商品ページ', '在庫'];
    ctx.product = p.h;
    return a;
  }
  /* 商品名だけの返事を、聞き返したときの用件に戻す言い方 */
  var BACK_TO = {
    size: 'のサイズ', styling: 'の合わせ方', color: 'は何色ありますか',
    material: 'の素材', care: 'のお手入れ', price: 'はいくらですか',
    review: 'の評判', together: 'と一緒に買うもの', why: 'を選んだ理由',
    feel: 'の透け感', about: 'はどんな商品ですか', restock: 'の入荷',
    compare: 'のサイズ'
  };
  /* 相槌・独り言。**突き放さずに受け止める** */
  var FILLER = new RegExp(
    '^(はい|うん|ええ|うーん|うーむ|ふーん|へえ|へー|そっか|なるほど|'
    + 'そう(です)?(ねぇ|ねえ|ね|か|なんだ)?|まあ|えっと|あのー?|すみません|ごめんなさい|'
    + 'ちょっと(いい|聞き|お聞き|教え)[^。]{0,12}|お尋ねしたい[^。]{0,8}|'
    + 'わかりません|分かりません|どうしよう(かな)?|迷って(います|る)?|迷います|'
    + '高いね|たかいね|高い(です)?ね|ちょっと高)[。、！!？?…\\s]*$');

  /* ── 次に聞けることを、そっと出す（route.py の NEXT と同じ）────────
     答えて終わりにしない。商品が要るものは、商品が分かっているときだけ。 */
  /* ★表は upc-kb.js に焼き込んだものを使う（route.NEXT / route._POOL が正本）。
     ⚠️ ここで二重に持っていたので、片方に足し忘れると**画面だけ会話が続かない**
        という形で出る。260809にJSとPythonの両方に書いていたのをやめた。 */
  var NEXT = KB.next || {};
  var POOL = KB.pool || [];
  /* ★話を切り替える道。**2つのうち1つは、いまの話の外から出す**（260809） */
  var SWITCH = KB.switch || [];
  /* カートで出してはいけない道＝**探しもののレーン**（会計が止まる） */
  var SHOP_LANE = ['browse', 'colordx', 'find', 'popular', 'similar', 'restart'];
  /* 「他には？」＝直前の話の続き */
  var MORE = /^(ほか|他)(に|には)?[はも]?[？?]?$|^もっと|ほかには|他には/;

  /* ★「その一枚についての答え」＝頭に写真つきの見出しを付ける用件（260809） */
  var ABOUT_INTENTS = ['size', 'color', 'material', 'care', 'styling', 'feel',
    'price', 'review', 'together', 'why', 'restock', 'about', 'audience',
    'similar', 'colordx', 'compare', 'scene', 'browse',
    /* ★丈（股下）もその一枚についての答え。**買う一歩を先頭に出す**（260810） */
    'length'];

  function nextSteps(intent, hasProduct, asked, at) {
    var pick = function (rows) {
      var out = [];
      (rows || []).forEach(function (row) {
        if (row[2] && !hasProduct) return;
        if (asked.indexOf(row[3]) >= 0) return;
        for (var i = 0; i < out.length; i++) { if (out[i][0] === row[0]) return; }
        out.push([row[0], row[1]]);
      });
      return out;
    };
    /* ★カートの面は、会計の話だけ。**装いの話へ戻さない**（そこで会計が止まる） */
    if (at === 'cart') return pick(KB.cartNext || []).slice(0, 2);

    var same = pick(NEXT[intent]);
    var out = same.slice(0, 1);            /* いまの話の続きは**1つだけ** */
    var has = function (x) {
      for (var i = 0; i < out.length; i++) { if (out[i][0] === x[0]) return true; }
      return false;
    };
    var sw = pick(SWITCH);                 /* もう1つは、話を切り替える道 */
    for (var s = 0; s < sw.length; s++) {
      if (!has(sw[s])) { out.push(sw[s]); break; }
    }
    if (out.length < 2) {
      same.slice(1).forEach(function (x) { if (!has(x)) out.push(x); });
    }
    if (out.length < 2) {
      pick(POOL).forEach(function (x) { if (!has(x)) out.push(x); });
    }
    if (!out.length) {
      /* ★**行き止まりを作らない。** 全部答えたあとでも、店なら次の一枚を出す */
      out = [['ほかも見せて', 'ほかのものも見せてください'],
             ['似合う色から', 'カラー診断をお願いします']];
    }
    return out.slice(0, 2);
  }
  var GREET = /^(こんにちは|こんばんは|おはよう|はじめまして|やあ|もしもし)/;
  var THANKS = /ありがと|助かりま|わかりました|承知|了解/;
  var BYE = /^(さようなら|失礼します|また来ます)/;
  var BARE_SIZE = /^(?:はい[、。]?)?\s*(3L|LL|L|M|S)(?:サイズ)?(?:です|でした)?[。！]?$/;
  var BARE_H = /^(1[4-8]\d)\s*(?:cm|センチ)?(?:です)?[。！]?$/;

  /* ── いま見ているコレクション（面）の中からお出しする（260810）──────────
     ⚠️ 260810までこの材料そのものが無く、コレクションの面は「店ぜんぶ」と同じ扱いだった。
        羽織り・ジャケットの面で「人気のもの」を押すとジョガーパンツが出ていた（Take）。
     正本は route.scope_kb。**KB.products をその面の中身に差し替えて core を通し、
     必ず戻す**（戻し忘れると、次の面まで絞られたままになる）。 */
  var ALL_PRODUCTS = KB.products;

  function allProducts() { return ALL_PRODUCTS; }

  function collByHandle(h) {
    if (!h) return null;
    /* すべてのアイテム・レコメンド・ランキングは店ぜんぶと同じ＝絞らない */
    if (h === 'all' || h === 'recommend' || h === 'ranking') return null;
    var cs = KB.collections || [];
    for (var i = 0; i < cs.length; i++) {
      if (cs[i].h === h) return cs[i];
    }
    return null;
  }

  /* 絞れたらその面を返す（KB.products を差し替える）。絞らないときは null */
  function scopeIn(ctx) {
    var c = collByHandle((ctx && ctx.coll) || '');
    if (!c) return null;
    var inside = {};
    (c.p || []).forEach(function (h) { inside[h] = 1; });
    var got = ALL_PRODUCTS.filter(function (p) { return inside[p.h]; });
    /* 1点しか無い面で「人気のもの」を聞かれても、お店の役に立たない */
    if (got.length < 2) return null;
    KB.products = got;
    return c;
  }

  function scopeOut() { KB.products = ALL_PRODUCTS; }

  function byHandle(h) {
    var ps = allProducts();
    for (var i = 0; i < ps.length; i++) {
      if (ps[i].h === h) return ps[i];
    }
    return null;
  }

  /* ⚠️ 呼ぶのは answer() のほう。こちらは中身で、次に聞けることが付かない */
  function core(text, ctx) {
    var r = KB.rules, a;
    ctx = ctx || newCtx('');

    /* ★書き方のゆれを、ここで一度だけ寄せる（route.py の _core と同じ場所）。
       ⚠️ **もとの言い方はフォームへ渡すぶんに残す**＝お客様の書いた言葉を書き換えない */
    var raw = text;
    text = normInput(text);

    /* ★伺ったことは、その場でカルテに書く。**次の一手が変わる**（260809） */
    remember(ctx, text);

    var pending = ctx.pending || '';
    /* ★こちらから伺ったことへの返事は、**受け取れたときだけ**話を進める */
    var forced = '';
    var me0 = ctx.me = ctx.me || {};
    var cdx = KB.cdx || {};
    if (pending === 'cdx1' && (new RegExp(cdx.gold).test(text)
                               || new RegExp(cdx.silver).test(text))) {
      me0.warm = new RegExp(cdx.gold).test(text);
      forced = 'colordx'; ctx.pending = '';
    } else if (pending === 'cdx2' && (new RegExp(cdx.bright).test(text)
                                      || new RegExp(cdx.deep).test(text))) {
      me0.bright = new RegExp(cdx.bright).test(text);
      forced = 'colordx'; ctx.pending = '';
    /* ★色の丸を押していただいたとき（260909）。**押した色そのものが答え**なので、
       「明るい／落ち着いた」に言い換えずに、その色を票として持つ */
    } else if (pending === 'cdx2' || pending === 'cdx3') {
      var gotDx = (ctx.dx_pick || []).filter(function (c) {
        return text.indexOf(c) >= 0;
      })[0];
      if (gotDx) {
        me0[pending === 'cdx2' ? 'dx1' : 'dx2'] = gotDx;
        me0.dx_seen = (me0.dx_seen || []).concat(ctx.dx_pick || []);
        forced = 'colordx'; ctx.pending = '';
      }
    } else if (pending === 'scene' && me0.scene_tag) {
      forced = 'browse'; ctx.pending = '';
    } else if (pending === 'worry' && me0.worry) {
      forced = 'browse'; ctx.pending = '';
    } else if (pending === 'part') {
      /* 「とくにない」も答えとして受ける（また聞かないため） */
      if (me0.part || new RegExp(KB.noWorry).test(text)) {
        if (!me0.part) me0.part = '';
        forced = 'browse'; ctx.pending = '';
      }
    }
    if (pending === 'size') {
      var m1 = text.trim().match(BARE_SIZE);
      if (m1) {
        text = 'いつも' + m1[1] + 'サイズです';
      } else {
        var m2 = text.trim().match(BARE_H);
        if (m2) {
          text = '身長' + m2[1] + 'cmです サイズ';
        } else if (findProduct(text)) {
          /* ★商品名だけの返事も、待っていた「サイズ」の用件に戻す（260809の二巡目） */
          text = text + 'のサイズ';
        }
      }
    } else if (pending.indexOf('product') === 0 && findProduct(text)) {
      /* ⚠️ **商品名だと分かったときだけ**戻す。「サイズ表を見せてください」まで
            「の合わせ方」に化けていた（260807の二巡目） */
      var pk = pending.indexOf(':') >= 0 ? pending.split(':')[1] : 'size';
      text = text + (BACK_TO[pk] || 'のサイズ');
    }

    /* 「他には？」は、直前の話の続きとして受ける */
    var more = MORE.test(text.trim()) && !!ctx.last;
    if (more && ctx.last === 'find' && ctx.find_text) {
      ctx.offset = (ctx.offset || 0) + 3;
      text = ctx.find_text;
    } else if (more) {
      /* 探しもの以外での「他には？」＝次に聞けることを並べて返す */
      a = A(GREEN, 'ほかに聞けること');
      a.lead = 'ほかにも、こんなことをお伝えできますよ。';
      a.next = nextSteps(ctx.last, !!ctx.product, ctx.asked || [], ctx.at || '');
      if (!a.next.length) {
        a.next = [['サイズを選ぶ', 'サイズはどれがいいですか'],
                  ['いつ届く？', 'いつ届きますか']];
      }
      a.sources = ['—'];
      return a;
    } else {
      ctx.offset = 0;
    }

    /* ★商品名を外してから用件を当てる（名前の中の言葉に用件を奪わせない）。
       ⚠️ 260809にTakeが踏んだ＝「【アイロン、もう要らない】ノーアイロンリラックスシャツ」を
          選んだら、名前の中の「アイロン」がお手入れに当たって実寸が出なかった */
    var named = findProduct(text);
    var intent = forced || detect(named ? stripTitle(text, named) : text);
    /* ★★お店にある色の名前を言われたら、それは**色のお尋ね**（260809）。
       ⚠️ 手で書いた色の語だけを見ていたので「オフホワイト」「オリーブ」を押しても
          色の答えにならず、場面のお伺いに落ちていた */
    if (['unknown', 'browse', 'find', 'scene'].indexOf(intent) >= 0
        && namedColor(text)) {
      intent = 'color';
    }
    var prod = named;
    if (!prod) prod = byHandle(ctx.product || '') || byHandle(ctx.page || '');
    /* ★場面や気になるところだけを言われたら、それは**探しもののご相談**（260809）。
       「旅行に着たいです」はどの受け口の言葉にも当たらないので🟡に落ちていた
       ⚠️ **いま見ている商品があるときはbrowseへ寄せない**（260809の二巡目・sim(8)）。
          scene_of/worry_ofが当たったなら、下のタグ照合（intent='scene'）に任せる */
    if (intent === 'unknown' && !prod && (sceneOf(text)[1] || worryOf(text))) {
      intent = 'browse';
    }

    var tagsHere = wantedTags(text);
    /* ★季節の言い方は、**商品ページの実データ**で探せる（260902）。袖丈・生地の厚さ・
       素材・色のどれかが言われていたら、聞き返さずに探しに行く。
       ⚠️ 商品が決まっているときは、その一枚の話のまま（「これの素材は？」を奪わない） */
    var saidSpec = wantedSleeve(text) || wantedThickness(text)
                   || wantedMaterial(text) || namedColor(text);
    /* ⚠️ 探している人に「どの商品でしょうか」と聞き返さない */
    if (NEED_PRODUCT.indexOf(intent) >= 0 && !prod
        && (tagsHere.length || budgetOf(text) || saidSpec
            || (FIND_VERB.test(text) && wantedGarment(text)))) {
      intent = 'find';
    } else if ((intent === 'unknown' || intent === 'popular' || intent === 'doubt')
               && !prod && saidSpec) {
      intent = 'find';
    } else if ((intent === 'unknown' || intent === 'popular' || intent === 'doubt')
               && tagsHere.length) {
      /* ⚠️ **いま見ている商品があるなら、探しに飛ばさない** */
      intent = prod ? 'scene' : 'find';
    } else if (intent === 'unknown' && !FILLER.test(text.trim())
               && (wantedGarment(text) || budgetOf(text) || FIND_VERB.test(text))) {
      /* 探している気配があるなら、聞き返しでなく**探す入口**を出す */
      intent = 'find';
    }

    ctx._intent = intent;
    if (intent !== 'unknown') ctx.miss = 0;
    if (prod) ctx.product = prod.h;
    ctx.pending = '';

    if (GREET.test(text.trim()) && intent === 'unknown') {
      a = A(GREEN, 'あいさつ');
      /* ⚠️ お店で、いきなり返品の話はしない。入口は買う前の相談にする */
      a.lead = 'こんにちは。Up selectコンシェルジュです。';
      /* ★カートの面は、探しものの話をしない。**会計の心配ごとに答えて背中を押す** */
      if (ctx.at === 'cart') {
        a.body = ['お会計の前に、気になることがあればどうぞ。'];
        a.acts = [['送料は？', 'ask', '送料はいくらですか'],
                  ['お支払い方法', 'ask', '支払い方法を教えてください'],
                  ['いつ届く？', 'ask', 'いつ届きますか'],
                  ['返品はできる？', 'ask', '返品はできますか'],
                  /* サイズ違いは**返品でなく交換**で解く方が多い（260809・Take） */
                  ['交換はできる？', 'ask', 'サイズを交換したいです']];
        a.sources = ['—'];
        return a;
      }
      /* ★商品ページでは、**その一枚の話から始める**（260809・Take「対話を消すと
         冒頭が『似合うもの見せて』になるのが変」）。目の前の一枚があるのに、
         店じゅうの話から始めない */
      if (prod) {
        a.body = [prod.t.replace(/【.*?】/g, '') + 'のこと、なんでもお尋ねくださいね。',
                  '下のボタンでも、入力欄に書いていただいても大丈夫です。'];
        a.acts = [['この服の魅力は？', 'ask', 'この商品の魅力を教えてください'],
                  ['着こなしシーン', 'ask', 'どんなときに着られますか'],
                  ['サイズを選ぶ', 'ask', 'サイズはどれがいいですか']];
        a.sources = ['—'];
        return a;
      }
      /* ★入口の言葉が「サイズ・素材」だと、**受けられる幅が狭いと伝わる**（260809） */
      /* ⚠️ 押しても書いてもよいことを、**はじめに言う**（260809・Take） */
      a.body = ['お探しのものを、ご一緒にお選びしますね。',
                '下のボタンでも、入力欄に書いていただいても大丈夫です。'];
      a.acts = [['合う一枚を選んで', 'ask', '似合うものを見せてください'],
                ['似合う色から', 'ask', 'カラー診断をお願いします'],
                ['サイズを選ぶ', 'ask', 'サイズはどれがいいですか']];
      a.sources = ['—'];
      return a;
    }
    if (THANKS.test(text) && intent === 'unknown') {
      a = A(GREEN, 'お礼への返し');
      a.lead = 'こちらこそ、ありがとうございます。';
      a.body = ['ほかにも気になることがあれば、どうぞ。'];
      /* まだ話していないことだけを、そっと出す */
      a.next = nextSteps(ctx.last || '', !!prod, ctx.asked || [], ctx.at || '');
      a.sources = ['—'];
      return a;
    }
    if (BYE.test(text.trim())) {
      a = A(GREEN, 'おわりのあいさつ');
      a.lead = 'またお気軽にお声がけくださいね。';
      a.sources = ['—'];
      return a;
    }

    /* 相槌・迷い。**同じ聞き返しで突き放さない** */
    if (FILLER.test(text.trim()) && (intent === 'unknown' || intent === 'popular')) {
      a = A(GREEN, '相槌を受ける');
      a.lead = 'ごゆっくりお選びくださいね。';
      a.body = ['気になるところから、ひとつずつお出しします。'];
      a.next = nextSteps(ctx.last || '', !!prod, ctx.asked || [], ctx.at || '');
      if (!a.next.length) {
        /* ⚠️ ここも装いの話へ寄せる（事務の語彙で戻さない／260809） */
        a.next = [['合う一枚を選んで', '似合うものを見せてください'],
                  ['似合う色から', 'カラー診断をお願いします']];
      }
      a.sources = ['—'];
      return a;
    }

    /* ── ①なんとなく見ている人を受け止める（260809・Take）────────── */
    if (intent === 'browse') {
      var meB = ctx.me = ctx.me || {};
      /* ★★**体のことを言われたら、受けたと言ってから伺う**（260909）。実測では
         「後ろ姿が気になります」に「ごゆっくりご覧くださいね。」と返していて、
         聞いたことが伝わらなかった。⚠️ ここで商品は出さない（場面を伺ってから） */
      /* ⚠️ **探していると言っている人は、探すほうへ通す**（popular と同じ作法）。
         ⚠️ **タグが当たっただけで通さない**＝「ヒップが気になります」は 体型カバー に
            当たるが、これは探しものの言い方ではなく困りごとの言い方 */
      var LOOKING = /探し|さがし|ほしい|欲しい|ありますか|ありませんか|見せて|おすすめ|オススメ|教えて/;
      if (meB.part && !meB.scene
          && !(wantedGarment(text) || LOOKING.test(text))) {
        a = A(GREEN, 'どんなときに着るかを伺う');
        a.lead = meB.part + 'が気になるのですね。';
        a.body = ['どんなときにお召しになりたいか、教えていただけますか。',
                  'そのうえで、気になるところに合うものをお出しします。'];
        a.acts = [['お出かけに', 'ask', 'お出かけに着たいです'],
                  ['お仕事に', 'ask', '仕事に着ていきたいです'],
                  ['ふだん着に', 'ask', 'ふだん着に着たいです'],
                  ['旅行に', 'ask', '旅行に着たいです']];
        ctx.pending = 'scene';
        a.sources = ['商品のタグ'];
        return a;
      }
      /* ⚠️「ほかも見せて」は**次の一枚**。いま見ているものの話に戻さない */
      if (new RegExp((KB.cdx || {}).moreItem).test(text)) {
        return propose(ctx, 'では、こちらはいかがでしょう。');
      }
      /* ⚠️ こちらの問いへの返事（場面・気になるところ）は、**探しもののご相談**。
         いま見ているものの話に落とさない（260809に踏んだ） */
      if (prod && !forced) {
        a = A(GREEN, '見ているものについて受ける');
        a.lead = '気になりますよね。';
        /* ★★**部位を言われたら、その部位の話をする**（260909）。実測では
           「背中・後ろ姿が気になります」に「モノトーン系プリント、というところです。」
           と返していて、聞かれたことに答えていなかった */
        var pt1 = meB.part || '';
        var cv1 = String((talkOf(prod).covers || {})[pt1] || '');
        if (cv1) {
          a.lead = cv1;
        } else if (pt1) {
          /* ⚠️ 言えないなら**言えないと言う**。ほかの部位の話にすり替えない */
          a.lead = pt1 + 'については、はっきりとは申し上げられないのですが、'
                 + 'この一枚はこんなふうです。';
        }
        var rB = talkOf(prod).hook || reasonLine(prod);
        if (rB && !sharesPhrase(a.lead, String(rB))) a.body.push(String(rB));
        a.body.push(sizeLine(prod));
        a.snaps = (prod.snaps || []).slice(0, 2);
        a.acts = [productAct(prod, ctx),
                  ['似合う色を見る', 'ask', 'どの色が似合いますか']];
        a.next = [['サイズを選ぶ', 'サイズはどれがいいですか'],
                  ['着用・コーデ例', '着ているところが見たいです']];
        a.sources = ['商品ページ', '在庫'];
        return a;
      }
      if (!meB.scene_tag) {
        a = A(GREEN, 'どんなときに着るかを伺う');
        a.lead = 'ごゆっくりご覧くださいね。';
        a.body = ['よろしければ、どんなときにお召しになりたいか教えてください。',
                  'そのうえで、合いそうなものをお出しします。'];
        /* ⚠️ お仕事を入れる（260809・Take「着るシーンで仕事用がないね」） */
        a.acts = [['お出かけに', 'ask', 'お出かけに着たいです'],
                  ['お仕事に', 'ask', '仕事に着ていきたいです'],
                  ['ふだん着に', 'ask', 'ふだん着に着たいです'],
                  ['旅行に', 'ask', '旅行に着たいです']];
        ctx.pending = 'scene';
        a.sources = ['商品のタグ'];
        return a;
      }
      if (!meB.worry) {
        a = A(GREEN, 'どんなふうに着たいかを伺う');
        a.lead = meB.scene + 'ですね。';
        /* ⚠️ 問いも一緒に替えた（260902・Take）。丸を今季のタグから作ると
           「きちんと見せたい」「一枚で決めたい」＝**悩みではなく要望**が並ぶので、
           「気になるところはありますか」のままだと日本語が合わない */
        a.body = ['どんなふうに着たいですか。'];
        a.acts = worryActs();
        ctx.pending = 'worry';
        a.sources = ['商品のタグ'];
        return a;
      }
      /* ★★「体型カバー」と言われたら、**どこが気になるか**をもう1段だけ伺う（260909）。
         ⚠️ 聞くのは**2つまで**の設計は守る＝この問いは「どんなふうに着たいか」の
            続きであって、3つ目の問いではない（体型のときだけ枝が分かれる） */
      if (meB.worry === '体型カバー' && !meB.part && ctx.pending !== 'part') {
        var pacts = partActs();
        if (pacts.length > 1) {
          a = A(GREEN, 'どこが気になるかを伺う');
          a.lead = '体型カバーですね。';
          a.body = ['どのあたりが気になりますか。',
                    '気になるところに合わせて、理由もお伝えします。'];
          a.acts = pacts;
          ctx.pending = 'part';
          a.sources = ['商品ページ'];
          return a;
        }
      }
      return propose(ctx, '');
    }

    /* ── 決めた筋から出る（260809・Take「旅行テーマで延々と聞かれ続ける」）── */
    if (intent === 'restart') {
      var meR = ctx.me = ctx.me || {};
      /* ⚠️ 捨てるのは**その日の探しもの**だけ。体のことや色の目安は残す */
      ['scene', 'scene_tag', 'worry', 'garment'].forEach(function (k) {
        delete meR[k];
      });
      ctx.proposed = [];
      ctx.shown = [];
      /* ⚠️ 話に出ていた商品も手放す。残すと、次に伺った場面が
         「いま見ているもの」の話に化ける（260809に踏んだ） */
      ctx.product = '';
      ctx.asked = (ctx.asked || []).filter(function (x) { return x !== 'restart'; });
      a = A(GREEN, '別の切り口でお探しする');
      a.lead = '承知しました。別の切り口でお探ししますね。';
      a.body = ['どんなときにお召しになりたいか、教えていただけますか。'];
      /* ⚠️ お仕事を入れる（260809・Take「着るシーンで仕事用がないね」） */
      a.acts = [['お出かけに', 'ask', 'お出かけに着たいです'],
                ['お仕事に', 'ask', '仕事に着ていきたいです'],
                ['ふだん着に', 'ask', 'ふだん着に着たいです'],
                ['旅行に', 'ask', '旅行に着たいです']];
      ctx.pending = 'scene';
      a.sources = ['商品のタグ'];
      return a;
    }

    /* ── ②「似たようなのある？」＝タグの近いものを写真で（260809）───── */
    if (intent === 'similar') {
      if (prod) {
        var mine = prod.tags || [];
        var near = KB.products.filter(function (p) {
          return p.h !== prod.h && sellable(p);
        }).map(function (p) {
          var n = (p.tags || []).filter(function (t) {
            return mine.indexOf(t) >= 0;
          }).length;
          return [n, p];
        }).filter(function (x) { return x[0] > 0; })
          .sort(function (x, y) { return y[0] - x[0]; })
          .slice(0, 3).map(function (x) { return x[1]; });
        if (near.length) {
          a = A(GREEN, '似たものを知りたい');
          a.lead = '近いものでしたら、こちらがございます。';
          near.forEach(function (p) {
            a.body.push(p.t + '／' + yen(p.p) + '円');
          });
          a.cards = productCards(near);
          ctx.shown = near.map(function (p) { return p.t; });
          a.acts = pickActs(near).concat(
            [['合う一枚を選んで', 'ask', '似合うものを見せてください']]);
          a.sources = ['商品のタグ', '在庫'];
          return a;
        }
        a = A(GREEN, '似たものを知りたい（近いものが無い）');
        a.lead = '近いつくりのものは、いまのところございません。';
        a.body = ['よろしければ、一覧からご覧いただけます。'];
        a.acts = [['合う一枚を選んで', 'ask', '似合うものを見せてください']];
        a.sources = ['商品のタグ', '在庫'];
        return a;
      }
      a = A(AMBER, '似たものを知りたい（商品が特定できない）');
      a.lead = 'どの商品に似たものでしょうか。';
      ctx.pending = 'product';
      a.acts = a.acts.length ? a.acts : shownActs(ctx);
      a.body = ['商品のページから聞いていただくと、近いものをお出しします。'];
      a.sources = ['—'];
      return a;
    }

    /* ── ③似合う色の目安（2問だけ伺う）───────────────────────── */
    if (intent === 'colordx') {
      var meC = ctx.me = ctx.me || {};
      if (!('warm' in meC)) {
        a = A(GREEN, '似合う色を伺う（1問目）');
        a.lead = '3つ伺えば、映えやすい色の目安をお出しできますよ。';
        a.body = ['まず、アクセサリーは金と銀のどちらが顔なじみがよいですか。'];
        a.acts = [['金のほう', 'ask', '金のほうが顔なじみがよいです'],
                  ['銀のほう', 'ask', '銀のほうが顔なじみがよいです']];
        a.note = ['どちらとも言えないときは、身につけていて気持ちのよいほうで大丈夫です'];
        ctx.pending = 'cdx1';
        a.sources = ['—（目安です）'];
        return a;
      }
      /* ★★**色そのものを見て選んでいただく**（260909・Take「二択でしょぼい」
         「めちゃ単調」）。「明るい色と落ち着いた色、どちら」と言葉で聞かれても
         答えようがない。**店に実在する色を4つ並べて、顔映りで選ぶ**形にする。
         ⚠️ 2回伺う＝1回だと、たまたま好きな色を選んだだけかが分からない。3問まで */
      var warmC = !!meC.warm;
      if (!('dx1' in meC)) {
        var picks1 = dxColors(warmC, []);
        if (picks1.length >= 4) {
          a = A(GREEN, '似合う色を伺う（2問目）');
          a.lead = 'ありがとうございます。ここからは色を見ていただきますね。';
          a.body = ['この中で、顔が明るく見えるのはどれでしょう。'];
          a.colors = colorSwatch(picks1, true);
          a.acts = picks1.map(function (c) { return [c, 'ask', c + 'を選びます']; });
          ctx.pending = 'cdx2';
          ctx.dx_pick = picks1;
          a.sources = ['商品の色', '在庫'];
          return a;
        }
      }
      if (!('dx2' in meC) && ('dx1' in meC)) {
        var picks2 = dxColors(warmC, meC.dx_seen || []);
        if (picks2.length >= 4) {
          a = A(GREEN, '似合う色を伺う（3問目）');
          a.lead = 'あと1つだけ、別の色でも見ていただけますか。';
          a.body = ['同じように、顔が明るく見えるのはどれでしょう。'];
          a.colors = colorSwatch(picks2, true);
          a.acts = picks2.map(function (c) { return [c, 'ask', c + 'を選びます']; });
          ctx.pending = 'cdx3';
          ctx.dx_pick = picks2;
          a.sources = ['商品の色', '在庫'];
          return a;
        }
      }
      /* ★選んでいただいた色から、明るい系か落ち着いた系かを決める。
         ⚠️ 2回とも同じ向きなら言い切りを少し強め、食い違ったら「目安」を強める */
      var votes = ['dx1', 'dx2'].map(function (k) { return meC[k]; })
                                .filter(function (x) { return x; });
      if (votes.length && !('bright' in meC)) {
        var upS = warmC ? '春' : '夏';
        var up = votes.filter(function (c) {
          return colorTypes(c).indexOf(upS) >= 0;
        }).length;
        meC.bright = up * 2 >= votes.length;
        meC.dx_sure = votes.length > 1 && (up === 0 || up === votes.length);
      }
      if (!('bright' in meC)) {
        /* 色を出せないときは、これまでどおり言葉で伺う（在庫が薄い週の落とし方） */
        a = A(GREEN, '似合う色を伺う（2問目）');
        a.lead = 'ありがとうございます。あと1つだけ。';
        a.body = ['明るい色と落ち着いた色、どちらのほうが顔が明るく見えますか。'];
        a.acts = [['明るい色', 'ask', '明るい色のほうが顔が明るく見えます'],
                  ['落ち着いた色', 'ask', '落ち着いた色のほうが顔が明るく見えます']];
        ctx.pending = 'cdx2';
        a.sources = ['—（目安です）'];
        return a;
      }
      meC.ptype = ptypeOf(!!meC.warm, !!meC.bright);
      var tC = meC.ptype;
      a = A(GREEN, '似合う色の目安');
      /* ⚠️ **言い切らない**（顔映りは光の加減で変わる）。ただし2回とも同じ向きを
         選ばれたときは、そのぶんだけ確かに言う（260909） */
      a.lead = (KB.ptypeSay || {})[tC]
             + (meC.dx_sure ? 'が、はっきり映えるほうだと思います。'
                            : 'が、映えやすいタイプに近そうです。');
      if (meC.dx1) {
        a.body.push('お選びいただいた'
          + ['dx1', 'dx2'].map(function (k) { return meC[k]; })
              .filter(function (x) { return x; }).join('／')
          + 'から、そう見ています。');
      }
      if (prod) {
        var okC = fitsColors(prod, tC);
        if (okC.length) {
          a.body.push('いまご覧の商品でしたら、' + okC.join('／') + 'が映えやすいです。');
          a.colors = colorCards(prod).filter(function (c) {
            return okC.indexOf(c.name) >= 0;
          });
        } else {
          a.body.push('いまご覧の商品の色は、どれもお顔から少し離れる色みです。');
        }
        a.acts = [productAct(prod, ctx)];
      }
      var pal = palette(tC);
      if (pal.length) {
        a.body.push('お店にあるものでは、' + pal.map(function (c) {
          return c.name;
        }).join('／') + 'が近い色みです。');
        if (!a.colors.length) a.colors = pal;
      }
      /* ★★**色名を並べて終わりにしない**（260909・Take「二択でしょぼい」）。
         ①その色みの一枚を実際にお出しする ②避けるならどれかを1つだけ言う。
         ⚠️ 言い切らない（顔映りは光で変わる）ので「避けたほうがよい」とは言わない */
      if (pal.length && !prod) {
        var gotD = KB.products.filter(function (q) {
          return sellable(q) && fitsColors(q, tC).length
              && (ctx.proposed || []).indexOf(q.h) < 0;
        });
        if (gotD.length) {
          var newD = {};
          newArrivals().forEach(function (q) { newD[q.h] = 1; });
          gotD.sort(function (x, y) {
            var nx = newD[x.h] ? 1 : 0, ny = newD[y.h] ? 1 : 0;
            return (ny - nx) || (ratingVal(y) - ratingVal(x));
          });
          var qD = gotD[0];
          a.body.push('たとえば' + qD.t + 'でしたら、'
            + fitsColors(qD, tC).slice(0, 2).join('／') + 'がその色みです。');
          a.cards = productCards([qD]);
          ctx.shown = [qD.t];
          a.acts = pickActs([qD]).concat(a.acts);
        }
      }
      var liveD = {};
      KB.products.forEach(function (p2) {
        if (!sellable(p2)) return;
        p2.v.forEach(function (v) {
          var c = v.t.split(/\s*\/\s*/).pop().trim();
          if (c) liveD[c] = 1;
        });
      });
      var farD = Object.keys(KB.pcolor || {}).filter(function (c) {
        return liveD[c] && (KB.pcolor[c] || []).indexOf(tC) < 0;
      });
      if (farD.length) {
        a.body.push('逆に' + farD[0] + 'は、お顔から少し離れて見えることがあります。');
      }
      a.note = ['あくまで目安です。お顔映りは、その日の光の加減でも変わります'];
      if (!a.acts.length) a.acts = [['合う一枚を選んで', 'ask', '似合うものを見せてください']];
      a.next = [['合う一枚を選んで', '似合うものを見せてください'],
                ['サイズを選ぶ', 'サイズはどれがいいですか']];
      a.sources = ['商品の色', '在庫'];
      return a;
    }

    if (intent === 'upset') {
      a = A(RED, 'お怒りのお申し出');
      a.lead = 'ご不快な思いをおかけして、申し訳ありません。';
      a.body = ['こちらでお返事を書くのではなく、担当のスタッフが直接お詫びとご対応を'
                + 'いたします。下のフォームから、お困りのことをお聞かせください。'];
      a.note = ['ご返信は、通常' + r['フォームの返信'] + 'です'];
      a.acts = [['スタッフに伝える', 'form', ''],
                ['メールで知らせる', 'mail', 'up_support@halmek.co.jp']];
      a.sources = ['—（人がお答えします）'];
      a.prefill = '対応についてご相談があります。';
      return a;
    }

    /* 店として持っていないもの。**言い切れるものは言い切る**（260807にTakeへ確認済み） */
    if (intent === 'no_info') {
      var row = null;
      NO_INFO.forEach(function (x) {
        if (row) return;
        if (x.words.some(function (w) { return text.indexOf(w) >= 0; })) row = x;
      });
      if (row) {
        a = A(GREEN, row.intent);
        a.lead = row.lead;
        a.body = (row.body || []).slice();
        a.acts = (row.acts || []).slice();
        a.sources = ['店の運営（260807に確認）'];
        if (row.form) {
          a.acts = a.acts.concat([['スタッフに聞く', 'form', '']]);
          a.prefill = row.form;
        }
        return a;
      }
      /* 表に無いものは、いままでどおり人へ渡す */
      a = A(RED, 'この場ではお答えできない');
      a.lead = '申し訳ありません。この場ではお答えできないんです。';
      a.body = ['よくあるご質問にもお買い物ガイドにも載っていないので、'
                + '確かなことをお伝えできません。下のフォームからお知らせいただければ、'
                + 'スタッフがお答えします。'];
      a.note = ['ご返信は、通常' + r['フォームの返信'] + 'です'];
      a.acts = [['スタッフに聞く', 'form', '']];
      a.sources = ['—（載っていないことを確かめました）'];
      return a;
    }

    /* 人に代わってほしい、という申し出。**受け止めて渡す** */
    if (intent === 'human') {
      a = A(RED, '人にお願いしたい');
      a.lead = '承知しました。スタッフにおつなぎしますね。';
      a.body = ['お電話の窓口はご案内できないのですが、下のフォームにお書きいただければ、'
                + 'スタッフがメールでお返事します。'];
      a.note = ['ご返信は、通常' + r['フォームの返信'] + 'です'];
      a.acts = [['スタッフに聞く', 'form', ''],
                ['メールで知らせる', 'mail', 'up_support@halmek.co.jp']];
      a.sources = ['—（人がお答えします）'];
      a.prefill = raw.slice(0, 120);
      return a;
    }

    /* 「本当に涼しいですか」「安っぽくないですか」＝**私では決めかねること** */
    if (intent === 'doubt') {
      a = A(AMBER, '実物が気になる');
      a.lead = 'そこは私では決めかねるので、確かなものをお出ししますね。';
      if (prod) {
        if (prod.rv) {
          a.body.push('買った方のご感想は、5点満点で' + prod.rv + '点です（'
                      + (prod.rc || 0) + '件）。');
        }
        var dsn = prod.snaps || [];
        if (dsn.length) {
          a.body.push('着ているところの写真も、あわせてご覧ください。');
          a.snaps = dsn.slice(0, 3).filter(function (s) { return s.img; });
        }
        a.body.push('それでも思っていたのと違えば、お届けから' + r['返品できる期日']
                    + 'のあいだは返品を承ります。');
        a.acts = [['レビューを見る', 'url', '/products/' + prod.h],
                  ['スタッフに聞く', 'form', '']];
        a.sources = ['レビューの点数'].concat(dsn.length ? ['着用スナップ'] : []);
        a.prefill = prod.t + '\n実物の風合いを教えてください。';
        return a;
      }
      a.body = ['どの商品でしょうか。買った方のご感想と、着ているところの写真をご覧いただけます。'];
      ctx.pending = 'product';
      a.acts = a.acts.length ? a.acts : shownActs(ctx);
      a.sources = ['—'];
      return a;
    }

    /* 「これ、会社にも着ていけますか」＝**目の前の商品**が、その場面に向くか
       ⚠️ **場面を言われたときだけ**ここ。「どんなときに着られますか」は場面が
          1つも挙がっていないので、下の「着ていく場面を知りたい」へ落とす */
    if (intent === 'scene' && prod && tagsHere.length) {
      var yesT = tagsHere.filter(function (t) { return prod.tags.indexOf(t) >= 0; });
      var noT = tagsHere.filter(function (t) { return prod.tags.indexOf(t) < 0; });
      a = A(yesT.length ? GREEN : AMBER, 'この商品が合うか知りたい');
      if (yesT.length) {
        a.lead = prod.t + 'は、' + yesT.map(function (t) { return '「' + t + '」'; })
                 .join('と') + 'としてお出ししています。';
        var hs = [], mm, rx = /■([^\n]+)\n([^\n]+)/g;
        while ((mm = rx.exec(prod.appeal || '')) !== null) hs.push([mm[1], mm[2]]);
        var pick2 = null;
        hs.forEach(function (h) {
          if (pick2) return;
          if (yesT.some(function (t) {
            return tagWordsOf(t).some(function (w) {
              return (h[0] + h[1]).indexOf(w) >= 0; });
          })) pick2 = h;
        });
        if (pick2 && pick2[1]) a.body.push(pick2[1].slice(0, 110));
        a.sources = ['商品のタグ', '商品ページ（おすすめポイント）'];
      } else {
        /* ⚠️「向きません」と読まれないように、**印の有無の話だと分かるように書く** */
        a.lead = 'この商品には'
               + noT.map(function (t) { return '「' + t + '」'; }).join('と')
               + 'の印が付いていないんです。';
        a.body.push('私からは、印の付いたものだけをお出ししています。');
        a.sources = ['商品のタグ'];
      }
      if (noT.length) {
        var alt2 = KB.products.filter(function (p) {
          return sellable(p) && p.h !== prod.h
            && noT.every(function (t) { return p.tags.indexOf(t) >= 0; });
        });
        if (alt2.length) {
          /* ⚠️ 商品名は長い（30字超）。**1文に2つ入れると読めない** */
          a.body.push(noT.map(function (t) { return '「' + t + '」'; }).join('と')
                      + 'でしたら、こちらがございます。');
          alt2.slice(0, 2).forEach(function (p) {
            a.body.push(p.t + '／' + yen(p.p) + '円');
          });
          a.cards = productCards(alt2.slice(0, 2));
          ctx.shown = alt2.slice(0, 3).map(function (p) { return p.t; });
        }
      }
      a.acts = [productAct(prod, ctx)];
      return a;
    }

    if (intent === 'formal') {
      a = A(GREEN, '礼服・喪服をお探し');
      a.lead = '礼服・喪服のお取り扱いはございません。';
      a.body = ['Up selectでお出ししているのは、ふだん着とお出かけ着です。'
                + 'きちんと見えるものでしたら、ご一緒にお探しできますよ。'];
      a.acts = [['きちんと見えるものを見る', 'ask', 'きちんと見えるものを探しています']];
      a.sources = ['商品のタグ', 'お取り扱いの一覧'];
      return a;
    }

    /* 妊娠中に着られるかどうかは、商品ページに書かれていない。**言い切らずに人へ渡す**
       （260810・`wild_sim`33件の精査。ここだけ🟡＝私からは決めない、が結論のまま） */
    if (intent === 'pregnant') {
      if (!ctx.asked) ctx.asked = [];
      /* ⚠️ 同じことをもう一度尋ねられたら、聞き返しを繰り返さずに人へ渡す */
      if (ctx.asked.indexOf('pregnant') >= 0) {
        a = A(RED, 'うまくお答えできない');
        a.lead = 'うまくお聞き取りできず、申し訳ありません。';
        a.body = ['ここから先は、スタッフがお答えしたほうが早そうです。'
                  + '下のフォームに、いまお困りのことをそのままお書きください。'];
        a.note = ['ご返信は、通常' + r['フォームの返信'] + 'です'];
        a.acts = [['スタッフに聞く', 'form', '']];
        a.sources = ['—（人がお答えします）'];
        a.prefill = raw.slice(0, 120);
        return a;
      }
      ctx.asked.push('pregnant');
      a = A(AMBER, '妊娠中のご相談');
      a.lead = '妊娠中の方に向けたつくりではないので、私からは言い切れません。';
      a.body = ['スタッフが実物で確かめてお答えします。下のボタンからお知らせください。'];
      a.acts = [['スタッフに聞く', 'form', '']];
      a.sources = ['—'];
      return a;
    }

    if (intent === 'gift') {
      a = A(AMBER, '贈り物にしたい');
      a.lead = '贈り物ですね。お品選びは、ここでお手伝いできますよ。';
      a.body = ['ラッピングやのしについては、この場ではお答えできないので、'
                + '下のフォームからスタッフにお尋ねください。'];
      a.acts = [['ご一緒に選ぶ', 'ask', 'きちんと見えるものを探しています'],
                ['包装のことを聞く', 'form', '']];
      a.sources = ['—（包装は載っていません）'];
      a.prefill = '贈り物にしたいのですが、ラッピングやのしはできますか。';
      return a;
    }

    /* FAQに答えがあるのに届いていなかったもの */
    var DIRECT = {
      receipt: ['領収書', '領収書のこと'],
      order_change: ['変更|キャンセル', '注文の変更・キャンセル'],
      tracking: ['追跡', '荷物のいま'],
      slot: ['時間帯|指定', 'お届け日時のご指定']
    };
    if (DIRECT[intent]) {
      a = faqAnswer(text, DIRECT[intent][0], DIRECT[intent][1]);
      if (a) {
        if (intent === 'tracking') {
          a.note.push('発送のご案内メールが見あたらないときは、'
                      + '下のフォームからお知らせください');
          a.acts = [['フォームで聞く', 'form', '']];
          a.prefill = '注文した商品がまだ届きません。';
        }
        return a;
      }
      a = A(AMBER, DIRECT[intent][1]);
      a.lead = 'お答えできるところまでお伝えしますね。';
      a.body = ['詳しいところは、フォームから担当がご案内します。'];
      a.acts = [['フォームで聞く', 'form', '']];
      a.sources = ['—'];
      return a;
    }

    if (intent === 'return') {
      a = A(GREEN, '返品したい');
      /* ⚠️ 返送先を先に出さない。**受付のないお荷物が届くと注文と結びつけられない** */
      if (/返送先|送り先|どこ.{0,4}送|住所.{0,6}(教え|知り)/.test(text)) {
        a.lead = '返送先は、お手続きのご連絡のあとにお伝えしています。';
        a.body = ['先に受付をさせていただくためで、下のフォームからひとこと'
                  + 'お知らせいただければ、折り返し返送先と送り方をお伝えします。'];
        a.note = ['お届けから' + r['返品できる期日'] + 'でしたら、返品を承ります',
                  'お客様のご都合による返品は、返送の送料をご負担いただきます'];
        a.acts = [['返品をフォームで伝える', 'form', '']];
        a.sources = ['よくあるご質問', 'お買い物ガイド④'];
        a.prefill = prod ? (prod.t + '\n返品を希望します。') : '返品を希望します。';
        return a;
      }
      /* ⚠️ 聞かれたことを1行目に。「返品の送料は？」に手続きの案内から始めない */
      if (/送料|費用|自己負担|お金/.test(text)) {
        a.lead = 'お客様のご都合による返品は、返送の送料をお客様にご負担いただいています。';
        a.body = ['お届けから' + r['返品できる期日'] + 'でしたら、返品を承ります。'
                  + 'お手続きは、下のフォームからひとことお知らせいただくだけです。'];
        a.note = ['不良品・誤配送のときは、返送の送料は当店が負担いたします',
                  'ご返金は、返送品が届いてから' + r['返金の時期'] + 'です'];
        a.acts = [['返品をフォームで伝える', 'form', '']];
        a.sources = ['よくあるご質問', 'お買い物ガイド④'];
        a.prefill = prod ? (prod.t + '\n返品を希望します。') : '返品を希望します。';
        return a;
      }
      a.lead = 'かしこまりました。お届けから' + r['返品できる期日'] + 'でしたら、返品を承ります。';
      a.body = ['お手続きは、下のフォームからひとことお知らせいただくだけなんです。'
                + '折り返し、返送先と送り方をこちらからお伝えします。'];
      a.note = ['お客様のご都合による返品は、返送の送料をご負担いただきます',
                'ご使用済みのもの、試着された靴下・ショーツ類はお受けできません',
                'ご返金は、返送品が届いてから' + r['返金の時期'] + 'です'];
      a.acts = [['返品をフォームで伝える', 'form', ''],
                ['サイズ交換について相談する', 'ask', 'サイズを交換したいです']];
      a.sources = ['よくあるご質問', 'お買い物ガイド④'];
      a.prefill = prod ? (prod.t + '\n返品を希望します。') : '返品を希望します。';
      return a;
    }

    if (intent === 'exchange') {
      a = A(GREEN, 'サイズ・色を交換したい');
      a.lead = 'かしこまりました。お届けから' + r['返品できる期日'] + 'でしたら、交換も承ります。';
      a.body = ['ご希望のサイズをフォームでお知らせいただければ、在庫をお調べしてご連絡します。'];
      a.note = ['交換品は、ご返送品が届いた当日にお手続きして、翌日に発送します'];
      a.acts = [['交換をフォームで伝える', 'form', '']];
      a.sources = ['よくあるご質問', 'お買い物ガイド④'];
      a.prefill = prod ? (prod.t + '\nサイズ交換を希望します。') : 'サイズ交換を希望します。';
      return a;
    }

    /* 着たときの心配ごと。**書いてあることだけ答え、無いものは無いと言う** */
    if (intent === 'feel') {
      if (!prod) {
        /* ⚠️ FAQに答えがあるなら、まずそれを言う（聞き返しだけで終わらせない） */
        a = faqAnswer(text, '素材|透け', '素材・透け感のこと');
        if (a) {
          a.body.push('商品のページから聞いていただければ、'
                      + 'その商品の数字をそのままお出しします。');
          ctx.pending = 'product';
          a.acts = a.acts.length ? a.acts : shownActs(ctx);
          return a;
        }
        a = A(AMBER, '着たときの感じが知りたい（商品が特定できない）');
        a.lead = 'どの商品でしょうか。商品ページに書かれていることをお出しします。';
        ctx.pending = 'product';
        a.acts = a.acts.length ? a.acts : shownActs(ctx);
        a.sources = ['—'];
        return a;
      }
      var rm = radarMap(prod), told = [], missing = [];
      FEEL_MAP.forEach(function (row) {
        if (row[1].some(function (w) { return text.indexOf(w) >= 0; }) && rm[row[0]]) {
          told.push(row[0]);
        }
      });
      FEEL_UNKNOWN.forEach(function (row) {
        if (row[1].some(function (w) { return text.indexOf(w) >= 0; })) missing.push(row[0]);
      });
      if (told.length) {
        a = A(GREEN, '着たときの感じが知りたい');
        a.lead = told[0] + 'は' + rm[told[0]] + 'です。';
        /* ⚠️ **記号で並べない**（260902・Take「かたい」）。2つまで、文にして */
        var rest = radarSay(rm, told[0], 2);
        if (rest) a.body.push('あわせて、' + rest + 'です。');
        a.acts = [productAct(prod, ctx)];
        a.sources = ['商品ページ（生地の見立て）'];
        if (missing.length) {
          a.note.push(missing.join('／') + 'は、着てみないと何とも言えないところです');
        }
        return a;
      }
      if (missing.length) {
        /* ⚠️ 「商品ページに書かれていないんです」と言わない（260902・Take）。
           お客様はその商品ページをご覧になっている＝**こちら側の都合の話**。
           ⚠️ 「分かりかねます」も使わない（260902・Take「かたい」）。
              記事と同じ、やわらかい説明の言葉にする。
           ⚠️ **言えることを先に書く**。推し量って言わないのは変えない */
        a = A(AMBER, '着たときの感じ（お答えできないところ）');
        a.lead = missing.join('／') + 'は、着てみないと何とも言えないところなんです。';
        a.body = [];
        /* ⚠️ 見立ては**2つまで、文にして**書く（260902・Take「かたい」）。
           「透け感｜なし／光沢｜ややあり／…」と全部並べると機械の書き方になって読めない */
        var feelFacts = [];
        var feelMat = specLine(prod.spec || '', '素材');
        if (feelMat) feelFacts.push('素材は' + feelMat);
        ['生地の厚さ', '透け感', '伸縮性'].forEach(function (k) {
          if (feelFacts.length < 2 && rm[k]) feelFacts.push(k + 'は' + rm[k]);
        });
        /* ⚠️ 読点は2つまで（tone_check の「読点で並べすぎ」）。素直に「◯◯です」で切る */
        if (feelFacts.length) a.body.push(feelFacts.join('、') + 'です。');
        a.body.push('気になるようでしたら、スタッフが実物を見てお答えしますので、'
                    + '下のフォームからどうぞ。');
        a.acts = [['スタッフに聞く', 'form', '']];
        a.sources = ['商品ページ（生地の見立て）'];
        a.prefill = prod.t + '\n' + missing.join('／') + 'について教えてください。';
        return a;
      }
      a = A(GREEN, '着たときの感じが知りたい');
      /* ⚠️ **記号で並べない**（260902・Take「かたい」）。2つまで、文にして */
      a.lead = rm.__keys.length
        ? (radarSay(rm, '', 2) + 'です。')
        : '生地の見立ては、この下にまとめています。';
      a.acts = [productAct(prod, ctx)];
      a.sources = ['商品ページ（生地の見立て）'];
      return a;
    }

    /* 何も決まっていない人を、聞き返しで突き放さない */
    if (intent === 'popular') {
      if (wantedTags(text).length || wantedGarment(text)) {
        intent = 'find';
      } else {
        var liveP = KB.products.filter(sellable);
        /* ⚠️ 点数は**文字のまま出す**（数にすると 5.0 が 5 になってPythonとずれる） */
        var val = function (p) { return parseFloat(p.rv || 0) || 0; };
        var topP = liveP.slice().sort(function (x, y) { return val(y) - val(x); }).slice(0, 3);
        a = A(GREEN, 'おすすめを知りたい');
        a.lead = 'ご感想の点数が高いものから、3点お出ししますね。';
        topP.forEach(function (p) {
          /* ⚠️ ★**ご感想がまだ無い商品に「5点満点で点・0件」と書かない**（260909）。
             新着の一覧では3点とも実績ゼロなので、空欄のまま文になっていた */
          var got = String(p.rc || '0');
          var tail = (p.rv && got !== '' && got !== '0')
            ? ('（5点満点で' + p.rv + '点・' + got + '件）') : '';
          a.body.push(p.t + '／' + p.p + '円' + tail);
        });
        a.cards = productCards(topP);
        ctx.shown = topP.map(function (p) { return p.t; });
        a.note = ['ご感想の件数はまだ少ないので、点数はご参考までに'];
        /* ★お出しした3点を、その場で選べるようにする（選ばないと先へ進めない） */
        a.acts = pickActs(topP).concat(
          [['合う一枚を選んで', 'ask', '似合うものを見せてください']]);
        /* ★新しいものへの道を置く（260902・Take「人気のものを押すと夏物しか出ない」）。
           ⚠️ 並びは**点数の高い順のまま**。「ご感想の点数が高いものから」と言っておいて
              別の順で出したら嘘になる。新商品はご感想がまだ無いので構造的に入らない＝
              **そう申し上げたうえで、道を1本置く** */
        /* ⚠️ 一覧の面では置かない。**その一覧の外の商品を黙って出す**ことになる
           （all_sim の関所。`originals` の面で踏んだ） */
        if (newArrivals().length && !ctx.coll) {
          a.body.push('新しく入ったものは、ご感想がまだそろっていません。');
          a.acts = a.acts.concat([['新しいものを見る', 'ask', '新商品はありますか']]);
        }
        a.sources = ['レビューの点数', '在庫'];
        return a;
      }
    }

    if (intent === 'about') {
      if (prod) {
        a = A(GREEN, 'どんな商品か知りたい');
        var tAb = talkOf(prod);
        a.lead = talkHook(prod);
        /* ★オリジナル（PB）は、**その一枚の話に入る前に**そう言う（260909 Take） */
        var ogAb = originalSay(prod);
        if (ogAb) a.body.push(ogAb);
        /* ★★**その一枚の話をする**（260909・Take「PDPをなぞっただけで平坦」）。
           トークがあれば「なぜこの形か」→「秋の着方」の順。
           ⚠️ トークがあるときは pts の「／」つなぎを**出さない**＝記号で3つ並べるのは
              商品ページの書き方で、店員の言い方ではない */
        if (tAb.why || tAb.wear) {
          if (tAb.why) a.body.push(String(tAb.why));
          if (tAb.wear) a.body.push(String(tAb.wear));
        } else {
          var pts = listField(prod.pts).slice(0, 3);
          if (pts.length) a.body.push(pts.join('／') + '、といったところです。');
        }
        a.body.push(sizeLine(prod));
        if (tAb.pair && tAb.pair.handle && tAb.pair.say
            && byHandle(String(tAb.pair.handle))) {
          a.body.push(String(tAb.pair.say));
        }
        /* ★一覧から1点を選んだ直後に必ず通る。次に決めるのは**サイズか色**なので
           両方押せるようにする（色→サイズの順で進みたい人が詰まらないように） */
        a.acts = buyNextActs(prod, ctx);
        a.sources = ['商品ページ', '在庫'];
        return a;
      }
      a = A(AMBER, 'どんな商品か知りたい（商品が特定できない）');
      a.lead = 'どの商品でしょうか。';
      ctx.pending = 'product';
      a.acts = a.acts.length ? a.acts : shownActs(ctx);
      a.body = ['商品のページから聞いていただくと、そのままお出しします。'];
      a.sources = ['—'];
      return a;
    }

    /* 「60代でも大丈夫？」＝この店が自分向きかを聞かれている。**数字で答える** */
    if (intent === 'audience') {
      a = A(GREEN, '自分に合うか知りたい');
      a.lead = 'ハルメクが選んだ、大人の女性のための品ぞろえです。';
      if (prod) {
        a.body.push(sizeLine(prod));
        var hsA = (prod.staffs || []).map(function (s) { return s[0]; }).sort(
          function (x, y) { return x - y; });
        if (hsA.length) {
          a.body.push('着ているところは、身長' + hsA[0] + '〜' + hsA[hsA.length - 1]
                      + 'cmのスタッフでご覧いただけます。');
        }
        a.acts = [productAct(prod, ctx)];
      } else {
        /* ⚠️ お店のサイズ展開＝**絞る前**で数える（一覧の面でも同じ丸を出す） */
        var sz = {}, szl = [];
        allProducts().forEach(function (p) {
          p.v.forEach(function (v) {
            var m2 = v.t.match(/(3L|LL|L|M|S)/);
            if (m2 && !sz[m2[1]]) { sz[m2[1]] = 1; szl.push(m2[1]); }
          });
        });
        szl.sort(function (x, y) { return SIZES.indexOf(x) - SIZES.indexOf(y); });
        a.body.push('サイズは' + szl.join('／') + 'をご用意しています。');
        a.acts = [['合う一枚を選んで', 'ask', '似合うものを見せてください']];
      }
      a.body.push('お届けから8日以内でしたら、思っていたのと違ったときに返品も承ります。');
      a.sources = ['サイズ表', 'スタッフの着用メモ'];
      return a;
    }

    /* ふたつ並べて比べたい。**どちらがよいかは決めず、事実だけ並べる** */
    if (intent === 'compare') {
      var two = namedProducts(text).slice(0, 2);
      if (two.length === 2) {
        a = A(GREEN, 'ふたつを比べたい');
        a.lead = '並べてみますね。';
        two.forEach(function (p) {
          var bits = [yen(p.p) + '円'];
          var mt = specLine(p.spec, '素材');
          if (mt) bits.push(mt);
          var rm2 = radarMap(p);
          /* ⚠️ **記号で並べない**（260902・Take「かたい」）。2つまで */
          if (rm2.__keys.length) bits.push(radarSay(rm2, '', 2));
          a.body.push(p.t + '：' + bits.join('／'));
        });
        a.note = ['どちらがよいかは、決めずにお出ししています。'
                  + '気になるほうの実寸や着ているところも、お出しできますよ'];
        a.acts = [['1つめを見る', 'url', '/products/' + two[0].h],
                  ['2つめを見る', 'url', '/products/' + two[1].h]];
        a.sources = ['商品ページ（仕様・生地の見立て）', '値段'];
        return a;
      }
      a = A(AMBER, 'ふたつを比べたい（商品が特定できない）');
      a.lead = 'どれとどれを比べましょうか。';
      ctx.pending = 'product';
      a.acts = a.acts.length ? a.acts : shownActs(ctx);
      a.body = ['商品の名前をふたつ教えていただければ、値段と素材を並べてお出しします。'];
      a.sources = ['—'];
      return a;
    }

    if (intent === 'size') {
      if (prod) {
        a = A(GREEN, 'サイズが合うか知りたい');
        var head = (prod.fit || '').trim();
        var _me = ctx.me || {};
      var rec = recommend(prod, text, _me.color || '',
                          PICK_SIZE.test(text) ? (_me.size || '') : '');
        var hint = rec ? null : inseamHint(prod, text);

        /* 丈だけを聞かれたら、丈だけを答える（サイズ表を積み上げない） */
        var lensAll = {};
        prod.v.forEach(function (v) {
          var mg = v.t.match(/股下\d{2}/); if (mg) lensAll[mg[0]] = 1;
        });
        var lensK = Object.keys(lensAll).sort();
        if (/股下|丈は|丈が|裾|くるぶし|長さ/.test(text) && lensK.length && !rec) {
          a.intent = '丈を知りたい';
          var cm = lensK.map(function (x) { return x.replace('股下', '') + 'cm'; }).join('と');
          a.lead = lensK.length > 1 ? ('股下は' + cm + 'からお選びいただけます。')
                                    : ('股下は' + cm + 'です。');
          var sl = (prod.staffs || []).slice(0, 2);
          if (sl.length) {
            a.body.push(sl.map(function (s) {
              return s[0] + 'cmのスタッフは' + s[1]; }).join('／') + 'を着ています。');
            if (prod.staff) a.note.push(prod.staff[0] + 'cmのスタッフの声：' + prod.staff[1]);
          }
          a.acts = [productAct(prod, ctx)];
          a.sources = ['サイズ表（SKU単位）', 'スタッフの着用メモ'];
          return a;
        }

        if (rec && rec.meas && rec.meas.outside) {
          /* ⚠️ 表の範囲から外れている。**近いからと言って言い切らない** */
          a.tier = AMBER;
          a.intent = 'サイズが合うか知りたい（表の範囲外）';
          a.lead = 'お伺いした' + rec.meas.told
                 + 'ですと、サイズ表の適応範囲に入るものがございませんでした。';
          a.body.push('いちばん近いのは' + rec.size + 'で、' + rec.meas.why + 'です。');
          a.body.push('無理におすすめせずに、スタッフが実物で確かめてお答えします。'
                      + '下のフォームからお知らせください。');
          a.acts = [['スタッフに聞く', 'form', '']];
          a.sources = ['サイズ表（SKU単位）'];
          a.prefill = prod.t + '\n' + rec.meas.told + 'です。';
          return a;
        }

        if (rec && rec.variant) {
          var v0 = rec.variant;
          var pr = v0.z.slice(0, 2).map(function (x) { return x[0] + x[1]; }).join('／');
          /* ★②【選ぶ】で押された＝**受ける**（判断しない）。260810・Take */
          var pickedS = (ctx.me || {}).picked_size || '';
          /* ⚠️ normInput の NFKC で「～」が「~」に化ける。**押したボタンの字**に戻す */
          if (pickedS) {
            var flatS = pickedS.replace(/[～〜]/g, '~');
            offerSizes(prod).forEach(function (s) {
              if (s.replace(/[～〜]/g, '~') === flatS) pickedS = s;
            });
          }
          if (pickedS && PICK_SIZE.test(text)) {
            a.lead = pickedS + 'ですね。承ります。';
          } else {
            a.lead = rec.same ? (rec.size + 'で大丈夫ですよ。')
                              : (rec.size + 'をおすすめします。');
          }
          if (rec.meas) {
            a.body.push('お伺いした' + rec.meas.told + 'でしたら、' + rec.size
                        + 'の適応が' + rec.meas.why + 'です。');
          }
          a.body.push(v0.t + 'は' + pr + 'です。' + (head ? head : ''));
          a.body.push('もし合わなければ、お届けから' + r['返品できる期日']
                      + 'のあいだは交換も承ります。');
          /* ⚠️ **点数は出さない**（260809・Take）。品切れのときだけ、そう言う */
          if ((v0.s || 0) <= 0) a.note.push('いま' + v0.t + 'は品切れです');
        } else if (rec && rec.none) {
          /* ★言われたサイズのご用意が無い＝**そう言う**（同じ聞き返しを返さない） */
          /* ⚠️ ここも在庫だけで数えると、**予約できるサイズを「無い」と言う**（260909） */
          var have = usualSizes(prod);
          a.lead = '申し訳ありません。' + rec.size + 'のご用意がございません。';
          if (have.length) a.body.push('ご用意があるのは、' + have.join('／') + 'です。');
          if (have.length) {
            a.acts = have.map(function (s) {
              return [s, 'ask', 'いつも' + s + 'サイズです'];
            });
          }
          /* ⚠️ **承っていないサイズを覚えない**（260909）。覚えると以後その
             サイズで話が進み、出したばかりの丸まで「もう伺った」として消える */
          if (ctx.me && ctx.me.size === rec.size) {
            delete ctx.me.size; delete ctx.me.picked_size;
          }
          ctx.pending = 'size';
        } else if (rec && !rec.none) {
          /* ★お伺いしたサイズは**ご用意がある**が、いま品切れ。
             ⚠️ 260909に踏んだ＝**その商品が全SKU品切れ**（発売直後の入荷待ち）だと
                alt が空になってこの分岐が外れ、下の「ふだんお召しのサイズを
                教えてください」へ落ちていた＝**Mと答えた方に、直前と一言一句
                同じ聞き返し**を返す（9/9発売のブラウス・ジレ・ワンピースの3点）。
                分かれ目は「ほかに在庫があるか」ではなく「**言われたサイズが在るか**」 */
          var outV = rec.out || [];
          var dlS = '';
          prod.v.forEach(function (x) { if (!dlS && x.dl) dlS = x.dl; });
          /* ★★**予約でお求めいただけるなら、お詫びから入らない**（260909 Take）。
             お客様にとっては買えるので、「申し訳ありません。品切れなんです」は
             事実と合わない。言うのは**どうすれば買えるか**のほう */
          if (outV.some(function (v) { return v.b; })) {
            a.lead = restockNote(outV, dlS);
          } else {
            a.lead = '申し訳ありません。' + rec.size + 'はいま品切れなんです。';
            if (!rec.alt.length) a.body.push(restockNote(outV, dlS));
          }
          if (rec.alt.length) {
            a.body.push('在庫があるのは、'
              + rec.alt.map(function (x) { return x.t; }).join('／') + 'です。');
          }
        } else if (hint) {
          /* ⚠️ **身長からサイズ（太さ）は決めない**（260807の事故）。
                背丈が近いスタッフの着用は「丈の見え方の実例」としてだけ使う */
          a.lead = hint.near[0] + 'cmのスタッフは' + hint.near[1] + 'を着ています。';
          if (hint.lens.length > 1) {
            a.body.push('丈をお選びいただけますので、この着方が目安になりますよ。');
          }
          a.body.push('太さは背丈では決まらないので、'
                      + 'ふだんお召しのサイズかウエストの寸法を教えてください。'
                      + 'そこからひとつに絞ってお出しします。');
          /* ⚠️ **いちばん背丈の近い人の声**を出す（先頭の人ではない） */
          a.note.push(hint.near[0] + 'cmのスタッフの声：' + (hint.near[3] || ''));
          ctx.pending = 'size';
        } else {
          /* ⚠️ apdp_fit_head をそのまま先頭に置くと**主語が無い**ので、
             「ゆったりめのつくりです。」だけが唐突に出る（260809・Take「バグ？」） */
          /* ★**着た人の話から入る**（260909）。実測では39点とも同じ2文の案内で、
             いちばん知りたい「着るとどうか」が案内文のあとに埋もれていた */
          var svS = talkOf(prod).size_voice;
          a.lead = svS ? String(svS)
                 : (head ? ('こちらは、' + head) : '実寸でお答えしますね。');
          /* ⚠️ 聞くだけで選択肢が無いと、一瞬「？」になる（260809・Take）。
             **押せるものを出し、書いてもよいと添える** */
          a.body.push('ふだんお召しのサイズを教えていただければ、おすすめをひとつお出しします。');
          a.body.push('下のボタンでも、入力欄にお書きいただいても大丈夫です。');
          /* ★丸は**その商品にあるサイズ**（260909 Take）。店の共通で出すと、
             M〜3Lしかない商品に S、ワンピースに S・M・L… と無いサイズが並ぶ */
          var mySz = usualSizes(prod);
          if (!mySz.length) mySz = storeSizes();
          a.acts = mySz.map(function (s) {
            return [s, 'ask', 'いつも' + s + 'サイズです'];
          });
          ctx.pending = 'size';
        }

        var rows = prod.v.filter(function (v) { return v.z && v.z.length; });
        if (rec && rec.variant) {
          var g = rec.variant.t.match(/股下\d{2}/);
          if (g) {
            var f = rows.filter(function (v) { return v.t.indexOf(g[0]) >= 0; });
            if (f.length) rows = f;
          }
        }
        /* ★色ごとに割らない（260809・Take）。同じサイズなら実寸は同じ */
        /* ⚠️ サイズ表に**点数は出さない**（260809・Take）。品切れだけは言う */
        /* ⚠️ **3サイズで切らない**（260909）。M～L／LL～3L の2本立てや3L展開のある
           商品で、下のサイズの行が出ていなかった */
        /* ⚠️ ★**「（ご予約）」を行ごとに繰り返さない**（260909 Take「いちいちご予約が
           出るのがうっとうしい」）。全部のサイズが予約なら**1文でまとめて**言う。
           表は実寸を読む場所であって、在庫の状態を並べる場所ではない */
        var merged = mergeRows(rows);
        var allPre = merged.length > 0 && merged.every(function (x) {
          return (x[1] || 0) <= 0 && rows.some(function (v) {
            return sizeKey(v.t) === x[0] && canBuy(v);
          });
        });
        merged.forEach(function (x) {
          var mk = '';
          if ((x[1] || 0) <= 0 && !allPre) {
            mk = rows.some(function (v) {
              return sizeKey(v.t) === x[0] && canBuy(v);
            }) ? '（ご予約）' : '（品切れ）';
          }
          a.body.push(x[0] + '：' + x[2] + mk);
        });
        if (allPre) a.body.push('どのサイズもご予約でお求めいただけます。');
        /* ⚠️ ★**トークの一言を出したときは、同じ出どころの声を重ねない**（260909）。
           talk.size_voice はこのスタッフの声から作っているので、両方置くと
           1つの吹き出しに同じ言い回しが2回出る */
        if (prod.staff && !hint && !talkOf(prod).size_voice) {
          a.note.push(prod.staff[0] + 'cmのスタッフの声：' + prod.staff[1]);
        }
        /* ⚠️ ここで上書きすると、上で出したサイズのボタンが消える（260809に踏んだ） */
        a.acts = a.acts.concat([productAct(prod, ctx)]);
        a.sources = ['サイズ表（SKU単位）', '在庫', 'スタッフの着用メモ'];
        if (/(\d{2,3})\s*(?:kg|キロ|㎏)|体重/.test(text)) {
          /* 体重は自前で判じない。商品ページの診断へ渡す */
          a.body.push('身長と体重で選ぶサイズ診断も、この商品ページにご用意しています。');
          a.acts = [['身長・体重で診断する', 'diag', KB.diagSel]].concat(a.acts);
          a.sources.push('サイズ診断');
        }
        /* ★★表も**サイズごとに1行**にまとめる（260809・Take）。
           ⚠️ 文のほうは `mergeRows` でまとめていたのに、**表には色ごとの生の行**を
              渡していたので、同じ実寸が16行並んでいた（「股下57／M / コン」…）。
              まとめ方は文と同じ＝サイズの見出しで束ね、在庫は足し上げる */
        /* ★品切れの**色の名前だけ**を添える（260809・Take）。数は出さない。
           サイズ表は色をまとめた1行なので、これが無いと
           「Mのモカだけ品切れ」が表からは分からない */
        var seen = {}, merged = [];
        rows.forEach(function (v) {
          var k = sizeKey(v.t);
          if (!seen[k]) { seen[k] = {t: k, z: v.z, s: 0, out: []}; merged.push(seen[k]); }
          seen[k].s += Math.max(0, v.s || 0);
          if ((v.s || 0) <= 0) {
            var cn2 = v.t.split('/').pop().trim();
            if (cn2 && seen[k].out.indexOf(cn2) < 0) seen[k].out.push(cn2);
          }
        });
        a.rows = merged; a.product = prod;
        return a;
      }
      /* ★「どの商品でしょうか」で突き放さない（260809・Take「直接できんかね」）。
         ふだんのサイズを伺って、**トップスならこれ、ボトムスならこれ**と捌く */
      var meS = ctx.me || {};
      var wantS = meS.size || usualSize(text);
      if (wantS) {
        var picks = sizePicks(wantS);
        if (picks.length) {
          a = A(GREEN, 'ふだんのサイズから選ぶ');
          a.lead = 'いつも' + wantS + 'でしたら、こちらが合いそうです。';
          picks.forEach(function (x) {
            a.body.push(x[0] + 'なら ' + x[1].t + '／' + yen(x[1].p) + '円');
            var pr = x[2].z.slice(0, 3).map(function (y) {
              return y[0] + y[1];
            }).join('／');
            if (pr) a.body.push(sizeKey(x[2].t) + '：' + pr);
          });
          a.cards = productCards(picks.map(function (x) { return x[1]; }));
          ctx.shown = picks.map(function (x) { return x[1].t; });
          a.note = ['もし合わなければ、お届けから8日以内は交換も承ります'];
          /* ★選べるようにする。⚠️ここが「合う一枚を選んで」だけだと、サイズを伺ったのに
             商品が決まらないまま、また3点並ぶ */
          a.acts = pickActs(picks.map(function (x) { return x[1]; })).concat(
            [['合う一枚を選んで', 'ask', '似合うものを見せてください']]);
          a.sources = ['サイズ表（SKU単位）', '在庫'];
          return a;
        }
      }
      a = A(GREEN, 'ふだんのサイズを伺う');
      a.lead = '実寸でお答えできますよ。';
      a.body = ['ふだんお召しのサイズを教えてください。',
                '下のボタンでも、入力欄にお書きいただいても大丈夫です。',
                'トップスとボトムスから、合いそうなものをお出しします。'];
      a.acts = storeSizes().map(function (s) {
        return [s, 'ask', 'いつも' + s + 'サイズです'];
      });
      ctx.pending = 'size';
      a.sources = ['サイズ表（SKU単位）'];
      return a;
    }

    if (intent === 'store_stock') {
      a = A(GREEN, '店舗の在庫を知りたい');
      a.lead = 'Up selectは、オンラインだけのお店なんです。店舗でのお取り扱いはありません。';
      a.body = ['いまこの画面でご覧いただける在庫が、すべてになります。'];
      a.acts = [['合う一枚を選んで', 'ask', '似合うものを見せてください']];
      a.sources = ['—（EC専業）'];
      return a;
    }

    if (intent === 'delivery') {
      a = A(GREEN, 'いつ届くか知りたい');
      a.lead = '在庫のある商品は' + r['当日出荷の締め'] + 'までのご注文で当日出荷します。';
      a.body = ['お届けは、出荷日の翌日から翌々日が目安です（沖縄・離島はおよそ1週間かかります）。'];
      a.note = ['当日出荷は、翌日のお届けをお約束するものではありません'];
      a.acts = [guideAct('delivery', 'お届けの目安を詳しく見る')];
      a.sources = ['よくあるご質問', 'お買い物ガイド③'];
      return a;
    }

    if (intent === 'shipping_fee') {
      a = A(GREEN, '送料を知りたい');
      a.lead = '送料は全国一律' + r['送料'] + 'です。' + r['送料無料の条件']
             + '以上のお買い物で無料になります。';
      /* ⚠️ 飛ばすなら**該当箇所へ**（ガイドのトップに落とさない／260809・Take） */
      a.acts = [guideAct('shipping_fee', '送料を詳しく見る')];
      a.sources = ['よくあるご質問'];
      return a;
    }

    if (intent === 'color') {
      if (prod) {
        var cs = [], seen = {};
        prod.v.forEach(function (v) {
          var c = v.t.split(/\s*\/\s*/).pop().trim();
          if (!c) return;
          if (!(c in seen)) { seen[c] = cs.length; cs.push([c, 0]); }
          /* ⚠️ **お求めいただける数**であって在庫の点数ではない（260909） */
          cs[seen[c]][1] += Math.max(0, v.s || 0) || (canBuy(v) ? 1 : 0);
        });
        a = A(GREEN, '色が知りたい');
        /* ★お客様が**色を1つ言われた**なら、まずそれを受ける（260810・Take
           「オリーブを選ぶと『3色ございます』と出て、同じ応答が二回続く感じ」） */
        var pickP = saidColor(text);
        var gotP = null;
        cs.forEach(function (x) { if (x[0] === pickP) gotP = x; });
        if (gotP) {
          if (gotP[1] > 0) {
            /* ★**どんな色かを言ってから、在庫の話をする**（260909）。実測では
               「グレーはどんなグレーですか」に「グレーですね。ご用意がございます。M／L」
               と返していた＝**在庫を答えて、聞かれたことに答えていない** */
            var sayC = String((talkOf(prod).colors || {})[gotP[0]] || '');
            a.lead = sayC || (gotP[0] + 'ですね。ご用意がございます。');
            if (sayC) {
              a.body.push(gotP[0] + 'のご用意がございます。');
              a.colors = colorCards(prod).filter(function (x) {
                return x.name === gotP[0];
              });
            }
            /* ⚠️ ここは②【選ぶ】＝**その商品の表記のまま**並べ、丸も同じ表記で出す。
               店の共通（S/M/L/LL/3L）を混ぜない（260810・Take） */
            var szP = [];
            prod.v.forEach(function (v) {
              if (v.t.split(/\s*\/\s*/).pop().trim() !== gotP[0]) return;
              if (!canBuy(v)) return;
              var k = sizeKey(v.t);
              if (szP.indexOf(k) < 0) szP.push(k);
            });
            if (szP.length) {
              a.body.push('お選びいただけるのは、' + szP.join('／') + 'です。');
              a.acts = szP.map(function (s) { return [s, 'ask', s + 'にします']; });
            }
          } else {
            a.lead = '申し訳ありません。' + gotP[0] + 'はいま品切れなんです。';
            var liveP = cs.filter(function (x) { return x[1] > 0; })
                          .map(function (x) { return x[0]; });
            if (liveP.length) a.body.push('ご用意があるのは、' + liveP.join('／') + 'です。');
          }
          a.acts = a.acts.concat([productAct(prod, ctx)]);
          a.sources = ['商品の色', '在庫'];
          return a;
        }
        /* ★言われた色の**ご用意そのものが無い**なら、そう言う（260810） */
        if (pickP && cs.length) {
          /* ⚠️ 持っていない色をカルテに残さない（次の答えでその色を前提にしてしまう） */
          if (ctx.me) delete ctx.me.color;
          a.lead = '申し訳ありません。' + pickP + 'のご用意はございません。';
          a.body.push('ご用意があるのは、'
            + cs.map(function (x) { return x[0]; }).join('／') + 'です。');
          a.acts = cs.filter(function (x) { return x[1] > 0; })
                     .map(function (x) { return [x[0], 'ask', x[0] + 'はありますか']; })
                     .concat([productAct(prod, ctx)]);
          a.colors = colorCards(prod);
          a.sources = ['商品の色', '在庫'];
          return a;
        }
        a.lead = cs.length ? (prod.t + 'は' + cs.length + '色ございます。')
                           : '色のご用意をお調べしますね。';
        /* ★★**色名だけを並べない**（260909・Take）。実測では販売中39点とも
           「◯◯は◯色ございます。」の1種類で、どんな色かを1語も言えていなかった */
        var saysC = talkOf(prod).colors || {};
        Object.keys(saysC).forEach(function (c) {
          var has = false;
          cs.forEach(function (x) { if (x[0] === c) has = true; });
          if (has && saysC[c]) {
            var sv = String(saysC[c]);
            a.body.push(sv.indexOf(c) === 0 ? sv
                        : (c + 'は' + sv.replace(/^。/, '')));
          }
        });
        /* ⚠️ 色を見たい人に**残りの点数はいらない**（260809・Take）。品切れのときだけ */
        cs.forEach(function (x) {
          if (!x[1]) a.body.push(x[0] + '：品切れです');
        });
        if (cs.filter(function (x) { return x[1] > 0; }).length < cs.length) {
          a.note.push('品切れの色は、入荷の予定が決まりしだいご案内します');
        }
        /* ★色の目安を伺っていれば、その人向けの一言を足す（260809） */
        var tCol = (ctx.me || {}).ptype;
        var okCol = tCol ? fitsColors(prod, tCol) : [];
        if (okCol.length) {
          a.body.push('お伺いした色の目安でしたら、' + okCol.join('／') + 'が映えやすいです。');
        }
        /* ⚠️ 「つづけて」は決め打ちにしない＝もう答えた話を勧め直す（answer() が組む） */
        a.colors = colorCards(prod);
        a.acts = [productAct(prod, ctx)];
        a.sources = ['商品の色', '在庫'];
        return a;
      }
      a = A(AMBER, '色が知りたい（商品が特定できない）');
      a.lead = 'どの商品でしょうか。色と在庫をその場でお出しします。';
      ctx.pending = 'product';
      a.acts = a.acts.length ? a.acts : shownActs(ctx);
      a.sources = ['—'];
      return a;
    }

    /* ★丈（股下）を伺う・お答えする（260810・`all_sim`。route.py の同じ場所と対）。
       ⚠️ サイズと色が決まっても、パンツは股下57／62のように丈が残る。
          伺わずに先頭の丈をカートに入れていた＝お客様が選んでいないものが入る */
    if (intent === 'length') {
      if (prod) {
        var lsL = lengthList(prod);
        if (lsL.length) {
          a = A(GREEN, '丈が知りたい');
          var wantL = (ctx.me || {}).length;
          var namesL = lsL.map(function (x) { return x[0]; });
          if (wantL && namesL.indexOf(wantL) >= 0) {
            /* ⚠️ 決まったあとに一覧をもう一度並べない（選んだのに迷わせる） */
            a.lead = wantL + 'でお承りしますね。';
            a.body.push(sizeLine(prod));
          } else {
            a.lead = lsL.length > 1
              ? (prod.t + 'は、丈が' + lsL.length + '種類ございます。')
              : ('丈は' + lsL[0][0] + 'の1種類です。');
            lsL.forEach(function (x) {
              a.body.push(x[0] + '：' + (x[1] ? 'ご用意があります' : '品切れです'));
            });
          }
          if (lsL.length > 1 && !wantL) {
            a.acts = lsL.filter(function (x) { return x[1]; })
                        .map(function (x) { return [x[0], 'ask', x[0] + 'がいいです']; });
          }
          a.acts = a.acts.concat([productAct(prod, ctx)]);
          a.sources = ['商品の丈', '在庫'];
          return a;
        }
        a = A(GREEN, '丈が知りたい');
        a.lead = prod.t + 'は、丈のお選びはございません。';
        a.body = [sizeLine(prod)];
        a.acts = [productAct(prod, ctx)];
        a.sources = ['商品ページ', '在庫'];
        return a;
      }
      a = A(AMBER, '丈が知りたい（商品が特定できない）');
      a.lead = 'どの商品でしょうか。丈のご用意をその場でお出しします。';
      ctx.pending = 'product';
      a.acts = a.acts.length ? a.acts : shownActs(ctx);
      a.sources = ['—'];
      return a;
    }

    if (intent === 'review') {
      if (prod && prod.rv) {
        a = A(GREEN, '評判が知りたい');
        a.lead = prod.t + 'は、5点満点で' + prod.rv + '点です（' + prod.rc + '件）。';
        a.body = ['お寄せいただいたご感想は、商品ページでご覧いただけます。'];
        /* ⚠️ いま見ている商品なら、同じ面へ飛ばさない（page_sim が検知） */
        a.acts = [productAct(prod, ctx)];
        a.sources = ['レビューの点数'];
        return a;
      }
      a = A(AMBER, '評判が知りたい');
      a.lead = 'お客様のご感想は、商品ページでご覧いただけます。';
      a.body = ['どの商品か教えていただければ、点数をお出しします。'];
      ctx.pending = 'product';
      a.acts = a.acts.length ? a.acts : shownActs(ctx);
      a.sources = ['—'];
      return a;
    }

    if (intent === 'together') {
      if (prod && prod.together && prod.together.length) {
        a = A(GREEN, '一緒に買うものを知りたい');
        a.lead = prod.t + 'に合わせるなら、こちらはいかがでしょう。';
        prod.together.slice(0, 3).forEach(function (t) {
          a.body.push(t.title + ((t.stock || 0) <= 0 ? '（いまはご予約となります）' : ''));
        });
        /* 写真でお出しする。**名前だけ並べても、合うかどうかは分からない** */
        /* ⚠️ 一緒に買うものは**商品側で決めてある組み合わせ**。一覧の面で絞ると
           その一覧に無い相方が静かに消える＝**絞る前**で引く（260810） */
        var byname = {};
        allProducts().forEach(function (p) { byname[p.t] = p; });
        var tog = prod.together.slice(0, 3)
          .filter(function (t) { return byname[t.title]; })
          .map(function (t) { return byname[t.title]; });
        a.cards = productCards(tog);
        /* ★行き先は**お出しした商品**。いま見ている商品へ戻さない（260809・Take） */
        a.acts = tog.map(function (p) {
          return [p.t.replace(/【.*?】/g, '').trim().slice(0, 14) + 'を見る',
                  'url', '/products/' + p.h];
        });
        a.sources = ['一緒に購入されている組み合わせ'];
        return a;
      }
      a = A(AMBER, '一緒に買うものを知りたい');
      a.lead = 'どの商品に合わせましょうか。';
      ctx.pending = 'product';
      a.acts = a.acts.length ? a.acts : shownActs(ctx);
      a.body = ['商品の名前を教えていただければ、相性のよいものをお出しします。'];
      a.sources = ['—'];
      return a;
    }

    if (intent === 'why') {
      var enW = (prod && prod.en) || {};
      var tW = talkOf(prod);
      if (prod && (enW.title || tW.why)) {
        a = A(GREEN, '選んだ理由を知りたい');
        /* ★編集部の語りがある29点はそれを、無い商品（毎週の新商品）はトークを使う。
           ⚠️ 260909まで、editors_note の無い秋10点は「商品ページに、編集部が選んだ
              理由を書いています」に落ちていた＝**その商品ページから話しかけている人に**
              言う言葉ではない */
        /* ⚠️ ★**「商品の魅力」と同じ出だしにしない**（260909）。about は hook から
           入るので、why も hook で始めると2つの答えがほとんど同じに見える */
        a.lead = enW.title ? enW.title.replace(/\n/g, ' ')
               : (String(tW.why || '') || talkHook(prod));
        var ogW = originalSay(prod);
        if (ogW && !sharesPhrase(a.lead, ogW, 6)) a.body.push(ogW);
        if (enW.title && tW.why && !echoes(a.lead, String(tW.why))) {
          a.body.push(String(tW.why));
        } else if (enW.body0) a.body.push(enW.body0);
        else if (tW.wear) a.body.push(String(tW.wear));
        if (enW.staff) a.note.push(enW.staff);
        a.acts = [productAct(prod, ctx)];
        a.sources = enW.title ? ['編集部のおすすめポイント'] : ['商品ページ'];
        return a;
      }
      a = A(AMBER, '選んだ理由を知りたい');
      a.lead = 'どの商品のことでしょうか。';
      a.body = ['商品の名前を教えていただければ、選んだ理由をお伝えします。'];
      ctx.pending = 'product';
      a.acts = a.acts.length ? a.acts : shownActs(ctx);
      a.sources = ['—'];
      return a;
    }

    if (intent === 'restock') {
      if (prod) {
        var out0 = prod.v.filter(function (v) { return (v.s || 0) <= 0; });
        var dl = null;
        for (var q = 0; q < prod.v.length; q++) {
          if (prod.v[q].dl) { dl = prod.v[q].dl; break; }
        }
        a = A(GREEN, '入荷を知りたい');
        /* ⚠️ お客様が言ったサイズを見ずに全体で答えると「見間違いです」に読める */
        var ask0 = text.match(/(?:^|[^A-Za-z0-9])(3L|LL|L|M|S)(?:サイズ|[^A-Za-z0-9]|$)/);
        var askedV = [];
        if (ask0) {
          /* ⚠️ ここも**幅のあるサイズ（M～L）**に当てる（260810） */
          askedV = prod.v.filter(function (v) { return hasSize(v, ask0[1]); });
        }
        if (askedV.length) {
          var outA = askedV.filter(function (v) { return (v.s || 0) <= 0; });
          if (outA.length) {
            /* ⚠️ ★**在庫0を「品切れ」と言い切らない**（260909）。予約でお求めいただける
               なら直後に「ご予約いただけます」と続くので、1つの吹き出しで前後が食い違う */
            /* ⚠️ 在庫の事情は言わない。**ご予約で買えることだけ**を言う */
            if (outA.every(canBuy)) {
              a.lead = ask0[1] + 'は、ご予約を承っています。';
            } else {
              a.lead = ask0[1] + 'は、いま品切れなんです。';
              a.body.push('品切れ：' + outA.slice(0, 4).map(function (v) { return v.t; }).join('／'));
            }
          } else {
            /* ⚠️ **点数は出さない**（260809・Take）。あるか無いかだけ */
            a.lead = ask0[1] + 'は、いまご用意がございます（'
              + askedV.slice(0, 3).map(function (v) {
                  return v.t; }).join('／') + '）。';
          }
          if (out0.length && !outA.length && !out0.every(canBuy)) {
            a.body.push('品切れ：' + out0.slice(0, 4).map(function (v) { return v.t; }).join('／'));
          }
          a.body.push(restockNote(outA.length ? outA : out0, dl));
        } else if (!out0.length) {
          a.lead = prod.t + 'は、いまどのサイズもご用意がございます。';
        } else {
          if (out0.every(canBuy)) {
            a.lead = 'ご予約でお求めいただけるサイズがございます。';
          } else {
            a.lead = '品切れのサイズがございます。';
            a.body.push('品切れ：' + out0.slice(0, 4).map(function (v) { return v.t; }).join('／'));
          }
          a.body.push(restockNote(out0, dl));
        }
        a.acts = [productAct(prod, ctx)];
        a.sources = ['在庫', '予約の可否'];
        return a;
      }
      var rh = KB.faq.filter(function (f) { return f.q.indexOf('再入荷') >= 0; });
      a = A(rh.length ? GREEN : AMBER, '入荷を知りたい');
      a.lead = rh.length ? (rh[0].a.split('。')[0] + '。')
                         : '入荷の予定は、商品ページでご案内しています。';
      a.sources = rh.length ? ['よくあるご質問「' + rh[0].q + '」'] : ['—'];
      return a;
    }

    if (intent === 'price') {
      if (prod) {
        a = A(GREEN, '値段が知りたい');
        a.lead = prod.t + 'は' + yen(prod.p) + '円（税込）です。';
        a.body = ['送料は全国一律' + r['送料'] + '、' + r['送料無料の条件']
                  + '以上のお買い物で無料になります。'];
        /* ⚠️ **点数は出さない**（260809・Take）。売り切れのときだけ、そう言う。
           ⚠️ ★**在庫0＝品切れ、ではない**（260909・Take「入荷あと1-4日発送なのに
              品切れがでる」）。毎週5点が在庫0で発売されるので、点数で見ると
              **発売当日にいちばん売りたい5点で「いまは品切れです」と言う** */
        if (!sellable(prod)) a.note = ['いまは品切れです'];
        else if ((prod.s || 0) <= 0) a.note = [preorderNote(prod)];
        a.acts = [productAct(prod, ctx)];
        a.sources = ['商品の値段', 'よくあるご質問'];
        return a;
      }
      a = A(AMBER, '値段が知りたい（商品が特定できない）');
      a.lead = '商品の名前を教えていただければ、お値段をお出しします。';
      ctx.pending = 'product';
      a.acts = a.acts.length ? a.acts : shownActs(ctx);
      a.sources = ['—'];
      return a;
    }

    if (intent === 'care') {
      if (prod) {
        var care = specLine(prod.spec, 'ケア方法');
        if (care) {
          a = A(GREEN, 'お手入れの仕方');
          a.lead = care + 'です。';
          var mat0 = specLine(prod.spec, '素材');
          if (mat0) a.body.push('素材は' + mat0 + 'です。');
          if ((prod.marks || '').indexOf('洗える') >= 0) a.note.push('ご家庭で洗えます');
          a.acts = [productAct(prod, ctx)];
          a.sources = ['商品ページ（仕様・ケア方法）'];
          return a;
        }
      }
      a = A(AMBER, 'お手入れの仕方');
      a.lead = 'お手入れの目安は、商品ページの「仕様」に載せています。';
      a.body = ['どの商品か教えていただければ、その場でお伝えします。'];
      a.sources = ['—'];
      return a;
    }

    /* ★装い以外のお話＝受け止めて、装いへ戻す（route.CHAT と同じ）。
       ⚠️ 服の言葉が混じっていたら、装いのお尋ね。ここでは受けない */
    if (intent === 'chat') {
      if (/着|服|サイズ|コーデ|丈|素材/.test(text)) {
        intent = 'unknown';
      } else {
        var row = null;
        for (var ci = 0; ci < CHAT.length; ci++) {
          if (CHAT[ci].words.some(function (w) { return text.indexOf(w) >= 0; })) {
            row = CHAT[ci]; break;
          }
        }
        if (!row) row = CHAT[CHAT.length - 1];
        a = A(GREEN, row.intent);
        a.lead = row.lead;
        a.body = row.body.slice();
        a.acts = row.acts.map(function (x) { return x.slice(); });
        a.sources = ['—'];
        return a;
      }
    }

    /* ★お店のこと＝何を大事に選んでいるお店かを、お店の面から取って答える（260809） */
    if (intent === 'shop') {
        var sl = shopLines();
        if (sl.length) {
          a = A(GREEN, 'お店のこと');
          a.lead = shopLead();
          a.body = sl;
          a.acts = [['はじめての方へ', 'url', '/pages/about'],
                    ['合う一枚を選んで', 'ask', '似合うものを見せてください']];
          a.sources = ['はじめての方へ（お店のご紹介）'];
          return a;
        }
        a = A(AMBER, 'お店のこと');
        a.lead = 'お店のご紹介は、こちらのページにまとめています。';
        a.acts = [['はじめての方へ', 'url', '/pages/about']];
        a.sources = ['—'];
        return a;
    }

    /* ★着ていく場面＝どういうところに着ていけるか。合わせ方とは別に答える（260809） */
    if (intent === 'scene') {
      /* ★★**場面ごとに言うことを変える**（260909・Take「着たいシーンとかも一辺倒」）。
         実測＝お出かけ・お仕事・あらたまった日が**同じ商品・同じ文**に落ちていた。
         秋はタグが「きちんと見え」「一枚で決まる」の2つに畳まれるので、タグでは
         場面を分けられない。**トークの scenes がその分かれ目を持つ** */
      var tSc = (talkOf(prod).scenes) || {};
      if (prod && Object.keys(tSc).length) {
        a = A(GREEN, '着ていく場面を知りたい');
        var saidSc = (sceneOf(text)[0] || (ctx.me && ctx.me.scene) || '');
        var ksSc = Object.keys(tSc);
        if (saidSc && tSc[saidSc]) {
          a.lead = String(tSc[saidSc]);
          var otherSc = ksSc.filter(function (k) { return k !== saidSc; });
          if (otherSc.length && !echoes(a.lead, String(tSc[otherSc[0]]))) {
            a.body.push(String(tSc[otherSc[0]]));
          }
        } else if (saidSc) {
          /* ⚠️ ★**聞かれた場面を持っていないのに、別の場面の文を出さない**（260909。
             「旅行に着られますか」に、お仕事の着方を答えていた） */
          a.lead = saidSc + 'については、はっきりとは申し上げられないのですが、'
                 + ksSc.slice(0, 2).join('／') + 'でしたらお使いいただけます。';
          a.body.push(String(tSc[ksSc[0]]));
        } else {
          a.lead = String(tSc[ksSc[0]]);
          if (ksSc.length > 1 && !echoes(a.lead, String(tSc[ksSc[1]]))) {
            a.body.push(String(tSc[ksSc[1]]));
          }
          a.body.push('お召しいただける場面：' + ksSc.slice(0, 3).join('／'));
        }
        a.acts = [productAct(prod, ctx)];
        if ((prod.snaps || []).length) {
          a.snaps = prod.snaps.slice(0, 2).filter(function (x) { return x.img; });
        }
        a.sources = ['商品ページ', '商品のタグ'];
        return a;
      }
      if (prod && prod.appeal) {
        var sh = [], re3 = /■([^\n]+)\n([^\n]+)/g, m3;
        while ((m3 = re3.exec(prod.appeal))) sh.push([m3[1], m3[2]]);
        var sp = sceneBlocks(sh);
        if (sp.length) {
          a = A(GREEN, '着ていく場面を知りたい');
          var stalk = toTalk(sp[0][0]);
          if (stalk) {
            a.lead = stalk;
            if (sp[0][1]) a.body.push(sp[0][1].slice(0, 110));
          } else {
            var sparts = (sp[0][1] || '').split('。')
              .filter(function (x) { return x.trim(); });
            a.lead = sparts.length ? (sparts[0] + '。') : 'こんな場面でお召しいただけます。';
            if (sparts.length > 1) {
              a.body.push(sparts.slice(1).join('。').slice(0, 110) + '。');
            }
          }
          /* ⚠️ **同じ言い回しが重なるなら2つめは出さない**（260902）。
             「〜と合わせれば」が2つ並ぶ（商品ページの文なのでこちらでは直せない） */
          var firstSay = a.body.length ? a.body[a.body.length - 1] : a.lead;
          if (sp.length > 1 && sp[1][1] && !echoes(firstSay, sp[1][1])) {
            a.body.push(sp[1][1].slice(0, 110));
          }
          var snames = sceneNames(sp);
          if (snames.length) {
            /* ⚠️ 「商品ページに書かれている場面」と言わない（260902・Take）。
               お客様はその商品ページをご覧になっている */
            a.note.push('お召しいただける場面：' + snames.slice(0, 4).join('／'));
          }
          a.acts = [productAct(prod, ctx)];
          a.sources = ['商品ページ（おすすめポイント）'];
          return a;
        }
        /* ★紹介文に場面が書かれていなくても、**タグから場面は言える**（260902・Take） */
        var ways = sceneFromTags(prod);
        if (ways.length) {
          a = A(GREEN, '着ていく場面を知りたい');
          a.lead = ways.join('や') + 'に、ちょうどよい一枚です。';
          a.body = ['着ているところの写真もありますので、合わせ方の目安にどうぞ。'];
          a.acts = [['着用・コーデ例', 'ask', '合わせ方を教えて'], productAct(prod, ctx)];
          a.sources = ['商品のタグ'];
          return a;
        }
        /* ⚠️ 「商品ページに書かれていないんです」「決めておりません」と言わない
           （260902・Take）。お客様はその商品ページをご覧になっている */
        a = A(AMBER, '着ていく場面を知りたい');
        a.lead = '着ているところの写真から見ていただくのが、いちばん早そうです。';
        a.body = ['合わせ方の目安になりますよ。'];
        a.acts = [['着用・コーデ例', 'ask', '合わせ方を教えて']];
        a.sources = ['—'];
        return a;
      }
      a = A(AMBER, '着ていく場面を知りたい');
      a.lead = 'どの商品でしょうか。商品ごとに、着ていける場面をお伝えできます。';
      ctx.pending = 'product';
      a.acts = a.acts.length ? a.acts : shownActs(ctx);
      a.sources = ['—'];
      return a;
    }

    if (intent === 'styling') {
      /* ★★**合わせる相手を言う**（260909）。実測では本文が「シルエットは標準。」など
         手ざわりの読み上げで終わっていて、**何と合わせるかを1点も言っていなかった**。
         相手は実注文の併買（together）にあるものだけ＝トークの関所が見ている */
      var tSt = talkOf(prod);
      if (prod && (tSt.wear || tSt.pair)) {
        a = A(GREEN, '合わせ方を知りたい');
        a.lead = String(tSt.wear || talkHook(prod));
        /* ⚠️ ★**一覧の面では、その面の外の商品をカードで出さない**（260909に all_sim が
           捕まえた）。KB.products はコレクションの面では絞られているので、
           byHandle が返さない＝ここで自動的に落ちる */
        var mateSt = (tSt.pair && tSt.pair.handle)
          ? byHandle(String(tSt.pair.handle)) : null;
        if (mateSt && ctx.coll) {
          var inColl = KB.products.some(function (q) { return q.h === mateSt.h; });
          if (!inColl) mateSt = null;
        }
        if (mateSt && tSt.pair.say) {
          /* ⚠️ **同じ言い回しが重なるなら、文は出さずカードだけにする**（260909）。
             wear と pair.say はどちらも「◯◯を合わせると」で書かれやすい */
          if (!echoes(a.lead, String(tSt.pair.say))
              && !sharesPhrase(a.lead, String(tSt.pair.say))) {
            a.body.push(String(tSt.pair.say));
          }
          a.cards = productCards([prod, mateSt]);
        }
        /* ⚠️ ★相手の一言を出したなら、レーダー由来の「シルエットは標準。」は足さない */
        if (!(mateSt && tSt.pair && tSt.pair.say)) a.body.push(dressNote(prod));
        var snSt = prod.snaps || [];
        if (snSt.length) {
          a.note.push('着ているところ：' + snSt.slice(0, 3)
            .map(function (x) { return x.txt || ''; })
            .filter(function (x) { return x; }).join('／'));
          a.snaps = snSt.slice(0, 3).filter(function (x) { return x.img; });
        }
        a.acts = [productAct(prod, ctx)];
        a.sources = ['商品ページ']
          .concat(mateSt ? ['一緒に購入されている組み合わせ'] : [])
          .concat(snSt.length ? ['着用スナップ'] : []);
        return a;
      }
      if (prod && prod.appeal) {
        a = A(GREEN, '合わせ方を知りたい');
        /* ⚠️「見出し：本文」を3つ並べるのはAIの書き方。合わせ方の段だけを選び、
           見出しは語りかけに変えて1行目に置く（鳥井トーン 1・1b・1d） */
        var heads = [], re2 = /■([^\n]+)\n([^\n]+)/g, m2;
        while ((m2 = re2.exec(prod.appeal))) heads.push([m2[1], m2[2]]);
        var pick = bestDressBlock(heads);
        var talk = toTalk(pick[0]);
        if (talk) {
          a.lead = talk;
          if (pick[1]) a.body.push(pick[1].slice(0, 110));
        } else {
          var parts = (pick[1] || '').split('。').filter(function (x) { return x.trim(); });
          a.lead = parts.length ? (parts[0] + '。') : '合わせ方をお伝えしますね。';
          if (parts.length > 1) a.body.push(parts.slice(1).join('。').slice(0, 110) + '。');
        }
        a.body.push(dressNote(prod));
        var snaps = prod.snaps || [];
        if (snaps.length) {
          a.note.push('着ているところ：' + snaps.slice(0, 3)
            .filter(function (s) { return s.txt; })
            .map(function (s) { return s.txt; }).join('／'));
          a.snaps = snaps.slice(0, 3).filter(function (s) { return s.img; });
        }
        a.acts = [productAct(prod, ctx)];
        a.sources = ['商品ページ（おすすめポイント）'].concat(snaps.length ? ['着用スナップ'] : []);
        return a;
      }
      a = A(AMBER, '合わせ方を知りたい');
      a.lead = 'どの商品でしょうか。商品ごとに合わせ方をお伝えできます。';
      ctx.pending = 'product';
      a.acts = a.acts.length ? a.acts : shownActs(ctx);
      a.sources = ['—'];
      return a;
    }

    if (intent === 'originals') {
      var og = originalsList();
      a = A(GREEN, 'オリジナルのご案内');
      if (!og.length) {
        /* ⚠️ 無いときは言い切る。**「ございます」と言って出せない**をしない */
        a.lead = 'いまお出しできるものがございません。';
        a.acts = [['人気のものを見る', 'ask', '人気のものはどれですか'],
                  ['新しく入ったものを見る', 'ask', '新商品はありますか']];
        a.sources = ['オリジナル'];
        return a;
      }
      a.lead = 'Up select オリジナルでしたら、こちらです。';
      og.slice(0, 5).forEach(function (p) { a.body.push(p.t + '／' + yen(p.p) + '円'); });
      a.cards = productCards(og.slice(0, 5));
      ctx.shown = og.slice(0, 5).map(function (p) { return p.t; });
      a.acts = pickActs(og, 3)
        .concat([['オリジナルをぜんぶ見る', 'url', '/collections/' + ORIG_COLL]]);
      a.sources = ['オリジナル', '在庫'];
      return a;
    }

    if (intent === 'term') {
      /* ★言葉を説明してから、使っている商品をお出しする（260902）。
         ⚠️ 言ってよい言い方は決まっている＝素材名「超熟綿」と「長時間浴びて熟成」。
            **収穫までの年数など数字は出さない／「オリジナル素材」とは呼ばない** */
      /* ★★**その商品の記事が説明している言葉なら、その説明を使う**（260909）。
         ⚠️ 用語の辞書を手で持たない＝毎週新しい言葉が入るので必ず置いていかれる */
      var poolT = (prod ? [prod] : []).concat(KB.products.filter(sellable));
      for (var ti = 0; ti < poolT.length; ti++) {
        var tms = talkOf(poolT[ti]).terms || {};
        var wds = Object.keys(tms);
        for (var wi = 0; wi < wds.length; wi++) {
          if (wds[wi] && text.indexOf(wds[wi]) >= 0) {
            a = A(GREEN, '言葉のご説明');
            a.lead = String(tms[wds[wi]]);
            if (poolT[ti] !== prod || !prod) {
              a.body.push('この形でしたら、' + poolT[ti].t + 'がございます。');
              a.cards = productCards([poolT[ti]]);
              ctx.shown = [poolT[ti].t];
            }
            a.acts = prod ? [productAct(prod, ctx)] : pickActs([poolT[ti]]);
            a.sources = ['商品ページ'];
            return a;
          }
        }
      }
      if (text.indexOf('超熟綿') < 0) {
        /* 言葉の説明が無いときは、聞き返さずに**その一枚の話へ戻す** */
        if (prod) {
          a = A(GREEN, '見ているものについて受ける');
          a.lead = talkHook(prod);
          var t2T = talkOf(prod);
          if (t2T.why) a.body.push(String(t2T.why));
          a.acts = buyNextActs(prod, ctx);
          a.sources = ['商品ページ'];
          return a;
        }
        a = A(GREEN, 'どんなときに着るかを伺う');
        a.lead = '承知しました。';
        a.body = ['どんなときにお召しになりたいか、教えていただけますか。',
                  'そのうえで、合いそうなものをお出しします。'];
        a.acts = [['お出かけに', 'ask', 'お出かけに着たいです'],
                  ['お仕事に', 'ask', '仕事に着ていきたいです'],
                  ['ふだん着に', 'ask', 'ふだん着に着たいです'],
                  ['旅行に', 'ask', '旅行に着たいです']];
        ctx.pending = 'scene';
        a.sources = ['商品のタグ'];
        return a;
      }
      a = A(GREEN, '言葉のご説明');
      a.lead = '「超熟綿」は、長い時間をかけて熟成させた綿のことです。';
      var tm = KB.products.filter(function (p) {
        return sellable(p) && nameHay(p).indexOf('超熟綿') >= 0;
      });
      if (!tm.length) {
        a.body.push('いまお出ししているものには、使っておりません。');
        a.acts = [['人気のものを見る', 'ask', '人気のものはどれですか']];
        a.sources = ['商品ページ'];
        return a;
      }
      a.body.push('この素材を使っているのは、こちらです。');
      tm.slice(0, 5).forEach(function (p) { a.body.push(p.t + '／' + yen(p.p) + '円'); });
      a.cards = productCards(tm.slice(0, 5));
      ctx.shown = tm.slice(0, 5).map(function (p) { return p.t; });
      a.acts = pickActs(tm, 3);
      a.sources = ['商品ページ', '在庫'];
      return a;
    }

    /* ★★「いつまで着られますか」＝**その一枚の話**（260909 Take）。実測では
       「冬まで着られますか」に店ぜんぶの新着一覧を返していて「秋の通勤と同じ回答で
       答えになってない」と言われた。⚠️ **季節を決めつけない**＝言えるのは
       商品ページに書いてある事実（袖丈・生地の厚さ・素材・重ね着の話）だけ */
    if (intent === 'span') {
      if (prod) {
        a = A(GREEN, 'いつまで着られるか');
        var twSp = talkOf(prod), factsSp = [];
        if (prod.slv) factsSp.push('袖丈は' + prod.slv + 'cm');
        var thSp = thicknessOf(prod);
        if (thSp) factsSp.push('生地の厚さは' + thSp);
        var matSp = specLine(prod.spec, '素材');
        if (matSp && factsSp.length < 2) factsSp.push('素材は' + matSp);
        a.lead = twSp.wear ? String(twSp.wear)
                           : '重ね方しだいで、着ていただける時期は変わります。';
        if (factsSp.length) a.body.push(factsSp.slice(0, 2).join('、') + 'です。');
        a.body.push('そのうえで、寒くなってからは下に一枚足していただくのが目安です。');
        a.note = ['気温の感じ方には個人差があるので、目安としてご覧ください'];
        a.acts = buyNextActs(prod, ctx);
        a.sources = ['商品ページ', 'サイズ表（SKU単位）'];
        return a;
      }
      a = A(AMBER, 'いつまで着られるか（商品が特定できない）');
      a.lead = 'どの商品のことでしょうか。';
      a.body = ['商品の名前を教えていただければ、袖丈や生地の厚さからお答えします。'];
      ctx.pending = 'product';
      a.acts = a.acts.length ? a.acts : shownActs(ctx);
      a.sources = ['—'];
      return a;
    }

    if (intent === 'newarrival' || intent === 'season') {
      /* ★新しく入ったもののお尋ねと、季節・気温のご相談は**同じ棚から**お出しする。
         お店に季節のタグは無いので、いま並べている「新着アイテム」の面がそれにあたる。
         ⚠️ 文面に季節の名前を焼き込まない（12月に「秋物」と言い出す道具にしない）。
            9月から12月まで毎週アイテムが足されるので、**面が入れ替われば答えも変わる** */
      var naSeason = intent === 'season';
      /* ★★**その商品ページで季節を聞かれたら、その一枚の話をする**（260909）。
         実測では「冬も着られますか」に、店ぜんぶの新着一覧を返していた */
      if (naSeason && prod && !wantedGarment(text)) {
        var twS = talkOf(prod);
        if (twS.wear) {
          a = A(GREEN, '季節の変わり目のご相談');
          a.lead = String(twS.wear);
          var factsS = [];
          if (prod.slv) factsS.push('袖丈は' + prod.slv + 'cm');
          var thS = thicknessOf(prod);
          if (thS) factsS.push('生地の厚さは' + thS);
          if (factsS.length) a.body.push(factsS.join('、') + 'です。');
          a.acts = buyNextActs(prod, ctx);
          a.sources = ['商品ページ', 'サイズ表（SKU単位）'];
          return a;
        }
      }
      var na = newArrivals();
      a = A(GREEN, naSeason ? '季節の変わり目のご相談' : '新しく入ったものを知りたい');
      if (!na.length) {
        /* ⚠️ 無いときは言い切る。**「新着があります」と言って出せない**をしない */
        a.lead = naSeason ? 'いまお出しできるものから、お探ししますね。'
                          : 'いまのところ、新しく入ったもののご案内はございません。';
        a.acts = [['人気のものを見る', 'ask', '人気のものはどれですか'],
                  ['合う一枚を選んで', 'ask', '似合うものを見せてください']];
        a.sources = ['新着アイテム'];
        return a;
      }
      /* ★これからの季節は、**袖のあるもの・厚めのもの**を先にお出しする（実データ）。
         ⚠️ 「秋」「冬」と決めつけない＝袖丈と生地の厚さは商品ページに書いてある事実 */
      if (naSeason) {
        /* ⚠️ **オリジナルを先に**（260902・Take）。袖丈だけで並べると、いちばん見せたい
           超熟綿プルオーバー（袖丈48）が4番目に落ち、**押せる丸（先頭3点）から外れていた** */
        var naOrig = {};
        collItems(ORIG_COLL).forEach(function (p) { naOrig[p.h] = 1; });
        na = na.slice().sort(function (x, y) {
          var ox = naOrig[x.h] ? 1 : 0, oy = naOrig[y.h] ? 1 : 0;
          if (ox !== oy) return oy - ox;
          var sx = sleeveOf(x) || 0, sy = sleeveOf(y) || 0;
          if (sx !== sy) return sy - sx;
          var tx = thicknessOf(x) === '厚め' ? 1 : 0;
          var ty = thicknessOf(y) === '厚め' ? 1 : 0;
          return ty - tx;
        });
      }
      /* ★★**場面を言われていたら、そこで絞る**（260909 Take「秋の通勤に着られるものは」
         に通勤を無視して新着5点を並べていた＝「答えになってない」） */
      var scP2 = sceneOf(text), scSay = '';
      if (naSeason && scP2[1]) {
        var naNarrow = na.filter(function (p) {
          return (p.tags || []).indexOf(scP2[1]) >= 0;
        });
        if (naNarrow.length) {
          na = naNarrow;
          scSay = scP2[0] + 'でしたら、入ったばかりのものからお出ししますね。';
        } else {
          scSay = scP2[0] + 'に向くものは、新しく入ったものの中には見当たりません'
                + 'でした。これからの季節のものをお出ししますね。';
        }
      }
      /* ★品種を言われていれば、新着の中で絞る（「涼しくなってきたので羽織れるもの」）。
         ⚠️ 絞って0点なら**黙って戻さず**、そう申し上げてから全部お出しする */
      var naG = wantedGarment(text);
      var naOnly = [];
      if (naG) {
        var naWs = GARMENT_IN_TITLE[naG];
        naOnly = na.filter(function (p) {
          return naWs.some(function (w) { return titleCore(p).indexOf(w) >= 0; });
        });
      }
      var naDay = arrivalDay(na);
      if (naOnly.length) {
        a.lead = naDay
          ? (naSeason ? ('これからの季節でしたら、こちらの' + naG + 'はいかがでしょう。')
                      : (naDay + 'に入ったばかりの' + naG + 'でしたら、こちらです。'))
          : ('新しく入った' + naG + 'でしたら、こちらです。');
        na = naOnly;
      } else if (naSeason) {
        if (naG) a.body.push('いまお出ししているものに' + naG + 'はございません。');
        /* ⚠️ 場面を伺えているなら**その言葉で言う**（260909 Take） */
        a.lead = scSay
               || 'これからの季節でしたら、入ったばかりのものからお出ししますね。';
      } else {
        if (naG) a.body.push('新しく入ったものに' + naG + 'はございませんでした。');
        /* ⚠️ **入荷の点数を言わない**（260902）。`newArrivals` は在庫0を外すので、
           1点売り切れた翌日に「4点入りました」へ変わる＝**発売した点数として嘘**になる */
        a.lead = naDay ? (naDay + 'に、新しいものが入りました。')
                       : ('新しく入ったものが' + na.length + '点ございます。');
      }
      na.slice(0, 5).forEach(function (p) {
        a.body.push(p.t + '／' + yen(p.p) + '円');
      });
      a.cards = productCards(na.slice(0, 5));
      ctx.shown = na.slice(0, 5).map(function (p) { return p.t; });
      a.acts = pickActs(na, 3)
        .concat([['新着アイテムをぜんぶ見る', 'url', '/collections/' + NEW_COLL]]);
      if (naSeason && weeklyArrivals()) a.note.push('毎週、新しいものが入っています');
      a.sources = ['新着アイテム', '在庫'];
      return a;
    }

    if (intent === 'find') {
      ctx.find_text = text;
      var off = ctx.offset || 0;
      var tags = wantedTags(text);
      /* ⚠️「涼しい**パンツ**」にブラウスを出さない */
      var gar = wantedGarment(text);
      var bud = budgetOf(text);          /* 予算で絞れないと買い物にならない */
      /* ★季節の言い方を、**商品ページの実データ**へ橋渡しする（260902）。
         タグには季節が無いので、袖丈・生地の厚さ・素材で受ける */
      var slv = wantedSleeve(text);
      var thk = wantedThickness(text);
      var mat = wantedMaterial(text);
      var col = findProduct(text) ? '' : namedColor(text);
      var pool = KB.products.filter(sellable);
      if (bud) pool = pool.filter(function (p) { return (p.p || 0) <= bud; });
      var narrowed = pool;
      if (gar) {
        var gws = GARMENT_IN_TITLE[gar];
        narrowed = pool.filter(function (p) {
          return gws.some(function (w) { return titleCore(p).indexOf(w) >= 0; });
        });
      }
      if (slv) narrowed = narrowed.filter(function (p) { return hasSleeve(p, slv); });
      if (thk) narrowed = narrowed.filter(function (p) { return thicknessOf(p) === thk; });
      if (mat) narrowed = narrowed.filter(function (p) { return hasMaterial(p, mat); });
      if (col) {
        narrowed = narrowed.filter(function (p) {
          return colorList(p).some(function (cn) { return cn[0] === col && cn[1] > 0; });
        });
      }
      var hit = tags.length ? narrowed.filter(function (p) {
        return tags.every(function (t) { return p.tags.indexOf(t) >= 0; });
      }) : ((gar || bud || slv || thk || mat || col) ? narrowed : []);
      /* ★聞かれた言葉が名前にあるものを先に（「フリルのブラウス」＝フリルのほうから） */
      hit = byNameFirst(hit, text);
      /* ★同じ当たりの中では、今季のものを先に（260902・Take）。
         ⚠️ 名前の当たりは**動かさない**＝聞かれた言葉に近いほうが先、という並びは守る。
            実測＝「そろそろ長袖がほしいです」で袖丈は正しく10点に絞れているのに、
            先頭3点が夏のシアーだった（並びが在庫順のままだった） */
      var fNew = {}, fOrig = {};
      newArrivals().forEach(function (p) { fNew[p.h] = 1; });
      collItems(ORIG_COLL).forEach(function (p) { fOrig[p.h] = 1; });
      /* ⚠️ 絞りに使った言葉（袖丈・厚さ・素材）は名前の当たりから外す＝二重に効かせない。
         「そろそろ長袖がほしいです」で、袖丈では正しく絞れているのに
         **紹介文に「長袖」と書いてある夏物が先頭に来ていた**（260902） */
      var fUsed = {};
      [SLEEVE_WORDS, THICK_WORDS, MATERIAL_WORDS].forEach(function (tbl) {
        tbl.forEach(function (row) {
          row[1].forEach(function (w) { if (text.indexOf(w) >= 0) fUsed[w] = 1; });
        });
      });
      var fWs = nameWords(text).filter(function (w) { return !fUsed[w]; });
      function named(p) {
        var hay = nameHay(p), n = 0;
        fWs.forEach(function (w) { if (hay.indexOf(w) >= 0) n += w.length; });
        return n;
      }
      hit = hit.map(function (p, i) { return [p, i]; })
        .sort(function (x, y) {
          return (named(y[0]) - named(x[0]))
            || ((fNew[y[0].h] ? 1 : 0) - (fNew[x[0].h] ? 1 : 0))
            || ((fOrig[y[0].h] ? 1 : 0) - (fOrig[x[0].h] ? 1 : 0))
            || (x[1] - y[1]);
        })
        .map(function (x) { return x[0]; });
      var quoted = tags.map(function (t) { return '「' + t + '」'; }).join('と');
      /* ⚠️ タグに品種が入っているときは重ねない（「「羽織り・ジャケット」のジャケット」） */
      var garSay = gar && !tags.some(function (t) { return t.indexOf(gar) >= 0; })
                   ? gar : '';
      var what = quoted + (garSay ? ('の' + garSay) : '');
      if (!tags.length && gar) what = gar;
      /* ★言われた条件を、そのまま名前にして返す（「長袖の」「厚めの」「ウールの」） */
      var said = '';
      [col, mat, thk, slv].forEach(function (x) { if (x) said += x + 'の'; });
      if (said) what = said + (what || 'もの');
      if (bud) what = yen(bud) + '円まで' + (what ? ('の' + what) : 'のもの');
      if (hit.length && off >= hit.length) {
        ctx.offset = hit.length;  /* これ以上は増やさない */
        a = A(GREEN, '商品を探したい（ここまで）');
        a.lead = 'ご紹介できるのは、いまのところここまでです。';
        a.body = [what + 'では、ぜんぶで' + hit.length + '点でした。'];
        a.acts = seeAll.apply(null, tags.concat([gar || '']));
        a.next = [['サイズの選び方', 'サイズはどれがいいですか'],
                  ['別の条件で探す', '別のものを探しています']];
        a.sources = ['商品のタグ', '在庫'];
        return a;
      }
      if (hit.length) {
        a = A(GREEN, '商品を探したい');
        a.lead = off ? '続きは、こちらです。' : (what + 'で' + hit.length + '点ございます。');
        /* **出したものを覚えておく**＝次に「着ているところは？」で聞き返さない */
        ctx.shown = hit.slice(off, off + 3).map(function (p) { return p.t; });
        /* ⚠️ 探しているだけの人に**「残り◯点」は出さない**（260809・Take） */
        hit.slice(off, off + 3).forEach(function (p) {
          a.body.push(p.t + '／' + yen(p.p) + '円');
        });
        a.cards = productCards(hit.slice(off, off + 3));
        /* ★お出しした3点を、その場で選べるようにする。⚠️ここが空だったせいで、
           写真は出ているのに商品が決まらず、サイズも色も聞き返しに落ちていた
           ★条件が1つだけなら、そのコレクションへ */
        a.acts = pickActs(hit.slice(off, off + 3))
          .concat(seeAll.apply(null, tags.concat([gar || ''])));
        a.sources = ['商品のタグ', '在庫'];
        return a;
      }
      if (tags.length || gar || bud || slv || thk || mat || col) {
        /* ★楽天の失敗をしない＝該当なしを言い切って、条件を1つだけ緩める */
        var loose = [];
        if (tags.length && gar) {
          loose = narrowed.filter(function (p) {
            return tags.some(function (t) { return p.tags.indexOf(t) >= 0; });
          });
        } else if (tags.length) {
          loose = pool.filter(function (p) {
            return tags.some(function (t) { return p.tags.indexOf(t) >= 0; });
          });
        }
        /* ★季節の条件（袖丈・厚さ・素材・色）で0点なら、**その1つだけ外して**出す */
        if (!loose.length && said) {
          var back = pool.filter(function (p) {
            var okG = !gar || GARMENT_IN_TITLE[gar].some(function (w) {
              return titleCore(p).indexOf(w) >= 0;
            });
            return okG && (!slv || hasSleeve(p, slv));
          });
          loose = (thk || mat || col) ? back : [];
        }
        a = A(GREEN, '商品を探したい（該当なし）');
        a.lead = what + 'にあてはまるものは、いまございません。';
        var shownHere = [];
        if (loose.length) {
          a.body.push('条件をひとつゆるめると、こちらがございます。');
          loose.slice(0, 3).forEach(function (p) {
            a.body.push(p.t + '／' + yen(p.p) + '円');
          });
          a.cards = productCards(loose.slice(0, 3));
          shownHere = loose.slice(0, 3);
        } else if (tags.length && gar) {
          var other = pool.filter(function (p) {
            return tags.every(function (t) { return p.tags.indexOf(t) >= 0; });
          });
          if (other.length) {
            a.body.push(gar + '以外でしたら、こちらがございます。');
            other.slice(0, 3).forEach(function (p) {
              a.body.push(p.t + '／' + yen(p.p) + '円');
            });
            a.cards = productCards(other.slice(0, 3));
            shownHere = other.slice(0, 3);
          } else {
            a.body.push('いまお取り扱いしているのは全部で' + pool.length + '点です。');
          }
        } else {
          /* ⚠️「よろしければ一覧をご覧ください」と言うだけで、**その一覧への道が
             どこにも無かった**（260809・Take「ワンピはある？で変な応対」） */
          a.body.push('いまお取り扱いしているのは全部で' + pool.length + '点です。');
        }
        /* ★該当なしでも**行き止まりにしない**。⚠️ seeAll を後から代入して、置いた道を
           消していた＝「ワンピはある？」がボタン0個になっていた（260809） */
        if (shownHere.length) ctx.shown = shownHere.map(function (p) { return p.t; });
        a.acts = pickActs(shownHere)
          .concat(seeAll.apply(null, tags.concat([gar || ''])));
        /* ★**「毎週、新しいものが入っています」を添える**（260902・Take決定）。
           9月から12月まで毎週アイテムが足されるので、いま無いだけのものが多い。
           ⚠️ 決め打ちにしない＝**発売タグが2週ぶん以上そろっているときだけ**。
           ⚠️ 入荷の予定日・発売前の品名は言わない（`restock` と同じ線） */
        if (weeklyArrivals()) {
          a.note.push('毎週、新しいものが入っています');
          a.acts = a.acts.concat([['新着アイテムを見る', 'url',
                                   '/collections/' + NEW_COLL]]);
        }
        if (!a.acts.length) {
          a.acts = [['人気のものを見る', 'ask', '人気のものはどれですか'],
                    ['合う一枚を選んで', 'ask', '似合うものを見せてください']];
        }
        a.sources = ['商品のタグ', '在庫'];
        return a;
      }
      /* ★条件が無いなら、タグを並べて選ばせない。**お店と同じに、場面から伺う**（260809） */
      a = A(GREEN, 'どんなときに着るかを伺う');
      a.lead = '承知しました。';
      a.body = ['どんなときにお召しになりたいか、教えていただけますか。',
                'そのうえで、合いそうなものをお出しします。'];
      /* ⚠️ お仕事を入れる（260809・Take「着るシーンで仕事用がないね」） */
      a.acts = [['お出かけに', 'ask', 'お出かけに着たいです'],
                ['お仕事に', 'ask', '仕事に着ていきたいです'],
                ['ふだん着に', 'ask', 'ふだん着に着たいです'],
                ['旅行に', 'ask', '旅行に着たいです']];
      ctx.pending = 'scene';
      a.sources = ['商品のタグ'];
      return a;
    }

    if (intent === 'material' && prod) {
      var mat = specLine(prod.spec, '素材');
      if (mat) {
        a = A(GREEN, '素材が知りたい');
        var made = specLine(prod.spec, '原産国');
        /* 「日本製ですか」＝**産地を聞かれている**。素材の羅列で返さない */
        if (made && /日本製|中国製|原産|生産国|どこで作/.test(text)) {
          a.lead = '原産国は' + made + 'です。';
          a.body.push('素材は' + mat + 'です。');
        } else {
          /* 「綿は何％ですか」＝**入っていないなら、入っていないと言う** */
          var FIB = [['綿', ['綿', 'コットン']], ['麻', ['麻', 'リネン']],
                     ['ウール', ['ウール', '毛']], ['シルク', ['シルク', '絹']],
                     ['ポリエステル', ['ポリエステル']]];
          var miss2 = FIB.filter(function (f) {
            return f[1].some(function (w) { return text.indexOf(w) >= 0; })
                && !f[1].some(function (w) { return mat.indexOf(w) >= 0; });
          }).map(function (f) { return f[0]; });
          if (miss2.length) {
            a.lead = miss2.join('／') + 'は入っていないんです。';
            a.body.push('素材は' + mat + 'です。');
          } else {
            /* ★**手ざわりから話す**（260909）。実測では39点中32点で本文が
               「原産国は中国です。」だった＝店員は原産国から話さない。
               トークがあればその一言を先に、素材の数字はそのあと */
            var mvM = talkOf(prod).material_voice;
            if (mvM) {
              a.lead = String(mvM);
              a.body.push('素材は' + mat + 'です。');
            } else {
              /* ⚠️ 商品名は長い（30字超）。素材と並べると一文が積み上がる */
              a.lead = '素材は' + mat + 'です。';
            }
          }
          /* ⚠️ ★**原産国は聞かれたときだけ**（上の分岐で答えている）。
             毎回添えると、32点で同じ文が出て「テンプレ」に見える */
        }
        /* ⚠️ **記号で並べない**（260902・Take「かたい」）。もとの radar は
           「"透け感｜ややあり｜シロ系のみ","光沢｜なし",…」の形で、そのまま出すと
           ｜が6個並ぶ。2つまで、文にして書く */
        var rmSpec = radarMap(prod);
        if (rmSpec.__keys.length) {
          a.body.push(radarSay(rmSpec, '', 2) + '、という手ざわりです。');
        }
        var care2 = specLine(prod.spec, 'ケア方法');
        /* ⚠️ 手ざわりの一言でお手入れに触れていたら、注記は重ねない（260909） */
        if (care2 && (echoes(a.lead, 'お手入れは' + care2 + 'です')
                      || sharesPhrase(a.lead, 'お手入れは' + care2 + 'です', 4))) {
          care2 = '';
        }
        if (care2) a.note.push('お手入れは' + care2 + 'です');
        a.acts = [productAct(prod, ctx)];
        a.sources = ['商品ページ（仕様）'];
        return a;
      }
    }

    if (intent === 'payment' || intent === 'coupon' || intent === 'login'
        || intent === 'material') {
      var label = {payment: '支払い方法', coupon: 'クーポン',
                   login: 'ログイン・会員登録', material: '素材・お手入れ'}[intent];
      /* ⚠️ **並び順の先頭で選ばない**。「代引きはできますか」に
            「注文後に支払い方法を変更できますか？」の答えを断定していた（260807） */
      a = faqAnswer(text, patternOf(intent), label + 'について');
      if (a) return a;
      a = A(AMBER, label + 'について');
      a.lead = 'お答えできるところまでお伝えしますね。';
      a.body = ['詳しいところは、フォームから担当がご案内します。'];
      a.acts = [['フォームで聞く', 'form', '']];
      a.sources = ['—'];
      return a;
    }

    if (intent === 'points') {
      var ph = KB.faq.filter(function (f) { return f.q.indexOf('ポイント') >= 0; });
      a = A(ph.length ? GREEN : AMBER, 'ポイントについて');
      a.lead = ph.length ? ph[0].a : 'ポイントのお取り扱いは、担当からご案内します。';
      a.sources = ph.length ? ['よくあるご質問「' + ph[0].q + '」'] : ['—'];
      if (!ph.length) a.acts = [['フォームで聞く', 'form', '']];
      return a;
    }

    if (intent === 'order_status') {
      a = A(RED, '注文が通っているか知りたい');
      a.lead = '申し訳ありません。ご注文が通っているかは、この場ではお調べできないんです。';
      a.body = ['どなたのご注文かを確かめられないので、下のフォームに、'
                + 'ご注文のときのお名前とメールアドレスをお書きください。'
                + 'スタッフが確かめてご連絡します。'];
      a.note = ['ご注文が確定していれば、確認メールが届いています。'
                + '迷惑メールのフォルダもご覧になってみてください',
                'ご返信は、通常' + r['フォームの返信'] + 'です'];
      a.acts = [['注文の確認をフォームで頼む', 'form', '']];
      a.sources = ['—（本人確認が要る）'];
      a.prefill = '注文が通っているか確認したいです。';
      return a;
    }

    if (intent === 'defect') {
      a = A(RED, '届いた商品に不具合がある');
      a.lead = '申し訳ありません。すぐにお取り替えいたします。';
      a.body = ['恐れ入りますが、状態がわかるお写真を添えて、'
                + 'メールでお知らせいただけますでしょうか。'];
      a.note = ['不良品・誤配送の場合は、返送の送料は当店が負担いたします'];
      a.acts = [['メールで知らせる', 'mail', 'up_support@halmek.co.jp']];
      a.sources = ['よくあるご質問', 'お買い物ガイド④'];
      return a;
    }

    if (intent === 'other_biz') {
      a = A(RED, 'Up selectのことではない');
      a.lead = 'こちらはUp selectの窓口で、お尋ねの件はお答えできないんです。';
      a.body = ['担当の窓口をご案内しますので、下のフォームからお知らせください。'];
      a.acts = [['フォームで聞く', 'form', '']];
      a.sources = ['—（別の窓口）'];
      return a;
    }

    /* ⚠️ 260807のネガチェック＝**同じ聞き返しが43回続いた**。3回目には壊れて見える。
          分からないままなら、聞き返しを繰り返さずに人へ渡す */
    var miss = (ctx.miss || 0) + 1;
    ctx.miss = miss;
    if (miss >= 3) {
      a = A(RED, 'うまくお答えできない');
      a.lead = 'うまくお聞き取りできず、申し訳ありません。';
      a.body = ['ここから先は、スタッフがお答えしたほうが早そうです。'
                + '下のフォームに、いまお困りのことをそのままお書きください。'];
      a.note = ['ご返信は、通常' + r['フォームの返信'] + 'です'];
      a.acts = [['スタッフに聞く', 'form', '']];
      a.sources = ['—（人がお答えします）'];
      a.prefill = raw.slice(0, 120);
      return a;
    }
    /* ★戻し先を「サイズ・素材・お届け」から**装いの話**へ（260809・Take）。
       事務の窓口の語彙で聞き返すと、買う前の人はそこで止まる */
    a = A(AMBER, 'どのお尋ねか決められない');
    a.lead = 'よろしければ、こんなふうにお手伝いできますよ。';
    a.body = ['どんなときに着るかを伺えば、合いそうなものをお出しします。'];
    a.acts = [['着ていく場面から', 'ask', 'お出かけに着たいです'],
              ['気になるところから', 'ask', '体型が気になります'],
              ['似合う色から', 'ask', 'カラー診断をお願いします']];
    a.next = [['人気のものを見る', '人気のものはどれですか'],
              ['サイズの選び方', 'サイズはどれがいいですか']];
    a.sources = ['—'];
    return a;
  }

  /* 答えたあとに「次に聞けること」を付け、何を答えたかを覚えておく */
  function answer(text, ctx) {
    ctx = ctx || newCtx('');
    /* ★★コレクションの面では、**その面に並んでいるものからお出しする**（260810・Take
       「羽織ジャケットで人気のものを押すと、ジョガーパンツとか関係ないのが出る」）。
       ⚠️ 絞った中に見当たらないときは**黙って店ぜんぶへ広げない**。
       ⚠️ 途中で落ちても KB.products を必ず戻す（戻し忘れると次の面まで絞られる） */
    var coll = null, a, it, widened = false, keep = null;
    try {
      coll = scopeIn(ctx);       /* ⚠️ ctx は触らない。控えはここで取れば足りる */
      if (coll) keep = JSON.parse(JSON.stringify(ctx));
      a = core(text, ctx);
    } finally {
      scopeOut();
    }
    it = ctx._intent || '';
    if (coll && SHOP_LANE.indexOf(it) >= 0 && !a.cards.length) {
      Object.keys(ctx).forEach(function (k) { delete ctx[k]; });
      Object.keys(keep).forEach(function (k) { ctx[k] = keep[k]; });
      a = core(text, ctx);
      it = ctx._intent || '';
      if (a.cards.length) {
        /* ⚠️ 一覧の名前をそのまま文にすると読みにくい。名前は帯（いまの話）に出ている */
        a.lead = 'いまご覧の一覧には見当たりませんでしたので、'
               + 'お店ぜんぶからお探ししますね。' + a.lead;
        widened = true;
      }
    }
    /* ⚠️ 「ありがとう」で話の続きを見失わない */
    if (it && it !== 'unknown') ctx.last = it;
    if (!ctx.asked) ctx.asked = [];
    /* ⚠️ 覚えるのが先。あとにするといま答えた話をもう一度勧める */
    if (it && it !== 'unknown' && a.tier === GREEN && ctx.asked.indexOf(it) < 0) {
      ctx.asked.push(it);
    }
    /* 🟡🔴はすでに聞き返しやフォームを出している。そこに選択肢を足さない */
    if (a.tier === GREEN && !a.next.length) {
      a.next = nextSteps(it, !!ctx.product, ctx.asked, ctx.at || '');
    }
    /* ⚠️ すぐ上のボタンに出ているものを、「つづけて」でもう一度出さない（260809） */
    var labels = a.acts.map(function (x) { return x[0]; });
    a.next = a.next.filter(function (n) { return labels.indexOf(n[0]) < 0; });
    /* ★**何についての答えかを、答えそのものに付ける**（260809・Take） */
    /* ★ガイドに書いてあることを、**チャットの中で厚く出す**（260809・Take
       「決済方法ならどれ使えるか、クーポンなら使い方とか。回答があっさりしすぎ」） */
    if (a.tier === GREEN && (KB.guidePick || {})[it] && a.body.length < 4) {
      var gd = guideDetail(it, 4);
      var have = [a.lead].concat(a.body).join(' ');
      gd[0].forEach(function (x) {
        /* ⚠️ 同じ言い回しを重ねない。**頭と結びの両方**を見る */
        var tail = x.slice(-7, -1);
        if (have.indexOf(x.slice(0, 14)) >= 0) return;
        if (tail.length >= 5 && have.indexOf(tail) >= 0) return;
        a.body.push(x);
        have += ' ' + x;
      });
      if (gd[1].length && !a.figs.length) a.figs = gd[1];
    }
    if (ABOUT_INTENTS.indexOf(it) >= 0) {
      var pa = byHandle(ctx.product || '') || byHandle(ctx.page || '');
      if (pa && !a.cards.length) {
        a.about = {t: pa.t.replace(/【.*?】/g, '').trim(),
                   img: pa.img || '', h: pa.h};
      }
      /* ★サイズと色が**両方決まっているときだけ**、カートへの一歩を先頭に出す。
         ⚠️ ★**伺っている最中は足さない**（260909）。カラー診断の2問目・3問目は
            「色を選ぶ」問いなので、そこへサイズの丸を混ぜるとどれを押せばよいのか
            分からなくなる（実測＝M／L／LL が色の丸に混ざった） */
      var asking = ['cdx1', 'cdx2', 'cdx3', 'part', 'scene', 'worry']
        .indexOf(ctx.pending) >= 0;
      var hasCart = a.acts.some(function (x) { return x[1] === 'cart'; });
      if (!asking && pa && a.tier === GREEN && !hasCart) {
        var ca = cartAct(pa, ctx);
        if (ca.length) {
          a.acts = ca.concat(a.acts);
        } else if (isSet(pa)) {
          /* ⚠️ セットは2枚お選びいただく＝**その場では入れられない**と言い切る */
          /* ⚠️ 「こちらは」で始めない（260902）。サイズの答えが「こちらは、標準的な
         つくりです。」で始まるので、同じ吹き出しに2回並ぶ */
      var sayS = '2枚お選びいただくセットです。';
          if (a.note.indexOf(sayS) < 0) a.note.push(sayS + '商品ページでお選びください');
        } else {
          /* ★あと一歩で決まるなら、**その場で決められるようにする**（260809・Take
             「サイズと色を選ぶまではいくけど、カートに入れる挙動は確認できんね」） */
          /* ⚠️ **もう伺ったほうの丸は消す**。残すとサイズの下に色が並んで、
             どちらを選ぶのか分からなくなる（260809・Take「ワッシャーで…」） */
          /* ★順番を決めつけない（260809・Take「色→サイズもある」）＝色の話をしている
             なら、サイズを伺う前でも色の丸を出す。足りないもう片方は1つだけ添える */
          var me2 = ctx.me || {};
          var sz = storeSizes();
          var cn = colorList(pa).map(function (x) { return x[0]; });
          var colChips = colorList(pa).filter(function (x) { return x[1] > 0; })
            .slice(0, 4).map(function (x) { return [x[0], 'ask', x[0] + 'はありますか']; });
          /* ★色が決まっていて**サイズだけ残っている**なら②【選ぶ】場面。
             店の共通ではなく**その商品の表記**を出す（260810・Take） */
          var sizeChips = offerActs(pa);
          if (!sizeChips.length) {
            sizeChips = sz.map(function (s) {
              return [s, 'ask', 'いつも' + s + 'サイズです'];
            });
          }
          sz = sz.concat(sizeChips.map(function (x) { return x[0]; }));
          var noBoth = function (x) {
            return sz.indexOf(x[0]) < 0 && cn.indexOf(x[0]) < 0;
          };
          /* ★丈（股下）が残っているなら、**それを先に伺う**（260810・`all_sim`） */
          var lv = lengthList(pa).filter(function (x) { return x[1] > 0; })
                                 .map(function (x) { return x[0]; });
          if (me2.size && (me2.color || cn.length === 1)
              && lv.length > 1 && !me2.length) {
            /* ★丈も**並べてからお選びいただく**（260810・talk_sim） */
            var labL = me2.picked_size || saidSizeLabel(pa, me2.size);
            var lineL = 'お選びいただいた' + labL + 'ですと、' + lv.join('／')
                      + 'からお選びいただけます。';
            var hasL = a.body.some(function (b) {
              return b.indexOf('からお選びいただけます。') >= 0;
            });
            if (!hasL) a.body.push(lineL);
            a.acts = lv.map(function (x) { return [x, 'ask', x + 'がいいです']; })
              .concat(a.acts.filter(function (y) { return lv.indexOf(y[0]) < 0; }));
          } else if (it === 'color' && !me2.color && cn.length > 1) {
            a.acts = colChips.concat(a.acts.filter(function (x) {
              return cn.indexOf(x[0]) < 0;
            }));
            if (!me2.size) {
              a.acts = a.acts.concat([['サイズを選ぶ', 'ask', 'サイズはどれがいいですか']]);
            }
          } else if (me2.size && !me2.color) {
            /* ★★橋渡しを一言はさむ（260810・Take「『大丈夫ですよ』と言って選択肢が
               カラーになるので、**お選び頂いたサイズではこのカラーがございます**とかを
               応答文に挟む必要があるのでは」）。色は**そのサイズで買えるものだけ** */
            var cinC = colorsInSize(pa, me2.size, me2.length || '');
            if (cinC.length) {
              colChips = cinC.slice(0, 4).map(function (c) {
                return [c, 'ask', c + 'はありますか'];
              });
              var labC = me2.picked_size || saidSizeLabel(pa, me2.size);
              var lineC = 'お選びいただいた' + labC + 'ですと、' + cinC.join('／')
                        + 'がございます。';
              var hasC = a.body.some(function (b) {
                return b.indexOf('がございます。') >= 0;
              });
              if (!hasC) a.body.push(lineC);
            }
            a.acts = colChips.concat(a.acts.filter(noBoth));
          } else if (me2.color && !me2.size) {
            a.acts = sizeChips.concat(a.acts.filter(noBoth));
          }
        }
      }
    }
    /* ★★同じ聞き返しを二度続けない（260809・wild_sim）。
       ⚠️ 一言一句同じ聞き返しを返すのはお店ではやらない。二度目は言い方を変えて人へ */
    if (a.tier === AMBER) {
      if (ctx._amber === a.intent) {
        a.lead = 'うまくお伺いできず、失礼しました。' + a.lead;
        if (!a.acts.some(function (x) { return x[1] === 'form'; })) {
          a.acts = a.acts.concat([['スタッフに聞く', 'form', '']]);
        }
      }
      ctx._amber = a.intent;
    } else {
      ctx._amber = '';
    }

    /* ★★材料が揃っているなら、話が横に逸れても**買う一歩を残す**（260809・slot_sim）。
       ⚠️ サイズ→色と決めたあとに場面の話をすると、カートのボタンが消えていた */
    /* ⚠️ 🟢だけに限ると「印が付いていない」の🟡で消える。🔴のときだけ出さない */
    if (a.tier !== RED && ctx.at !== 'cart'
        && !a.acts.some(function (x) { return x[1] === 'cart'; })) {
      var here = byHandle(ctx.page || '');
      if (here) {
        var ca2 = cartAct(here, ctx);
        if (ca2.length) a.acts = a.acts.concat(ca2);
      }
    }
    /* ★カートの面では、**決済へ進む後押しを優先する**（260809・Take）。
       ⚠️ ただし**カートに入っていない商品の話のときは送らない** */
    if (ctx.at === 'cart' && a.tier === GREEN) {
      /* ⚠️ カートからガイドへ飛ばさない＝そのまま離脱する */
      a.acts = a.acts.filter(function (x) {
        return String(x[2]).indexOf('/pages/shopping-guide') !== 0;
      });
      var ease = 'お届けから' + KB.rules['返品できる期日'] + 'でしたら、返品も承ります';
      var hasRet = a.note.some(function (n) { return n.indexOf('返品') >= 0; });
      if (!hasRet && a.lead.indexOf('返品') < 0) a.note.push(ease);
      var shopping = !!a.cards.length || ABOUT_INTENTS.indexOf(it) >= 0
                     || ['find', 'popular', 'restart'].indexOf(it) >= 0;
      var hasCo = a.acts.some(function (x) { return x[2] === '/checkout'; });
      if (!shopping && !hasCo) {
        a.acts = [['レジへ進む', 'url', '/checkout']].concat(a.acts);
      }
    }
    /* ⚠️ **探しものへ戻すボタンを、カートでは出さない**（🟡🔴のときも消す） */
    if (ctx.at === 'cart') {
      a.acts = a.acts.filter(function (x) {
        return !(x[1] === 'ask' && SHOP_LANE.indexOf(detect(x[2])) >= 0);
      });
      a.next = a.next.filter(function (n) {
        return SHOP_LANE.indexOf(detect(n[1])) < 0;
      });
    }
    /* ★コレクションの面でのしまつ（260810。route.py の同じ場所と対） */
    if (coll) {
      /* ⚠️ **いま見ている一覧へ「ぜんぶ見る」を出さない**＝押しても同じ面に戻るだけ */
      var hereUrl = '/collections/' + coll.h;
      a.acts = a.acts.filter(function (x) { return String(x[2]) !== hereUrl; });
      a.next = a.next.filter(function (n) { return String(n[1]) !== hereUrl; });
      /* ★どこから選んだのかを、その場に書いておく（探しに行かせない）。
         ⚠️ 店ぜんぶへ広げたときは書かない＝1行目と言うことが食い違う */
      var told = a.note.some(function (n) { return n.indexOf(coll.t) >= 0; });
      if (a.cards.length && !widened && !told) {
        a.note.push('いまご覧の「' + coll.t + '」の中からお出ししています');
      }
    }
    /* ★どの面でも**行き止まりを作らない**（押すものが1つも無い答えを出さない） */
    if (a.tier !== RED && !a.acts.length && !a.next.length) {
      a.next = nextSteps(it, !!ctx.product, ctx.asked, ctx.at || '');
    }
    return dontAskWhichTwice(a, ctx);
  }

  /* 「どの商品でしょうか」を続けて言わない（260808のネガチェック）。
     ⚠️ 260807の関所は**同じ用件のときだけ**効くので、
        「着ているところ→サイズ表→何色」のように用件が変わると素通りし、
        3回続けて同じ聞き返しをしていた。route.py と同じ中身。 */
  function dontAskWhichTwice(a, ctx) {
    if (String(ctx.pending || '').indexOf('product') !== 0) {
      ctx.which = 0;
      return a;
    }
    var n = (ctx.which || 0) + 1;
    ctx.which = n;
    if (n === 1) return a;
    var names = a.acts.filter(function (x) { return x[1] === 'ask'; });
    if (n === 2 && names.length) {
      a.lead = '先ほどの' + names.length + '点でしたら、こちらからお選びいただけます。';
      a.body = [];
      return a;
    }
    /* ⚠️ さっき出した候補のボタンは残す（消すと選ぶ手段まで無くなる） */
    a.lead = 'うまくお伝えできず、申し訳ありません。';
    a.body = ['下から選んでいただくか、一覧からお探しいただけます。'];
    a.acts = names.slice(0, 3).concat([['合う一枚を選んで', 'ask', '似合うものを見せてください'],
                                       ['スタッフに聞く', 'form', '']]);
    return a;
  }

  function formUrl(a) {
    if (!a.prefill) return KB.form;
    return KB.form + '?upc=' + encodeURIComponent(a.prefill);
  }

  /* ── 送る前に、個人が特定できるものだけを落とす ──────────────────
     ⚠️ 表は upc-kb.js に焼き込んだもの（正本は log.MASK_RULES）。手で写さない。
     ⚠️ **身長・ウエストは残す**＝品ぞろえの材料そのもの。誰のものかは送らない。
     両方が同じ結果になることは scrub_check.py が毎回確かめる。 */
  var BY_WORD = {'名乗り': 1, '申します': 1, '様づけ': 1};

  function scrub(text) {
    var rules = KB.masks || [], keep = KB.keepWords || [], out = String(text);
    for (var i = 0; i < rules.length; i++) {
      var name = rules[i][0], re = new RegExp(rules[i][1], 'g'), rep = rules[i][2];
      if (BY_WORD[name]) {
        out = out.replace(re, function (all, who) {
          for (var k = 0; k < keep.length; k++) {
            var w = keep[k];
            /* ⚠️ lastIndexOf は見つからないと -1。長さを先に見ないと
               「2文字の語 vs 3文字の見出し」で -1 === -1 になって素通りする
               （260808に scrub_check が捕まえた） */
            if (who.indexOf(w) === 0) return all;
            if (w.length <= who.length && who.slice(who.length - w.length) === w) return all;
          }
          return all.replace(who, '＜お名前＞');
        });
      } else {
        out = out.replace(re, rep);
      }
    }
    return out;
  }

  /* ★画面側は、**絞れる面かどうかをここで訊く**（260810）。
     ⚠️ 帯に「いまの話：◯◯」と出しておきながら答えが店ぜんぶ、では食い違う。
        名前を出してよい面＝実際に絞れる面、と1か所で決める */
  function collInfo(h) {
    var c = collByHandle(h);
    if (!c) return null;
    var inside = {};
    (c.p || []).forEach(function (x) { inside[x] = 1; });
    var n = ALL_PRODUCTS.filter(function (p) { return inside[p.h]; }).length;
    return n >= 2 ? {h: c.h, t: c.t, n: n} : null;
  }

  window.UPC = {answer: answer, detect: detect, findProduct: findProduct,
                newCtx: newCtx, nextSteps: nextSteps, scrub: scrub,
                formUrl: formUrl, collInfo: collInfo, KB: KB};
})();
